// import "react-datetime-picker/dist/DateTimePicker.css";

// import * as faIcons from "@fortawesome/pro-light-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import React, { useEffect, useMemo, useState } from "react";
// import { Form, Stack } from "react-bootstrap";
// import ReactQuill from "react-quill";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
// import { Tooltip as ReactTooltip } from "react-tooltip";
// import styled, { css } from "styled-components";

// import Badge from "src/components/Badge";
// import { SelectBoxContainer } from "src/components/Dropdown/styles";
// import LoadingContainer from "src/components/LoadingContainer";
// import PhotoUpload from "src/components/PhotoUpload";
// import { OptionItem } from "src/components/SelectSearch";
// import { useIsMobile } from "src/hooks/useIsMobile";
// import { Attachments } from "src/pages/TicketForm/Attachments";
// import ClientApprovalWindow from "src/pages/TicketForm/ClientApproval";
// import { getUserData } from "src/redux/selectors/user";
// import { FirebaseDataService } from "src/services/Firebase/data";
// import { ContentFrame, colors } from "src/styles";
// import { MaximoDocument, PriorityLevel, WorkOrder, WorkType, Worklog } from "src/types";
// import { parseDateToFormat } from "src/utils/time";

// import Button from "src/components/Button";
// import BackButton from "src/components/Button/BackButton";
// import {
//   ActiveEmployee,
//   ActiveVendor,
//   AssignWOResourceFormValues,
// } from "src/components/molecules/AssignWOResource/types";
// import { ShareFormValues } from "src/components/molecules/ShareForm/types";
// import AssignWOResourceModal from "src/components/organisms/AssignWOResourseModal";
// import ShareFormModal from "src/components/organisms/ShareFormModal";

// import { setPageNameHeader } from "src/redux/actions/header";
// import { roundTo2Decimals } from "src/utils/helpers";
// import { CustomWorkRequestField } from "../CreateForm/types";
// import DetailsSection, { CommentRegEx } from "../DetailsSection";
// import StatusSelect from "../StatusSelect";
// import { ClientApprovalStatuses, FormData, MobileProps, TicketFormProps } from "../types";
// import { CustomWorkRequestFieldsViewForm } from "./components/CustomWorkRequestFieldsViewForm";
// import ResourseAssigned from "src/components/molecules/TicketsContainer/components/ResourseAssigned";
// import CreateFormTabs from "../CreateForm/components/CreateFormTabs";
// import { objToArray } from "src/utils/objToArray";
// import { ErrorPage } from "src/pages/ErrorPage";
// import Header from "src/components/Header";

// export const ViewForm = ({ isNoAuthWorkRequest }: TicketFormProps) => {
//   const navigate = useNavigate();
//   const location: any = useLocation();
//   const { isMobile } = useIsMobile();
//   const { id } = useParams();
//   const dispatch = useDispatch();

//   const { id: clientUserId, isManager, firstName, lastName, email } = useSelector(getUserData);

//   const defaultServiceType = location?.state?.serviceType;
//   const [workTypes, setWorkTypes] = useState<WorkType[]>([]);
//   const [error, setError] = useState("");
//   const [workOrder, setWorkOrder] = useState<WorkOrder>();
//   const [isFormLoading, setIsFormLoading] = useState(false);
//   const [worklog, setWorklog] = useState<Worklog[]>([]);
//   const [commentsSectionWorklog, setCommentsSectionWorklog] = useState<Worklog[]>([]);
//   const [formData, setFormData] = useState<FormData>({
//     ticketName: "",
//     description: "",
//     serviceType: defaultServiceType?.description || "",
//     classification: "",
//     priorityName: "",
//     priority: 0,
//     workType: "",
//     location: "",
//     targetStart: new Date(),
//     targetFinish: new Date(),
//   });
//   const [clientPhotos, setClientPhotos] = useState<string[]>([]);
//   const [technicianPhotos, setTechnicianPhotos] = useState<string[]>([]);
//   const [files, setFiles] = useState<File[]>([]);
//   const [statusList, setStatusList] = useState<OptionItem[]>([]);
//   const [timezone, setTimezone] = useState("");
//   const [priorityLevel, setPriorityLevel] = useState<PriorityLevel>();
//   const [documents, setDocuments] = useState<MaximoDocument[]>();
//   const [hints, setHints] = useState({ serviceType: "", classification: "" });
//   const [addCommentSuccess, setAddCommentSuccess] = useState<boolean>(false);

//   const fullWorkType = workTypes?.find((type: WorkType) => type.type === workOrder?.worktype);
//   const description = (workOrder?.description_longdescription || "").replace(CommentRegEx, "");
//   const addressId = workOrder?.locationData?.label ? workOrder?.locationData?.label : workOrder?.locationData?.address;
//   const [clientApprovalStatuses, setClientApprovalStatuses] = useState<ClientApprovalStatuses>();
//   const [customWorkRequestFields, setCustomWorkRequestFields] = useState<CustomWorkRequestField[]>();
//   const [isShareWorkRequestModalVisible, setIsShareWorkRequestModalVisible] = useState<boolean>(false);
//   const [shareFormError, setShareFormError] = useState("");
//   const [employees, setEmployees] = useState<ActiveEmployee[]>([]);
//   const [vendors, setVendors] = useState<ActiveVendor[]>([]);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [assignResourceErrorOnSubmit, setAssignResourceErrorOnSubmit] = useState("");
//   const [noAuthActiveWorkOrder, setNoAuthActiveWorkOrder] = useState<boolean>(false);
//   const [noAuthDeletedWorkOrder, setNoAuthDeletedWorkOrder] = useState<boolean>(false);

//   const [activeTab, setActiveTab] = useState<string>("1");
//   const [searchParams] = useSearchParams();

//   const trackingId = searchParams.get("trackingId");

//   const tabs = [
//     { eventKey: "1", label: "Work Details" },
//     { eventKey: "2", label: "Requestor Details" },
//     { eventKey: "3", label: "Service Details" },
//   ];

//   const getClientApprovalStatuses = async () => {
//     try {
//       const { success, data } = await FirebaseDataService.getClientApproveStatuses();
//       if (success) setClientApprovalStatuses(data);
//     } catch (error) {
//       // this error is ignored because Work Requests should work fine even when approve statuses is absent at the DB
//     }
//   };

//   const parsedCreatedDate = useMemo(
//     () => parseDateToFormat(workOrder?.reportdate as string, "MMMM Do YYYY, h:mm A"),
//     [workOrder],
//   );

//   const fetchWorkRequestData = async () => {
//     const workRequests = await FirebaseDataService.getTrackWorkOrders();
//     const workRequestArray = objToArray(workRequests.data, (item, id) => ({
//       ...item,
//       id,
//     }));

//     const filteredWorkRequests = workRequestArray.filter((workRequest) => workRequest.trackingId === trackingId);

//     if (filteredWorkRequests.length !== 0 && filteredWorkRequests[0].status !== "CLOSE") {
//       fetchNoAuthWorkRequestData(filteredWorkRequests[0]);
//     } else if (filteredWorkRequests.length !== 0 && filteredWorkRequests[0].status === "CLOSE") {
//       setNoAuthActiveWorkOrder(true);
//       await FirebaseDataService.deleteClosedTrackingIdFromDB(filteredWorkRequests[0].id);
//     } else {
//       setNoAuthDeletedWorkOrder(true);
//     }
//   };

//   const fetchNoAuthWorkRequestData = async (filteredWorkRequests: any) => {
//     setIsFormLoading(true);

//     const { wonum } = filteredWorkRequests;

//     const { data: viewTicketData } = await FirebaseDataService.getDataForTicketViewForm(
//       wonum as string,
//       "MANAGER",
//       true,
//     );

//     //at the moment, when clicking on a row in the manager portal, this redirect works, since we receive empty data
//     if (!viewTicketData) {
//       setNoAuthDeletedWorkOrder(true);
//     }

//     if (viewTicketData?.locationTimezone) {
//       setTimezone(viewTicketData.locationTimezone);
//     }

//     const clientPhotos = viewTicketData?.attachments.clientPhotos.map((photo) => {
//       const query = [
//         `workorderid=${String(viewTicketData?.workOrder?.workorderid)}`,
//         `attachmentId=${photo.attachmentId}`,
//         `fileName=${encodeURI(photo.fileName)}`,
//       ].join("&");
//       return `${process.env.REACT_APP_FIREBASE_BASE_URL}/clientPortal-getMaximoAttachment?${query}`;
//     });

//     const technicianPhotos = viewTicketData?.attachments.technicianPhotos.map((photo) => {
//       const query = [
//         `workorderid=${String(viewTicketData?.workOrder?.workorderid)}`,
//         `attachmentId=${photo.attachmentId}`,
//         `fileName=${encodeURI(photo.fileName)}`,
//       ].join("&");
//       return `${process.env.REACT_APP_FIREBASE_BASE_URL}/clientPortal-getMaximoAttachment?${query}`;
//     });

//     await getClientApprovalStatuses();

//     setWorkOrder(viewTicketData?.workOrder);
//     setWorkTypes(viewTicketData?.workTypes);
//     setClientPhotos(clientPhotos);
//     setTechnicianPhotos(technicianPhotos);
//     setWorklog(viewTicketData?.technicianNotesWorklog);
//     setCommentsSectionWorklog(viewTicketData?.commentsSectionWorklog);
//     setPriorityLevel(viewTicketData?.priorityLevel);
//     setDocuments(viewTicketData?.attachments.documents);

//     setStatusList(viewTicketData?.statusList);
//     setCustomWorkRequestFields(viewTicketData?.customWorkRequestFields);

//     setEmployees(viewTicketData.employees);
//     setVendors(viewTicketData.vendors);
//     setIsFormLoading(false);
//   };

//   useEffect(() => {
//     if (isNoAuthWorkRequest) {
//       fetchWorkRequestData();
//     }
//   }, [isNoAuthWorkRequest]);

//   const setServiceType = () => {
//     let serviceType = workOrder?.classstructure?.[0].classstructure?.[0].description;
//     let classification = workOrder?.classstructure?.[0]?.description;
//     const serviceTypeHint = workOrder?.classstructure?.[0].classstructure?.[0].classificationdesc_longdescription;
//     const classificationHint = workOrder?.classstructure?.[0]?.classificationdesc_longdescription;

//     if (workOrder?.classstructure && !workOrder.classstructure[0].classstructure) {
//       serviceType = workOrder?.classstructure?.[0]?.description;
//       classification = "";
//     }

//     setFormData((data) => ({
//       ...data,
//       serviceType: serviceType as string,
//       classification: classification as string,
//     }));

//     setHints({
//       serviceType: serviceTypeHint as string,
//       classification: classificationHint as string,
//     });
//   };

//   const fetchData = async () => {
//     setIsFormLoading(true);

//     const { data: viewTicketData } = await FirebaseDataService.getDataForTicketViewForm(
//       id as string,
//       clientUserId,
//       isManager,
//     );
//     //at the moment, when clicking on a row in the manager portal, this redirect works, since we receive empty data
//     if (!viewTicketData) {
//       navigate("/workrequests");
//     }

//     if (viewTicketData?.locationTimezone) {
//       setTimezone(viewTicketData.locationTimezone);
//     }

//     const clientPhotos = viewTicketData?.attachments.clientPhotos.map((photo) => {
//       const query = [
//         `workorderid=${String(viewTicketData?.workOrder?.workorderid)}`,
//         `attachmentId=${photo.attachmentId}`,
//         `fileName=${encodeURI(photo.fileName)}`,
//       ].join("&");
//       return `${process.env.REACT_APP_FIREBASE_BASE_URL}/clientPortal-getMaximoAttachment?${query}`;
//     });

//     const technicianPhotos = viewTicketData?.attachments.technicianPhotos.map((photo) => {
//       const query = [
//         `workorderid=${String(viewTicketData?.workOrder?.workorderid)}`,
//         `attachmentId=${photo.attachmentId}`,
//         `fileName=${encodeURI(photo.fileName)}`,
//       ].join("&");
//       return `${process.env.REACT_APP_FIREBASE_BASE_URL}/clientPortal-getMaximoAttachment?${query}`;
//     });

//     await getClientApprovalStatuses();

//     setWorkOrder(viewTicketData?.workOrder);
//     setWorkTypes(viewTicketData?.workTypes);
//     setClientPhotos(clientPhotos);
//     setTechnicianPhotos(technicianPhotos);
//     setWorklog(viewTicketData?.technicianNotesWorklog);
//     setCommentsSectionWorklog(viewTicketData?.commentsSectionWorklog);
//     setPriorityLevel(viewTicketData?.priorityLevel);
//     setDocuments(viewTicketData?.attachments.documents);

//     setStatusList(viewTicketData?.statusList);
//     setCustomWorkRequestFields(viewTicketData?.customWorkRequestFields);

//     setEmployees(viewTicketData.employees);
//     setVendors(viewTicketData.vendors);
//     setIsFormLoading(false);
//   };

//   const onExitClick = () => {
//     if (location?.state?.ticketNumber) {
//       navigate(-1);
//     } else {
//       navigate("/workrequests");
//     }
//   };

//   useEffect(() => {
//     if (!isNoAuthWorkRequest) {
//       fetchData();
//     }
//   }, [id]);

//   useEffect(() => {
//     setServiceType();
//   }, [workOrder]);

//   useEffect(() => {
//     dispatch(setPageNameHeader("Work Request Details"));
//     return () => {
//       dispatch(setPageNameHeader(""));
//     };
//   }, []);
//   const shareWorkRequest = async (value: ShareFormValues) => {
//     try {
//       if (workOrder) {
//         await FirebaseDataService.shareWorkRequest(
//           value.emailTo,
//           value.emailMessage,
//           workOrder?.workorderid,
//           `${firstName} ${lastName}`,
//           workOrder.wonum,
//           email ?? "",
//         );
//         setIsShareWorkRequestModalVisible(false);
//       }
//     } catch (err) {
//       setShareFormError(err.message);
//     }
//   };
//   const onSubmitAssignResourceHandler = async (data: AssignWOResourceFormValues) => {
//     if (workOrder) {
//       setAssignResourceErrorOnSubmit("");
//       const res = await FirebaseDataService.assignResourceInWorkOrder({
//         wonum: workOrder.wonum,
//         approvedamount: data.vendors.approvedamount,
//         vendorId: data.vendors.vendorId,
//         woacceptscharges: data.vendors.woacceptscharges,
//         laborCode: data.employees.laborCode,
//         managerId: clientUserId,
//       });

//       if (res && res.status === "error") {
//         setAssignResourceErrorOnSubmit(res.message);
//       } else {
//         await fetchData();
//         setIsModalVisible(false);
//       }
//     }
//   };
//   const getApprovedAmount = (workOrder: WorkOrder) => {
//     if (workOrder.woacceptscharges) {
//       const service = workOrder.wpservice?.find((service) => service.vendor);
//       return service?.linecost ? `$ ${roundTo2Decimals(service.linecost)}` : "Post-completion";
//     } else {
//       return "Non-billable";
//     }
//   };
//   if (noAuthActiveWorkOrder) {
//     return <ErrorPage subtitle="Work Request Closed" />;
//   }

//   if (noAuthDeletedWorkOrder) {
//     return <ErrorPage subtitle="Work Request Not Found or Closed" />;
//   }

//   const requestQuotationHandler = () => {
//     navigate(`/workrequests/${workOrder?.wonum}/request-quotation`);
//   };

//   return (
//     <LoadingContainer isLoading={isFormLoading}>
//       {isModalVisible && workOrder && (
//         <AssignWOResourceModal
//           closeModal={() => {
//             setAssignResourceErrorOnSubmit("");
//             setIsModalVisible(false);
//           }}
//           errorMsg={assignResourceErrorOnSubmit}
//           onSubmit={onSubmitAssignResourceHandler}
//           employees={employees}
//           vendors={vendors.filter(
//             (vendor) => vendor.clients && vendor.clients.includes(workOrder?.pluspcustomer?.customer ?? ""),
//           )}
//           defaultValues={{
//             employees: {
//               laborCode: workOrder?.wplabor?.find((labor) => labor.laborcode)?.laborcode,
//             },
//             vendors: {
//               woacceptscharges: workOrder?.woacceptscharges ?? false,
//               approvedamount: workOrder?.wpservice?.find((service) => service.vendor)?.linecost,
//               vendorId: workOrder?.wpservice?.find((service) => service.vendor)?.vendor,
//             },
//             // commented out temporarily to hide the Employees tab. Will be reverted in the future
//             activetab: workOrder?.wpservice?.find((service) => service.vendor)?.vendor ? "vendors" : "employees",
//             // activetab: "vendors",
//           }}
//         />
//       )}
//       <Container>
//         {isNoAuthWorkRequest ? <Header name={"Work Request Tracking"} logo={""} noLink noUserLoginPage /> : null}
//         <Content>
//           <Stack
//             direction="horizontal"
//             className="align-items-center justify-content-between"
//             style={{ marginBottom: 30 }}
//           >
//             {!isNoAuthWorkRequest ? <BackButton backHandler={onExitClick} /> : <EmptyContainer />}
//             <Stack direction="horizontal" gap={3}>
//               {isManager && (
//                 <Button
//                   text="Request for Quotation"
//                   variant="white"
//                   additionalStyles={{ display: "flex" }}
//                   icon={faIcons.faShare as any}
//                   onClick={requestQuotationHandler}
//                 />
//               )}
//               <Button
//                 text="Share"
//                 variant="white"
//                 additionalStyles={{ display: "flex" }}
//                 icon={faIcons.faShare as any}
//                 onClick={() => {
//                   setIsShareWorkRequestModalVisible(true);
//                 }}
//               />
//             </Stack>
//           </Stack>
//           <ContentFrame>
//             {isShareWorkRequestModalVisible && (
//               <ShareFormModal
//                 closeModal={() => {
//                   setIsShareWorkRequestModalVisible(false);
//                 }}
//                 error={shareFormError}
//                 onSubmit={shareWorkRequest}
//               />
//             )}
//             {workOrder &&
//               clientApprovalStatuses &&
//               workOrder.status === clientApprovalStatuses.approvalRequired.abbreviation && (
//                 <ClientApprovalWindow
//                   workOrder={workOrder}
//                   documents={documents}
//                   setError={setError}
//                   clientApprovalStatuses={clientApprovalStatuses}
//                   setWorkOrder={setWorkOrder}
//                   setAddCommentSuccess={setAddCommentSuccess}
//                 />
//               )}
//             {!isNoAuthWorkRequest ? (
//               <CreateFormTabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
//             ) : null}
//             <StyledForm>
//               {activeTab === "1" && (
//                 <>
//                   <InputsContainer $isMobile={isMobile}>
//                     <InputsRow>
//                       <InputRow $isMobile={isMobile} ismanager={isManager ? 1 : 0}>
//                         <label>Work Request Name:</label>
//                         <RawValue>
//                           {workOrder?.wonum}: {workOrder?.description}
//                         </RawValue>
//                       </InputRow>
//                       {!isManager && (
//                         <InputRow>
//                           <label>Location: </label>
//                           <RawValue>{addressId || "N/A"}</RawValue>
//                         </InputRow>
//                       )}
//                     </InputsRow>
//                     {workOrder?.parentOrder && (
//                       <InputRow $isMobile={isMobile} ismanager={1}>
//                         <label>Parent Work Request:</label>
//                         <div>
//                           <a href={`/workrequests/${workOrder.parentOrder.wonum}`}>
//                             {workOrder.parentOrder.wonum}: {workOrder.parentOrder.description}
//                           </a>
//                         </div>
//                       </InputRow>
//                     )}
//                     {workOrder?.wochildren && workOrder?.wochildren.length && (
//                       <InputRow $isMobile={isMobile} $topLabel>
//                         <label>Child Work Requests:</label>
//                         <div>
//                           {workOrder?.wochildren.map((child: WorkOrder) => (
//                             <ChildWorkRequestRow key={child.displaywonum}>
//                               <a href={`/workrequests/${child.displaywonum}`}>
//                                 {child.displaywonum}: {child.description}
//                               </a>
//                             </ChildWorkRequestRow>
//                           ))}
//                         </div>
//                       </InputRow>
//                     )}
//                     {isManager && (
//                       <InputsRow>
//                         <InputRow>
//                           <label>Client:</label>
//                           <RawValue>{workOrder?.pluspcustomer?.name}</RawValue>
//                         </InputRow>
//                         <InputRow>
//                           <label>Location: </label>
//                           <RawValue>{addressId || "N/A"}</RawValue>
//                         </InputRow>
//                       </InputsRow>
//                     )}
//                     <InputsRow>
//                       <InputRow $isMobile={isMobile}>
//                         <label>Creation Time:</label>
//                         <RawValue>{parsedCreatedDate}</RawValue>
//                       </InputRow>
//                       <InputRow $isMobile={isMobile}>
//                         <label>Status:</label>
//                         {isManager && workOrder ? (
//                           <StatusSelect workOrder={workOrder} statusList={statusList} />
//                         ) : (
//                           <Badge status={workOrder?.status_description as string} />
//                         )}
//                       </InputRow>
//                     </InputsRow>

//                     <InputsRow>
//                       <InputRow $isMobile={isMobile}>
//                         <label>Service Type:</label>
//                         <RawValue>{formData.serviceType || "N/A"}</RawValue>

//                         <HintIcon
//                           style={{
//                             visibility: defaultServiceType?.longDescription || hints.serviceType ? "visible" : "hidden",
//                           }}
//                           title="Edit Mode"
//                           data-tip={
//                             defaultServiceType?.longDescription || hints.serviceType
//                               ? (defaultServiceType?.longDescription || hints.serviceType).replace(/<br ?\/?>/g, "\n")
//                               : ""
//                           }
//                           icon={(faIcons as any)["faQuestionCircle"]}
//                         />
//                       </InputRow>

//                       <InputRow>
//                         <label>Classification:</label>
//                         <RawValue>{formData.classification || "N/A"} </RawValue>

//                         <HintIcon
//                           style={{
//                             visibility: hints.classification ? "visible" : "hidden",
//                           }}
//                           data-tip={`<div style="overflow: hidden">${(hints.classification || "").replace(
//                             /<br ?\/?>/g,
//                             "\n",
//                           )}</div>`}
//                           icon={(faIcons as any)["faQuestionCircle"]}
//                         />
//                       </InputRow>

//                       <ReactTooltip className="tooltip" />
//                     </InputsRow>

//                     <InputsRow>
//                       <InputRow>
//                         <label>Work Type:</label>
//                         <RawValue>{(fullWorkType && fullWorkType["name"]) || "N/A"} </RawValue>
//                       </InputRow>

//                       <InputRow>
//                         <label>Priority Level:</label>
//                         <RawValue color={priorityLevel ? priorityLevel.color : colors.grey.default}>
//                           {workOrder?.wopriority_description || "N/A"}
//                         </RawValue>
//                       </InputRow>
//                     </InputsRow>
//                   </InputsContainer>

//                   {isManager && workOrder && (
//                     <InputsContainer>
//                       <InputsRow>
//                         <InputRow $isMobile={isMobile}>
//                           <label>Visible to Client? :</label>
//                           <RawValue>{workOrder?.isvisibletoclient ? "Yes" : "No"}</RawValue>
//                         </InputRow>
//                         <InputRow $isMobile={isMobile}>
//                           <label style={{ marginRight: 5 }}>Resource (optional) :</label>
//                           <ResourseAssigned
//                             employees={employees}
//                             vendors={vendors}
//                             onClick={() => setIsModalVisible(true)}
//                             laborCode={workOrder?.wplabor?.find((labor) => labor.laborcode)?.laborcode}
//                             vendorId={workOrder?.wpservice?.find((service) => service.vendor)?.vendor}
//                           />
//                         </InputRow>
//                       </InputsRow>
//                       <InputsRow>
//                         <InputRow $isMobile={isMobile} />
//                         <InputRow $isMobile={isMobile}>
//                           <label>Approved Amount:</label>
//                           <RawValue>{getApprovedAmount(workOrder)}</RawValue>
//                         </InputRow>
//                       </InputsRow>
//                     </InputsContainer>
//                   )}
//                   {customWorkRequestFields && (
//                     <CustomWorkRequestFieldsViewForm
//                       $isMobile={isMobile}
//                       isClient={!isManager}
//                       customWorkRequestFields={customWorkRequestFields}
//                       workOrder={workOrder}
//                     />
//                   )}

//                   <DescriptionContainer $isMobile={isMobile}>
//                     <label>Description: </label>

//                     <DescriptionContainer $isMobile={isMobile}>
//                       <ReactQuill
//                         readOnly
//                         theme="snow"
//                         value={description || "N/A"}
//                         style={{ width: "calc(100% - 0px)" }}
//                       />
//                     </DescriptionContainer>
//                   </DescriptionContainer>

//                   {clientPhotos?.length === 0 ? null : (
//                     <InputsRow>
//                       <PhotoInput $isMobile={isMobile}>
//                         <label>
//                           Photos<span>(optional):</span>
//                         </label>
//                         <PhotoUpload
//                           files={files}
//                           isLoading={false}
//                           images={clientPhotos}
//                           setFiles={setFiles}
//                           isViewMode
//                         ></PhotoUpload>
//                       </PhotoInput>
//                     </InputsRow>
//                   )}

//                   <AttachmentRow>
//                     <Attachments
//                       documents={documents}
//                       workOrderHref={workOrder?.href}
//                       workOrderId={workOrder?.workorderid}
//                     />
//                   </AttachmentRow>

//                   <ErrorMessage>{error && error}</ErrorMessage>

//                   {workOrder && (
//                     <Details>
//                       <DetailsSection
//                         isNoAuthWorkRequest={isNoAuthWorkRequest}
//                         technicianPhotos={technicianPhotos}
//                         $isMobile={isMobile}
//                         workOrder={workOrder as WorkOrder}
//                         workOrderWorklog={worklog}
//                         isViewMode
//                         areImagesLoading={false}
//                         timezone={timezone}
//                         commentsSectionWorklog={commentsSectionWorklog}
//                         addCommentSuccess={addCommentSuccess}
//                         setAddCommentSuccess={setAddCommentSuccess}
//                         workOrderID={workOrder.wonum as string}
//                       />
//                     </Details>
//                   )}
//                 </>
//               )}
//               {/* <InputsContainer $isMobile={isMobile}> */}

//               {activeTab === "2" && (
//                 <InputsContainer $isMobile={isMobile}>
//                   <InputsRow>
//                     <InputRow $isMobile={isMobile}>
//                       <label>Requestor First Name:</label>
//                       <RawValue>{workOrder?.firstname || "N/A"}</RawValue>
//                     </InputRow>
//                     <InputRow $isMobile={isMobile}>
//                       <label>Requestor Email:</label>
//                       <RawValue>{workOrder?.email || "N/A"}</RawValue>
//                     </InputRow>
//                   </InputsRow>
//                   <InputsRow>
//                     <InputRow $isMobile={isMobile}>
//                       <label>Requestor Last Name:</label>
//                       <RawValue>{workOrder?.lastname || "N/A"}</RawValue>
//                     </InputRow>
//                     <InputRow $isMobile={isMobile}>
//                       <label>Requestor Phone No:</label>
//                       <RawValue>{workOrder?.phonenumber || "N/A"}</RawValue>
//                     </InputRow>
//                   </InputsRow>
//                 </InputsContainer>
//               )}

//               {activeTab === "3" && (
//                 <InputsContainer $isMobile={isMobile}>
//                   <InputRow $isMobile={isMobile}>
//                     <label>Service Type:</label>
//                     <RawValue>{workOrder?.commodity || "N/A"}</RawValue>
//                   </InputRow>
//                   <InputRow $isMobile={isMobile}>
//                     <label>Vendor:</label>
//                     <RawValue>
//                       {workOrder?.wpservice?.find((service) => service.vendor)
//                         ? vendors.find(
//                             (vendor) =>
//                               vendor.vendorId === workOrder?.wpservice?.find((service) => service.vendor)?.vendor,
//                           )?.displayName
//                         : "N/A"}
//                     </RawValue>
//                   </InputRow>
//                   <InputRow $isMobile={isMobile}>
//                     <label>Cost:</label>
//                     <RawValue>{workOrder?.estmatcost || "N/A"}</RawValue>
//                   </InputRow>
//                   <InputRow $isMobile={isMobile}>
//                     <label>Vendor Invoice:</label>
//                     <RawValue>{workOrder?.vendor || "N/A"}</RawValue>
//                   </InputRow>
//                   <InputRow $isMobile={isMobile}>
//                     <label>Actual Start:</label>
//                     <RawValue>
//                       {workOrder?.actstart
//                         ? parseDateToFormat(workOrder.actstart as string, "MMMM Do YYYY, h:mm A")
//                         : "N/A"}
//                     </RawValue>
//                   </InputRow>
//                   <InputRow $isMobile={isMobile}>
//                     <label>Actual Finish:</label>
//                     <RawValue>
//                       {workOrder?.actfinish
//                         ? parseDateToFormat(workOrder.actfinish as string, "MMMM Do YYYY, h:mm A")
//                         : "N/A"}
//                     </RawValue>
//                   </InputRow>
//                 </InputsContainer>
//               )}
//             </StyledForm>
//           </ContentFrame>
//         </Content>
//       </Container>
//     </LoadingContainer>
//   );
// };

// export const PhotoInput = styled.div<MobileProps>`
//   margin-bottom: 20px;
//   display: flex;
//   align-items: flex-start;
//   margin-bottom: 40px;
//   width: 100%;
//   border-bottom: 1px solid ${colors.grey.light12};
//   border-top: 1px solid ${colors.grey.light12};
//   padding: 30px 0;

//   label {
//     font-weight: 600;
//     font-size: 14px;
//     flex: 0 0 195px;

//     color: ${colors.black.light2};
//     white-space: nowrap;
//     margin-right: 20px;
//     display: flex;
//     align-items: baseline;

//     span {
//       display: block;
//       font-size: 14px;
//       font-weight: 400;
//       padding-left: 5px;
//     }

//     ${(props) => props.$isMobile && `width: 100px;`}
//   }
// `;

// const Details = styled.div`
//   padding: 30px 0;
// `;

// const StyledForm = styled(Form)`
//   padding-top: 20px;
// `;

// const Container = styled.div`
//   width: 100%;
//   height: inherit;
//   display: flex;
//   flex-direction: column;
//   position: relative;
//   margin-bottom: 40px;
// `;

// const EmptyContainer = styled.div`
//   width: 32px;
//   height: 32px;
// `;

// const Content = styled.div`
//   margin: 30px;
//   background-color: ${colors.white.default};
// `;

// const ErrorMessage = styled.p`
//   color: ${colors.red.default};
//   font-size: 14px;
//   text-align: center;
// `;

// interface InputRowProps extends MobileProps {
//   $marginBottom?: string;
//   isSelectSearch?: boolean;
//   ismanager?: number;
// }

// export const InputRow = styled.div<InputRowProps>`
//   display: flex;
//   align-items: center;
//   margin-bottom: ${({ $marginBottom }) => `${$marginBottom === undefined ? "40" : $marginBottom}px`};
//   max-width: ${({ ismanager }) => (ismanager ? "unset" : "600px")};
//   width: 100%;
//   position: relative;
//   margin-right: 40px;

//   & div {
//     width: ${({ ismanager }) => ismanager && "100%"};
//   }

//   ${(props) =>
//     props.$topLabel &&
//     css`
//       align-items: flex-start;
//     `}

//   div {
//     ${(props) =>
//       props.$isMobile &&
//       css`
//         font-size: 14px;
//       `}
//     p {
//       font-size: 14px;
//       margin-top: 8px;
//       color: ${colors.grey.dark};
//       max-width: 400px;
//     }
//   }

//   label {
//     font-size: 14px;
//     font-weight: 600;
//     width: 200px;
//     color: ${colors.black.light2};
//     white-space: nowrap;
//     flex: 0 0 200px;
//     margin-right: 20px;
//   }

//   input {
//     width: ${({ ismanager }) => (ismanager ? "100%" : "360px")};
//     ${(props) =>
//       !props.isSelectSearch &&
//       css`
//         padding: 0px 7px;
//       `}

//     ${(props) =>
//       props.$isMobile &&
//       css`
//         width: 200px;
//       `}
//   }

//   a {
//     font-weight: 500;
//     color: ${colors.grey.dark};
//   }
// `;

// export const RawValue = styled.p<{ color?: string }>`
//   border-bottom: 1px solid ${colors.grey.light4};
//   width: 100%;
//   font-size: 14px;
//   padding-bottom: 4px;
//   color: ${({ color }) => (color ? color : colors.grey.dark)};
// `;

// export const InputsRow = styled.div`
//   display: flex;
//   flex-wrap: wrap;

//   .tooltip {
//     max-width: 70%;
//   }
// `;

// const HintIcon = styled(FontAwesomeIcon)`
//   color: ${colors.grey.dark};
//   height: 20px;
//   width: 20px;
//   position: absolute;
//   right: -25px;

//   @media (max-width: 480px) {
//     right: -5%;
//   }
// `;

// const InputsContainer = styled.div<MobileProps>`
//   display: flex;
//   flex-direction: column;

//   ${(props) =>
//     props.$isMobile &&
//     css`
//       ${InputRow} {
//         margin-bottom: 20px;
//       }
//     `}

//   ${(props) =>
//     props.$isMobile &&
//     css`
//       label {
//         width: 100px;
//       }

//       input {
//         width: 100%;
//       }
//     `}

//   ${(props) =>
//     props.$isMobile &&
//     css`
//       ${SelectBoxContainer} {
//         height: 25px;
//       }
//     `}
// `;

// export const DescriptionContainer = styled.div<MobileProps>`
//   display: flex;
//   flex-direction: ${({ $isComments }) => ($isComments ? "column" : "row")};
//   margin-bottom: 20px;
//   width: 100%;

//   .ql-toolbar.ql-snow {
//     display: none;
//     border: none;
//   }

//   .ql-container.ql-snow {
//     border: none;
//   }

//   .ql-editor {
//     border: 1px solid ${colors.grey.light13};
//     padding: 10px;
//   }

//   label {
//     font-size: 14px;
//     font-weight: 600;
//     flex: 0 0 200px;
//     margin-right: 20px;
//     color: ${colors.black.light2};
//     margin-bottom: ${({ $isComments }) => ($isComments ? "10px" : "0px")};

//     ${(props) =>
//       props.$isMobile &&
//       css`
//         label {
//           font-size: 12px;
//         }
//       `};
//   }

//   ${(props: MobileProps) =>
//     props.$isMobile &&
//     css`
//       label {
//         font-size: 12px;
//       }
//     `}
// `;

// const AttachmentRow = styled.div`
//   ${InputRow} {
//     align-items: flex-start;
//   }
// `;

// const ChildWorkRequestRow = styled.div`
//   margin-bottom: 8px;
// `;

import * as faIcons from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "src/styles/datepicker-overrides.css";
import { Stack } from "react-bootstrap";
// import ReactQuill from "react-quill";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
// import { Tooltip as ReactTooltip } from "react-tooltip";
import styled, { css, keyframes } from "styled-components";

// import Badge from "src/components/Badge";
// import { SelectBoxContainer } from "src/components/Dropdown/styles";
import LoadingContainer from "src/components/LoadingContainer";
import PhotoUpload from "src/components/PhotoUpload";
import { OptionItem } from "src/components/SelectSearch";
import { useIsMobile } from "src/hooks/useIsMobile";
// import { Attachments } from "src/pages/TicketForm/Attachments";
import ClientApprovalWindow from "src/pages/TicketForm/ClientApproval";
import { getUserData } from "src/redux/selectors/user";
import {
  // ApprovedCcEmail,
  FirebaseDataService,
  WorkOrderEditLockResponse,
  WorkOrderEditLockState,
} from "src/services/Firebase/data";
import { colors } from "src/styles";
import {
  Client,
  DBLocation,
  MaximoDocument,
  PriorityLevel,
  PriorityLevelList,
  ResourceKind,
  ServiceTypeList,
  Ticket,
  WorkOrder,
  WorkType,
  Worklog,
} from "src/types";
import { parseDateToFormat } from "src/utils/time";
import { getBase64File } from "src/utils/convertToBase64";

import Button from "src/components/Button";
import BackButton from "src/components/Button/BackButton";
import Alert, { AlertVariants } from "src/components/Alert";
import {
  ActiveEmployee,
  ActiveVendor,
  AssignWOResourceFormValues,
} from "src/components/molecules/AssignWOResource/types";
// import { IssueWorkOrderPayload } from "src/components/organisms/IssueWorkOrderModal/types";
import { ShareFormValues } from "src/components/molecules/ShareForm/types";
import AssignWOResourceModal from "src/components/organisms/AssignWOResourseModal";
// import IssueWorkOrderModal from "src/components/organisms/IssueWorkOrderModal";
import ShareFormModal from "src/components/organisms/ShareFormModal";
import RequestQuoteForm from "src/pages/TicketForm/RequestQuoteForm";

import { setPageNameHeader } from "src/redux/actions/header";
import { roundTo2Decimals } from "src/utils/helpers";
// import { CustomWorkRequestField } from "../CreateForm/types";
import { CommentRegEx } from "../DetailsSection";
// import StatusSelect from "../StatusSelect";
import { ClientApprovalStatuses, FormData, MobileProps, TicketFormProps } from "../types";
// import { CustomWorkRequestFieldsViewForm } from "./components/CustomWorkRequestFieldsViewForm";
import { ClientSelectionModal } from "../CreateForm/components/ClientSelectionModal";
import { ParentWorkOrderSelectionModal } from "../CreateForm/components/ParentWorkOrderSelectionModal";
import { RelatedResourceSelectionModal } from "../CreateForm/components/RelatedResourceSelectionModal";
import { ServiceTypeClassificationModal } from "../CreateForm/components/ServiceTypeClassificationModal";
// import CreateFormTabs from "../CreateForm/components/CreateFormTabs";
import { objToArray } from "src/utils/objToArray";
import { ErrorPage } from "src/pages/ErrorPage";
import Header from "src/components/Header";
import { isSchedulingFieldEditable } from "./schedulingFieldUtils";
import { normalizeServiceTypes, getServiceTypesForClient } from "src/utils/serviceTypes";

// ─── New types for activity log & billing extensions ──────────────────────────

type AuditEvent = {
  id: string;
  created_at: string;
  who: string;
  event: string;
};

type ActivityFilter = "all" | "comments" | "system";
type StatusHighlightTone = "neutral" | "active" | "warning" | "success" | "danger";

const resolveStatusHighlightTone = (statusCode: string, statusLabel: string): StatusHighlightTone => {
  const normalized = `${statusCode} ${statusLabel}`.trim().toUpperCase();
  if (!normalized) return "neutral";

  if (/(CLOSE|CLOSED|COMP|COMPLET|DONE|RESOLV|APPR|APPROV)/.test(normalized)) {
    return "success";
  }

  if (/(CAN|CANCEL|REJ|REJECT|DECLIN)/.test(normalized)) {
    return "danger";
  }

  if (/(WAPPR|APPROVAL|PEND|WAIT|WTBS|WTS|WSCH|SCHED)/.test(normalized)) {
    return "warning";
  }

  if (/(INPRG|PROGRESS|WORKING|ACTIVE|START)/.test(normalized)) {
    return "active";
  }

  return "neutral";
};

const parseLocalDateTime = (value?: string) => {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const formatDateTimeLocalValue = (date: Date | null) => {
  if (!date) return "";
  const pad = (num: number) => String(num).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
    date.getMinutes(),
  )}`;
};

const WORK_ORDER_LOCKED_MESSAGE = "Another user is actively editing this work order. Please try again in a moment.";

const getWorkOrderLockedMessage = (editorName?: string) => {
  const normalizedEditorName = String(editorName || "").trim();
  if (!normalizedEditorName) {
    return WORK_ORDER_LOCKED_MESSAGE;
  }

  return `${normalizedEditorName} is actively editing this work order. Please try again in a moment.`;
};

type BillableType = "not_billable" | "ksi" | "client" | "both";
type ClientBillingMode = "fixed" | "cost_plus";
type ClientApprovalStatus = "not_required" | "pending" | "approved" | "declined";
type EditableFieldKey =
  | "title"
  | "parent"
  | "specificArea"
  | "worktype"
  | "serviceType"
  | "priority"
  | "description_longdescription"
  | "billable_type"
  | "estmatcost"
  | "vendor_cost"
  | "client_markup_pct"
  | "client_billing_mode"
  | "client_fixed_amount"
  | "client_approval_status"
  | "client_po_number"
  | "requires_quote"
  | "schedstart"
  | "schedfinish"
  | "actstart"
  | "actfinish";

// These fields extend WorkOrder for the new billing panel.
// They are optional so existing WorkOrder data never breaks.
type ExtendedWorkOrder = WorkOrder & {
  request_type?: "service_request" | "service_concern";
  linked_po_id?: string | null;
  site_id?: string | null;
  resource_id?: string | null;
  completion_contact_name?: string | null;
  billable_type?: BillableType;
  client_billing_mode?: ClientBillingMode;
  client_fixed_amount?: number | null;
  client_approval_status?: ClientApprovalStatus;
  client_po_number?: string | null;
  requires_quote?: boolean;
  billingType?: BillableType;
  clientBillingMode?: ClientBillingMode;
  clientFixedAmount?: number | null;
  clientApprovalStatus?: ClientApprovalStatus;
  clientPoNumber?: string | null;
  requiresQuote?: boolean;
  serviceTypeId?: string;
  classificationId?: string;
  serviceType?: string;
  classification?: string;
  descriptionLongDescription?: string;
  descriptionlongdescription?: string;
  vendor_cost?: number | null;
  client_markup_pct?: number | null;
};

type PendingResourceAssignment = {
  vendorId?: string;
  vendorName?: string;
  laborCode?: string;
  approvedamount?: number;
  woacceptscharges?: boolean;
  assignedEmployee?: {
    id?: string;
    laborCode?: string;
    displayName?: string;
    email?: string;
  };
};

export const ViewForm = ({ isNoAuthWorkRequest }: TicketFormProps) => {
  const navigate = useNavigate();
  const location: any = useLocation();
  const { isMobile } = useIsMobile();
  const { id } = useParams();
  const dispatch = useDispatch();

  const { id: clientUserId, isManager, isTechnician, firstName, lastName, email } = useSelector(getUserData);

  const defaultServiceType = location?.state?.serviceType;
  const [workTypes, setWorkTypes] = useState<WorkType[]>([]);
  const [clients, setClients] = useState<Client[]>([]);
  const [locations, setLocations] = useState<DBLocation[]>([]);
  const [serviceTypes, setServiceTypes] = useState<ServiceTypeList>();
  const [priorityLevels, setPriorityLevels] = useState<PriorityLevelList>();
  const [statusList, setStatusList] = useState<OptionItem[]>([]);
  const [error, setError] = useState("");
  const [workOrder, setWorkOrder] = useState<ExtendedWorkOrder>();
  const [isFormLoading, setIsFormLoading] = useState(false);
  // const [worklog, setWorklog] = useState<Worklog[]>([]);
  const [_formData, setFormData] = useState<FormData>({
    ticketName: "",
    description: "",
    serviceType: defaultServiceType?.description || "",
    classification: "",
    priorityName: "",
    priority: 0,
    workType: "",
    location: "",
    targetStart: new Date(),
    targetFinish: new Date(),
  });
  const [clientPhotos, setClientPhotos] = useState<string[]>([]);
  // const [technicianPhotos, setTechnicianPhotos] = useState<string[]>([]);
  const [files, setFiles] = useState<File[]>([]);
  // const [statusList, setStatusList] = useState<OptionItem[]>([]);
  // const [timezone, setTimezone] = useState("");
  // const [priorityLevel, setPriorityLevel] = useState<PriorityLevel>();
  const [documents, setDocuments] = useState<MaximoDocument[]>();
  // const [hints, setHints] = useState({ serviceType: "", classification: "" });
  const [setAddCommentSuccess] = useState<boolean>(false);
  const [clientApprovalStatuses, setClientApprovalStatuses] = useState<ClientApprovalStatuses>();
  // const [customWorkRequestFields, setCustomWorkRequestFields] = useState<CustomWorkRequestField[]>();
  const [isShareWorkRequestModalVisible, setIsShareWorkRequestModalVisible] = useState<boolean>(false);
  const [shareFormError, setShareFormError] = useState("");
  const [isQuoteModalVisible, setIsQuoteModalVisible] = useState<boolean>(false);
  const [employees, setEmployees] = useState<ActiveEmployee[]>([]);
  const [vendors, setVendors] = useState<ActiveVendor[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [assignResourceErrorOnSubmit, setAssignResourceErrorOnSubmit] = useState("");
  const [noAuthActiveWorkOrder, setNoAuthActiveWorkOrder] = useState<boolean>(false);
  const [noAuthDeletedWorkOrder, setNoAuthDeletedWorkOrder] = useState<boolean>(false);
  // const [activeTab, setActiveTab] = useState<string>("1");
  const [searchParams] = useSearchParams();
  const trackingId = searchParams.get("trackingId");

  // Activity log
  const [events, setEvents] = useState<AuditEvent[]>([]);
  const [activityFilter, setActivityFilter] = useState<ActivityFilter>("all");
  const [noteDraft, setNoteDraft] = useState("");
  const [uploading, setUploading] = useState(false);
  const [completionContactDraft, setCompletionContactDraft] = useState("");
  const [completionContactSaving, setCompletionContactSaving] = useState(false);
  const [isInternalComposerOpen, setIsInternalComposerOpen] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const detailsAttachmentInputRef = useRef<HTMLInputElement>(null);
  const [isAttachmentModalOpen, setIsAttachmentModalOpen] = useState(false);
  const [pendingAttachmentFiles, setPendingAttachmentFiles] = useState<File[]>([]);
  const [selectedAttachmentPreview, setSelectedAttachmentPreview] = useState<{
    href: string;
    label: string;
    isImage: boolean;
  } | null>(null);
  const [isAttachmentPreviewLoading, setIsAttachmentPreviewLoading] = useState(false);
  const [scheduleDrafts, setScheduleDrafts] = useState({
    schedstart: "",
    schedfinish: "",
    actstart: "",
    actfinish: "",
  });
  const [isRelatedResourceModalOpen, setIsRelatedResourceModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [_editableField, setEditableField] = useState<EditableFieldKey | null>(null);
  const [pendingEditPatch, setPendingEditPatch] = useState<Record<string, unknown>>({});
  const [pendingResourceAssignment, setPendingResourceAssignment] = useState<PendingResourceAssignment | null>(null);
  const [isSavingEdits, setIsSavingEdits] = useState(false);
  const [resourceKind, setResourceKind] = useState<ResourceKind>("none");
  const [resourceId, setResourceId] = useState("");
  const [isStatusTransitioning, setIsStatusTransitioning] = useState(false);
  const [statusTransitionSuccess, setStatusTransitionSuccess] = useState("");
  const [selectedClientId, setSelectedClientId] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const [selectedServiceTypeId, setSelectedServiceTypeId] = useState("");
  const [selectedClassificationId, setSelectedClassificationId] = useState("");
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const [isParentModalOpen, setIsParentModalOpen] = useState(false);
  const [parentWorkOrderOptions, setParentWorkOrderOptions] = useState<Ticket[]>([]);
  const [isServiceTypeModalOpen, setIsServiceTypeModalOpen] = useState(false);
  const [selectedSidebarStatusCode, setSelectedSidebarStatusCode] = useState("");
  const [isEditLockLoading, setIsEditLockLoading] = useState(false);
  const [isWorkOrderLockedByAnotherUser, setIsWorkOrderLockedByAnotherUser] = useState(false);
  const [workOrderLockOwner, setWorkOrderLockOwner] = useState("");
  const [workOrderLockMessage, setWorkOrderLockMessage] = useState("");
  const hasLocalEditLockRef = useRef(false);
  const activeWorkOrderLockRef = useRef("");
  const activeWorkOrderIdRef = useRef<string>("");

  // Completion notes (low/medium severity gate, mirrors Kori)
  // const [completionNotes, setCompletionNotes] = useState("");

  const formatActivityText = (detailsText: string, summaryText: string) => {
    if (summaryText && detailsText) return `${summaryText}: ${detailsText}`;
    if (detailsText) return detailsText;
    if (summaryText) return summaryText;
    return "";
  };

  const normalizeActivityTimestamp = (value: unknown) => {
    if (!value) return new Date().toISOString();

    if (value instanceof Date) return value.toISOString();

    if (typeof value === "string" || typeof value === "number") {
      const direct = new Date(value);
      if (!Number.isNaN(direct.getTime())) return direct.toISOString();
    }

    if (typeof value === "object") {
      const obj = value as {
        toDate?: () => Date;
        seconds?: number;
        _seconds?: number;
        $date?: string;
        iso?: string;
        value?: string;
      };

      if (typeof obj.toDate === "function") {
        const d = obj.toDate();
        if (d instanceof Date && !Number.isNaN(d.getTime())) return d.toISOString();
      }

      const epochSeconds = obj.seconds ?? obj._seconds;
      if (typeof epochSeconds === "number") {
        const d = new Date(epochSeconds * 1000);
        if (!Number.isNaN(d.getTime())) return d.toISOString();
      }

      const candidate = obj.$date || obj.iso || obj.value;
      if (candidate) {
        const d = new Date(candidate);
        if (!Number.isNaN(d.getTime())) return d.toISOString();
      }
    }

    return new Date().toISOString();
  };

  const normalizeWorkOrderForView = (sourceWorkOrder: any, procurement?: any): ExtendedWorkOrder => {
    if (!sourceWorkOrder) return sourceWorkOrder;

    const normalizedWorkOrder: ExtendedWorkOrder = { ...(sourceWorkOrder as ExtendedWorkOrder) };
    const dbData = sourceWorkOrder?.dbData || {};
    const normalizedProcurement = procurement || {};

    normalizedWorkOrder.billable_type =
      normalizedWorkOrder.billable_type ||
      (sourceWorkOrder.billing_type as BillableType) ||
      (sourceWorkOrder.billingType as BillableType) ||
      (dbData.billing_type as BillableType) ||
      "not_billable";
    normalizedWorkOrder.client_billing_mode =
      normalizedWorkOrder.client_billing_mode ||
      (sourceWorkOrder.client_billing_mode as ClientBillingMode) ||
      (sourceWorkOrder.clientBillingMode as ClientBillingMode);
    normalizedWorkOrder.client_fixed_amount =
      normalizedWorkOrder.client_fixed_amount ??
      sourceWorkOrder.client_fixed_amount ??
      sourceWorkOrder.clientFixedAmount ??
      sourceWorkOrder.client_billed_amount ??
      dbData.client_billed_amount ??
      ((sourceWorkOrder.billing_type === "client" || sourceWorkOrder.billing_type === "both") &&
      normalizedProcurement.totalAmount != null
        ? Number(normalizedProcurement.totalAmount)
        : null) ??
      null;
    normalizedWorkOrder.vendor_cost =
      normalizedWorkOrder.vendor_cost ??
      sourceWorkOrder.vendor_cost ??
      sourceWorkOrder.vendorCost ??
      sourceWorkOrder.estimated_cost ??
      sourceWorkOrder.estimatedCost ??
      dbData.estimated_cost ??
      (normalizedProcurement.totalAmount != null ? Number(normalizedProcurement.totalAmount) : null) ??
      null;
    normalizedWorkOrder.client_markup_pct =
      normalizedWorkOrder.client_markup_pct ??
      sourceWorkOrder.client_markup_pct ??
      sourceWorkOrder.clientMarkupPct ??
      null;
    normalizedWorkOrder.client_approval_status =
      normalizedWorkOrder.client_approval_status ||
      (sourceWorkOrder.client_approval_status as ClientApprovalStatus) ||
      (sourceWorkOrder.clientApprovalStatus as ClientApprovalStatus);
    normalizedWorkOrder.client_po_number =
      normalizedWorkOrder.client_po_number ??
      sourceWorkOrder.client_po_number ??
      sourceWorkOrder.po_number ??
      sourceWorkOrder.clientPoNumber ??
      dbData.po_number ??
      normalizedProcurement.poNumber ??
      null;
    normalizedWorkOrder.requires_quote =
      normalizedWorkOrder.requires_quote ?? sourceWorkOrder.requires_quote ?? sourceWorkOrder.requiresQuote;

    (normalizedWorkOrder as any).estmatcost =
      (normalizedWorkOrder as any).estmatcost ??
      normalizedWorkOrder.vendor_cost ??
      sourceWorkOrder.estimated_cost ??
      sourceWorkOrder.estimatedCost ??
      dbData.estimated_cost ??
      null;

    normalizedWorkOrder.serviceTypeId =
      normalizedWorkOrder.serviceTypeId ||
      sourceWorkOrder.service_type_id ||
      dbData.service_type_id ||
      sourceWorkOrder.serviceType ||
      "";
    normalizedWorkOrder.serviceType =
      normalizedWorkOrder.serviceType || sourceWorkOrder.service_type_name || dbData.service_type_name || "";
    normalizedWorkOrder.classificationId =
      normalizedWorkOrder.classificationId ||
      sourceWorkOrder.classification_id ||
      sourceWorkOrder.class_structure_id ||
      dbData.class_structure_id ||
      "";
    normalizedWorkOrder.classification =
      normalizedWorkOrder.classification || sourceWorkOrder.classification_name || dbData.classification_name || "";

    if (!normalizedWorkOrder.description_longdescription) {
      normalizedWorkOrder.description_longdescription =
        sourceWorkOrder.descriptionLongDescription ||
        sourceWorkOrder.descriptionlongdescription ||
        sourceWorkOrder.description_longdescription ||
        dbData.description_longdescription ||
        "";
    }

    return normalizedWorkOrder;
  };

  const getWorkOrderDescription = (currentWorkOrder?: ExtendedWorkOrder) => {
    if (!currentWorkOrder) {
      return "";
    }

    return String(
      currentWorkOrder.description_longdescription ??
        currentWorkOrder.descriptionLongDescription ??
        currentWorkOrder.descriptionlongdescription ??
        "",
    );
  };

  const getActivityActorName = () => {
    const managerName = `${firstName || ""} ${lastName || ""}`.trim();
    if (!isNoAuthWorkRequest) return managerName || "User";

    const contactName = completionContactDraft.trim();
    if (contactName) return contactName;
    return managerName || "User";
  };

  const getEditLockIdentity = () => {
    const userId = String(email || clientUserId || "").trim();
    const userName = `${firstName || ""} ${lastName || ""}`.trim() || email || "User";
    const normalizedFirstName = String(firstName || "").trim();
    const normalizedLastName = String(lastName || "").trim();
    const normalizedEmail = String(email || "").trim();

    return {
      userId,
      userName,
      firstName: normalizedFirstName,
      lastName: normalizedLastName,
      email: normalizedEmail,
    };
  };

  const parseWorkOrderEditLock = (response: WorkOrderEditLockResponse | null | undefined): WorkOrderEditLockState => {
    const base = (response || {}) as Record<string, any>;
    const payload = base?.result && typeof base.result === "object" ? base.result : base;
    const nested = payload?.data && typeof payload.data === "object" ? payload.data : payload;
    const editor = nested?.editor && typeof nested.editor === "object" ? nested.editor : {};

    const resolvedOwnerId =
      nested?.lockedByUserId ||
      nested?.userId ||
      nested?.lockedBy ||
      nested?.editorId ||
      editor?.editorId ||
      editor?.email ||
      "";
    const resolvedOwnerName =
      nested?.lockedByUserName ||
      nested?.userName ||
      nested?.lockedByName ||
      nested?.editorName ||
      editor?.displayName ||
      editor?.email ||
      "";
    const resolvedLockedAt = nested?.lockedAt || nested?.updatedAt || nested?.timestamp || editor?.updatedAt || "";
    const resolvedExpiresAt = nested?.expiresAt || nested?.expires_at || editor?.expiresAt || editor?.expires_at;

    const explicitLockValue = nested?.isLocked ?? nested?.locked ?? nested?.is_locked ?? nested?.lockActive;
    const hasExplicitLock = explicitLockValue !== undefined && explicitLockValue !== null;
    const explicitLockState = hasExplicitLock
      ? explicitLockValue === true ||
        explicitLockValue === "true" ||
        explicitLockValue === 1 ||
        explicitLockValue === "1"
      : false;

    const ownerId = String(resolvedOwnerId || "").trim();
    const ownerName = String(resolvedOwnerName || "").trim();
    const hasEditorIdentity = Boolean(ownerId || ownerName);

    const expiresAtString = String(resolvedExpiresAt || "").trim();
    const parsedExpiresAt = expiresAtString ? new Date(expiresAtString) : null;
    const hasValidExpiry = Boolean(parsedExpiresAt && !Number.isNaN(parsedExpiresAt.getTime()));
    const isExpired = Boolean(hasValidExpiry && parsedExpiresAt && parsedExpiresAt.getTime() <= Date.now());

    const inferredLockState = hasEditorIdentity && !isExpired;

    return {
      isLocked: hasExplicitLock ? explicitLockState : inferredLockState,
      lockedByUserId: String(resolvedOwnerId),
      lockedByUserName: String(resolvedOwnerName),
      lockedAt: String(resolvedLockedAt),
    };
  };

  const isLockOwnedByCurrentUser = (lockState?: WorkOrderEditLockState | null) => {
    if (!lockState?.isLocked) {
      return false;
    }

    const currentUserId = String(getEditLockIdentity().userId || "")
      .trim()
      .toLowerCase();
    const currentUserEmail = String(email || "")
      .trim()
      .toLowerCase();
    const ownerId = String(lockState.lockedByUserId || "")
      .trim()
      .toLowerCase();
    const ownerName = String(lockState.lockedByUserName || "")
      .trim()
      .toLowerCase();

    if (currentUserEmail && (ownerId === currentUserEmail || ownerName === currentUserEmail)) {
      return true;
    }

    if (currentUserId && (ownerId === currentUserId || ownerName === currentUserId)) {
      return true;
    }

    return false;
  };

  const applyWorkOrderEditLockState = (wonum: string, lockState: WorkOrderEditLockState) => {
    const normalizedLockOwnerId = String(lockState.lockedByUserId || "").trim();
    const normalizedLockOwnerName = String(lockState.lockedByUserName || "").trim();
    const isCurrentUserOwner = isLockOwnedByCurrentUser(lockState);

    if (!lockState.isLocked) {
      if (activeWorkOrderLockRef.current === wonum) {
        hasLocalEditLockRef.current = false;
      }

      setIsWorkOrderLockedByAnotherUser(false);
      setWorkOrderLockOwner("");
      setWorkOrderLockMessage("");
      return;
    }

    const lockOwnedLocally = hasLocalEditLockRef.current && activeWorkOrderLockRef.current === wonum;
    const isLockedByAnother = !isCurrentUserOwner && !lockOwnedLocally;

    if (isCurrentUserOwner) {
      hasLocalEditLockRef.current = true;
      activeWorkOrderLockRef.current = wonum;
      if (workOrder?.workorderid) {
        activeWorkOrderIdRef.current = String(workOrder.workorderid);
      }
    }

    const normalizedLockOwnerLabel = normalizedLockOwnerName || normalizedLockOwnerId;

    setWorkOrderLockOwner(normalizedLockOwnerLabel);
    setIsWorkOrderLockedByAnotherUser(isLockedByAnother);
    setWorkOrderLockMessage(isLockedByAnother ? getWorkOrderLockedMessage(normalizedLockOwnerLabel) : "");
  };

  const getLatestWorkOrderEditLock = async (options?: { suppressErrors?: boolean }) => {
    if (isNoAuthWorkRequest || !workOrder?.wonum || !canEditWorkOrderFields) {
      return null;
    }

    try {
      const lockResponse = await FirebaseDataService.getWorkOrderEditLock({
        wonum: workOrder.wonum,
        workOrderId: workOrder.workorderid,
        userId: getEditLockIdentity().userId,
      });
      const lockState = parseWorkOrderEditLock(lockResponse);
      applyWorkOrderEditLockState(workOrder.wonum, lockState);
      return lockState;
    } catch (lockError) {
      if (!options?.suppressErrors) {
        setError(lockError instanceof Error ? lockError.message : "Unable to check edit lock.");
      }
      return null;
    }
  };

  const releaseWorkOrderEditLock = async (options?: {
    silent?: boolean;
    wonum?: string;
    workOrderId?: string | number;
    force?: boolean;
  }) => {
    const wonumToRelease = options?.wonum || activeWorkOrderLockRef.current || workOrder?.wonum;
    const workOrderIdToRelease = options?.workOrderId || activeWorkOrderIdRef.current || workOrder?.workorderid;

    if (!wonumToRelease) {
      return;
    }

    if (!hasLocalEditLockRef.current && !options?.force) {
      return;
    }

    const identity = getEditLockIdentity();
    if (!identity.userId) {
      return;
    }

    try {
      await FirebaseDataService.setWorkOrderEditLock({
        wonum: wonumToRelease,
        workOrderId: workOrderIdToRelease,
        userId: identity.userId,
        userName: identity.userName,
        firstName: identity.firstName,
        lastName: identity.lastName,
        email: identity.email,
        lock: false,
      });
    } catch (lockError) {
      if (!options?.silent) {
        setError(lockError instanceof Error ? lockError.message : "Unable to release edit lock.");
      }
    } finally {
      hasLocalEditLockRef.current = false;

      if (activeWorkOrderLockRef.current === wonumToRelease) {
        activeWorkOrderLockRef.current = "";
        activeWorkOrderIdRef.current = "";
      }

      if (workOrder?.wonum === wonumToRelease) {
        setIsWorkOrderLockedByAnotherUser(false);
        setWorkOrderLockOwner("");
        setWorkOrderLockMessage("");
      }
    }
  };

  const acquireWorkOrderEditLock = async () => {
    if (!workOrder?.wonum) return false;

    const identity = getEditLockIdentity();
    if (!identity.userId) {
      setError("Unable to acquire edit lock: missing user identity.");
      return false;
    }

    setIsEditLockLoading(true);
    try {
      const latestLock = await getLatestWorkOrderEditLock({ suppressErrors: true });
      const isLockedByAnother = !!latestLock?.isLocked && !isLockOwnedByCurrentUser(latestLock) && !isEditMode;

      if (isLockedByAnother) {
        const ownerName = String(latestLock?.lockedByUserName || latestLock?.lockedByUserId || "").trim();
        setIsWorkOrderLockedByAnotherUser(true);
        setWorkOrderLockOwner(ownerName);
        setWorkOrderLockMessage(getWorkOrderLockedMessage(ownerName));
        return false;
      }

      const lockResponse = await FirebaseDataService.setWorkOrderEditLock({
        wonum: workOrder.wonum,
        workOrderId: workOrder.workorderid,
        userId: identity.userId,
        userName: identity.userName,
        firstName: identity.firstName,
        lastName: identity.lastName,
        email: identity.email,
        lock: true,
      });

      const confirmedLock = parseWorkOrderEditLock(lockResponse);
      const lockOwnedByAnother = confirmedLock.isLocked && !isLockOwnedByCurrentUser(confirmedLock);

      if (lockOwnedByAnother) {
        const ownerName = String(confirmedLock.lockedByUserName || confirmedLock.lockedByUserId || "").trim();
        setIsWorkOrderLockedByAnotherUser(true);
        setWorkOrderLockOwner(ownerName);
        setWorkOrderLockMessage(getWorkOrderLockedMessage(ownerName));
        return false;
      }

      hasLocalEditLockRef.current = true;
      activeWorkOrderLockRef.current = workOrder.wonum;
      activeWorkOrderIdRef.current = String(workOrder.workorderid || "");
      setIsWorkOrderLockedByAnotherUser(false);
      setWorkOrderLockOwner("");
      setWorkOrderLockMessage("");
      return true;
    } catch (lockError) {
      setError(lockError instanceof Error ? lockError.message : "Unable to acquire edit lock.");
      return false;
    } finally {
      setIsEditLockLoading(false);
    }
  };

  const isCommentBoxTimelineEvent = (entry: AuditEvent) => {
    const eventText = String(entry.event || "").trim();
    const normalizedEventText = eventText.replace(/^activity\s*log\s*:\s*/i, "").trim();
    const hasCommentAuthorPrefix = /^\[[^\]]+\]\s+/.test(normalizedEventText);
    const messageBody = normalizedEventText.replace(/^\[[^\]]+\]\s+/, "").trim();
    const isAttachmentEvent = /^attached file:/i.test(messageBody);
    const isSystemGeneratedEvent =
      /^(updated\b|assigned\s+vendor\b|assigned\s+team\s+member\b|cleared\s+related\s+resource\s+assignment\b|cleared\s+completion\s+contact\b|status\s+changed\s+to\b|client\s+changed\s+to\b|location\s+changed\s+to\b|service\s+type\s+changed\s+to\b)/i.test(
        messageBody,
      );

    // Notes typed in the comment box are logged as: [User Name] <note text>
    // Keep system-generated activity entries in the System tab.
    return hasCommentAuthorPrefix && !isAttachmentEvent && !isSystemGeneratedEvent;
  };

  const timelineEntries = useMemo(
    () =>
      [
        {
          id: "_open",
          created_at: workOrder?.reportdate ?? new Date().toISOString(),
          who: "System",
          event: "Work request opened.",
        },
        ...events,
      ]
        .slice()
        .sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime()),
    [events, workOrder?.reportdate],
  );

  const filteredTimelineEntries = useMemo(() => {
    if (activityFilter === "comments") {
      return timelineEntries.filter((entry) => isCommentBoxTimelineEvent(entry));
    }

    if (activityFilter === "system") {
      return timelineEntries.filter((entry) => !isCommentBoxTimelineEvent(entry));
    }

    return timelineEntries;
  }, [timelineEntries, activityFilter]);

  // const tabs = [
  //   { eventKey: "1", label: "Work Details" },
  //   { eventKey: "2", label: "Requestor Details" },
  //   { eventKey: "3", label: "Service Details" },
  // ];

  // ─── Derived values ───────────────────────────────────────────────────────
  const resolvedClientId = useMemo(() => {
    if (selectedClientId) return String(selectedClientId);

    const customerKey = String(workOrder?.pluspcustomer?.customer || "");
    const byCustomer = clients.find(
      (client) => String(client.customerId) === customerKey || String(client.id) === customerKey,
    );

    return byCustomer ? String(byCustomer.id) : "";
  }, [clients, selectedClientId, workOrder?.pluspcustomer?.customer]);
  // const locationOptions = useMemo(
  //   () => locations.filter((loc) => String(loc.clientId) === String(resolvedClientId)),
  //   [locations, resolvedClientId],
  // );
  // const serviceTypeOptions = useMemo(() => {
  //   const source = getServiceTypesForClient(serviceTypes, resolvedClientId);
  //   return source
  //     .filter(
  //       (item) =>
  //         item.showOnPublic !== false &&
  //         Object.values(item.classifications || {}).some((classification) => classification?.showOnPublic !== false),
  //     )
  //     .map((item) => ({
  //       id: item.id,
  //       label: item.description || item.name,
  //     }));
  // }, [serviceTypes, resolvedClientId]);
  const editableServiceTypeOptions = useMemo(() => {
    const source = getServiceTypesForClient(serviceTypes, resolvedClientId);
    return source.map((item) => ({
      id: item.id,
      label: item.description || item.name,
    }));
  }, [serviceTypes, resolvedClientId]);
  const fallbackServiceTypeId = useMemo(() => {
    if (selectedServiceTypeId) return selectedServiceTypeId;

    const classificationNode = workOrder?.classstructure?.[0];
    const nestedNode = classificationNode?.classstructure?.[0];
    const serviceTypeSource = getServiceTypesForClient(serviceTypes, resolvedClientId);
    const nodes = [classificationNode, nestedNode].filter(Boolean) as Array<{
      classstructureid?: string;
      description?: string;
    }>;

    const matchedFromNodes = serviceTypeSource.find((serviceType) =>
      nodes.some(
        (node) =>
          serviceType.id === node.classstructureid ||
          normalizeLookupKey(serviceType.description || serviceType.name) === normalizeLookupKey(node.description),
      ),
    );

    const fallbackFromFormData = serviceTypeSource.find(
      (serviceType) =>
        serviceType.id ===
          String((workOrder as any)?.serviceType || (workOrder as any)?.dbData?.service_type_id || "") ||
        normalizeLookupKey(serviceType.description || serviceType.name) ===
          normalizeLookupKey((workOrder as any)?.serviceType || (workOrder as any)?.dbData?.service_type_name),
    );

    return (
      matchedFromNodes?.id ||
      fallbackFromFormData?.id ||
      String((workOrder as any)?.serviceTypeId || (workOrder as any)?.dbData?.service_type_id || "") ||
      ""
    );
  }, [resolvedClientId, selectedServiceTypeId, serviceTypes, workOrder]);
  const classificationOptions = useMemo(() => {
    const selectedServiceType = getServiceTypesForClient(serviceTypes, resolvedClientId).find(
      (serviceType) => serviceType.id === fallbackServiceTypeId,
    );
    return objToArray(selectedServiceType?.classifications, (item, id) => ({
      ...(item || {}),
      id,
    }))
      .filter((item) => !!item?.name)
      .map((item) => ({
        id: item.classstructureid || item.id,
        label: item.description || item.name,
      }));
  }, [fallbackServiceTypeId, resolvedClientId, serviceTypes]);
  const getClassificationsByServiceType = (serviceTypeId: string) => {
    const selectedServiceType = getServiceTypesForClient(serviceTypes, resolvedClientId).find(
      (serviceType) => serviceType.id === serviceTypeId,
    );
    return objToArray(selectedServiceType?.classifications, (item, id) => ({
      ...(item || {}),
      id,
    }))
      .filter((item) => !!item?.name)
      .map((item) => ({
        id: item.classstructureid || item.id,
        label: item.description || item.name || "",
      }));
  };
  const getClassificationLabelFromFirebase = (
    classificationId?: string,
    serviceTypeId?: string,
    rawClassificationValue?: string,
  ) => {
    const normalizedClassificationId = String(classificationId || "").trim();
    const normalizedRaw = String(rawClassificationValue || "").trim();

    if (!serviceTypes) return "";

    const currentClientServiceTypes = getServiceTypesForClient(serviceTypes, resolvedClientId);
    const serviceTypeBuckets = Object.values(serviceTypes || {}).flat();

    const matchInServiceType = (serviceType: any) =>
      objToArray(serviceType?.classifications, (item, id) => ({ ...(item || {}), id })).find((classification) => {
        const classId = String(classification.classstructureid || classification.id || "").trim();
        const className = String(classification.name || "").trim();
        const classDescription = String(classification.description || "").trim();

        if (normalizedClassificationId && classId === normalizedClassificationId) return true;
        if (normalizedRaw && (className === normalizedRaw || classDescription === normalizedRaw)) return true;

        return false;
      });

    if (serviceTypeId) {
      const preferredServiceType = currentClientServiceTypes.find((serviceType) => serviceType.id === serviceTypeId);
      const preferredMatch = preferredServiceType ? matchInServiceType(preferredServiceType) : undefined;
      if (preferredMatch) {
        return preferredMatch.description || preferredMatch.name || "";
      }
    }

    for (const serviceType of currentClientServiceTypes) {
      const found = matchInServiceType(serviceType);
      if (found) {
        return found.description || found.name || "";
      }
    }

    for (const serviceType of serviceTypeBuckets) {
      const found = matchInServiceType(serviceType);
      if (found) {
        return found.description || found.name || "";
      }
    }

    return "";
  };
  const fallbackClassificationId = useMemo(() => {
    if (selectedClassificationId) return selectedClassificationId;

    const classificationNode = workOrder?.classstructure?.[0];
    const nestedNode = classificationNode?.classstructure?.[0];
    const byId = classificationOptions.find(
      (classification) =>
        classification.id === (classificationNode?.classstructureid as string) ||
        classification.id === (nestedNode?.classstructureid as string),
    );
    const byLabel = classificationOptions.find(
      (classification) =>
        normalizeLookupKey(classification.label) === normalizeLookupKey(classificationNode?.description) ||
        normalizeLookupKey(classification.label) === normalizeLookupKey(nestedNode?.description),
    );

    const rawClassification = String((workOrder as any)?.classification || "");
    const byRawField = classificationOptions.find(
      (classification) =>
        classification.id === rawClassification ||
        normalizeLookupKey(classification.label) === normalizeLookupKey(rawClassification),
    );

    const byFirebaseLabel = getClassificationLabelFromFirebase(
      String((workOrder as any)?.classificationId || (workOrder as any)?.dbData?.class_structure_id || ""),
      String((workOrder as any)?.serviceTypeId || (workOrder as any)?.dbData?.service_type_id || ""),
      rawClassification,
    );

    const byFirebaseId = classificationOptions.find(
      (classification) => normalizeLookupKey(classification.label) === normalizeLookupKey(byFirebaseLabel),
    );

    return (
      byId?.id ||
      byLabel?.id ||
      byFirebaseId?.id ||
      byRawField?.id ||
      String((workOrder as any)?.classificationId || (workOrder as any)?.dbData?.class_structure_id || "") ||
      ""
    );
  }, [classificationOptions, selectedClassificationId, workOrder]);
  const priorityOptions = useMemo(
    () => [...(priorityLevels?.[resolvedClientId] || [])].sort((a, b) => a.priority - b.priority),
    [priorityLevels, resolvedClientId],
  );
  // Default to view mode and switch to editable mode when user clicks Edit.
  const isViewOnlyMode = !isEditMode;
  // const description = (workOrder?.description_longdescription || "").replace(CommentRegEx, "");
  const addressId = workOrder?.locationData?.label ? workOrder?.locationData?.label : workOrder?.locationData?.address;
  const parentData = (workOrder as any)?.parentData as
    | {
        wonum?: string;
        description?: string;
        status_description?: string;
        wopriority_description?: string;
        wochildren?: WorkOrder[];
      }
    | undefined;
  const assignedVendorId =
    workOrder?.wpservice?.find((service) => service.vendor)?.vendor ||
    (workOrder as any)?.assigned_vendor_id ||
    (workOrder as any)?.assignedVendorId ||
    (workOrder as any)?.dbData?.assigned_vendor_id ||
    "";
  const assignedLaborCode =
    workOrder?.wplabor?.find((labor) => labor.laborcode)?.laborcode ||
    (workOrder as any)?.assigned_employee_labor_code ||
    (workOrder as any)?.assignedEmployeeLaborCode ||
    (workOrder as any)?.dbData?.assigned_employee_labor_code ||
    "";
  const getSelectionResourceId = (resource: any, kind: ResourceKind) => {
    if (kind === "vendor") {
      return String(resource?.vendorId || resource?.vendorid || resource?.id || "");
    }

    if (kind === "team_member") {
      return String(resource?.laborCode || resource?.laborcode || resource?.id || "");
    }

    return "";
  };
  const parentWonum = parentData?.wonum || (typeof workOrder?.parent === "string" ? workOrder.parent : "");
  const parentDescription = parentData?.description || "Untitled work order";
  // const parentStatus = parentData?.status_description || "Unknown";
  // const parentPriority = parentData?.wopriority_description || "—";
  const childWorkRequests = useMemo(() => {
    const source =
      workOrder?.wochildren && workOrder.wochildren.length > 0 ? workOrder.wochildren : parentData?.wochildren || [];

    return source.filter((child) => !child?.istask);
  }, [workOrder?.wochildren, parentData?.wochildren]);
  const hasParentWorkOrder = Boolean(parentWonum);
  const hasChildWorkRequests = childWorkRequests.length > 0;
  const assignedVendor = vendors.find(
    (vendor) =>
      String((vendor as any).vendorId || (vendor as any).vendorid || vendor.id || "") ===
      String(assignedVendorId || ""),
  );
  const assignedEmployee = employees.find((employee) => {
    const employeeLaborCode = String(employee.laborCode || (employee as any).laborcode || "");
    const employeeId = String(employee.id || "");
    const targetLaborCode = String(assignedLaborCode || "");
    const targetEmployeeId = String(
      (workOrder as any)?.assigned_employee_id ||
        (workOrder as any)?.assignedEmployeeId ||
        (workOrder as any)?.dbData?.assigned_employee_id ||
        "",
    );

    return (
      (targetLaborCode && employeeLaborCode === targetLaborCode) ||
      (targetEmployeeId && employeeId && employeeId === targetEmployeeId)
    );
  });
  const relatedVendorResources = useMemo(() => {
    const clientId = workOrder?.pluspcustomer?.customer;
    return vendors.filter((vendor) => {
      if (!clientId) return true;
      if (!Array.isArray(vendor.clients) || vendor.clients.length === 0) return true;
      return vendor.clients.includes(clientId);
    });
  }, [vendors, workOrder?.pluspcustomer?.customer]);
  const relatedTeamResources = useMemo(() => employees, [employees]);
  const resourceOptions = useMemo(() => {
    if (resourceKind === "vendor") {
      return relatedVendorResources;
    }
    if (resourceKind === "team_member") {
      return relatedTeamResources;
    }
    return [];
  }, [resourceKind, relatedVendorResources, relatedTeamResources]);
  const relatedResourceModalOptions = useMemo(
    () =>
      resourceOptions.map((resource: any) => ({
        id: getSelectionResourceId(resource, resourceKind),
        name: resource.displayName || "Unnamed",
        details:
          resourceKind === "vendor" ? `Vendor ID: ${resource.vendorId || "-"}` : resource.email || "No email on file",
      })),
    [resourceOptions, resourceKind],
  );
  const selectedResourceLabel = useMemo(() => {
    if (resourceKind === "none" || !resourceId) return "";
    const selectedResource = resourceOptions.find(
      (resource: any) => getSelectionResourceId(resource, resourceKind) === String(resourceId),
    );
    return selectedResource ? selectedResource.displayName || "Unnamed" : "";
  }, [resourceKind, resourceId, resourceOptions]);
  // const defaultApprovedCcEmails = useMemo(
  //   () => (Array.isArray(approvedCcOptions) ? approvedCcOptions : []).map((option) => option.email).filter(Boolean),
  //   [approvedCcOptions],
  // );
  // const approvedSenderEmails = useMemo(() => {
  //   return email ? [email] : [];
  // }, [email]);
  // const defaultIssueRecipients = useMemo(() => {
  //   if (assignedVendor?.contacts?.length) {
  //     return assignedVendor.contacts
  //       .map((contact) => contact.email)
  //       .filter(Boolean)
  //       .map((contactEmail) => contactEmail.trim());
  //   }

  //   if (assignedEmployee?.email) {
  //     return [assignedEmployee.email.trim()];
  //   }

  //   return [];
  // }, [assignedVendor, assignedEmployee]);
  // const issueActionLabel = assignedVendor
  //   ? "Issue Work Order to Vendor"
  //   : assignedEmployee
  //     ? "Issue Work Order to Team Member"
  //     : "Issue Work Order";
  // const issueActionContext = assignedVendor
  //   ? `Vendor selected: ${assignedVendor.displayName || assignedVendor.vendorId}`
  //   : assignedEmployee
  //     ? `Team member selected: ${assignedEmployee.displayName || assignedEmployee.laborCode}`
  //     : "No assigned resource found. You can still enter recipients manually.";
  // const description = (workOrder?.description_longdescription || "").replace(CommentRegEx, "");
  const assetLabel =
    (workOrder as any)?.assetnum || (workOrder as any)?.asset?.assetnum
      ? `${(workOrder as any)?.assetnum || (workOrder as any)?.asset?.assetnum}: ${(workOrder as any)?.asset_description || (workOrder as any)?.asset?.description || "Unnamed asset"}`
      : "No asset selected";
  const specificArea =
    (workOrder as any)?.specificArea ||
    (workOrder as any)?.pluspcspecificarea ||
    (workOrder as any)?.pluspspecificarea ||
    "N/A";
  const assigneeFallbackLabel =
    (workOrder as any)?.assigned_resource_name ||
    (workOrder as any)?.assigned_employee_display_name ||
    (workOrder as any)?.assigned_employee_name ||
    (workOrder as any)?.assigned_vendor_name ||
    (workOrder as any)?.dbData?.assigned_resource_name ||
    (workOrder as any)?.dbData?.assigned_employee_display_name ||
    (workOrder as any)?.dbData?.assigned_employee_name ||
    (workOrder as any)?.dbData?.assigned_vendor_name ||
    "";
  const assigneeLabel =
    assignedVendor?.displayName ||
    assignedEmployee?.displayName ||
    assignedVendor?.vendorId ||
    assignedEmployee?.laborCode ||
    assigneeFallbackLabel ||
    "Unassigned";
  const selectedPriorityLevel = priorityOptions.find(
    (priority) => String(priority.priority) === String(workOrder?.wopriority ?? ""),
  );
  const fallbackPriorityLevel =
    selectedPriorityLevel ||
    Object.values(priorityLevels || {})
      .flat()
      .filter((priority): priority is PriorityLevel => Boolean(priority))
      .find((priority) => String(priority.priority) === String(workOrder?.wopriority ?? ""));
  const priorityLabel =
    fallbackPriorityLevel?.name ||
    (workOrder as any)?.priority_description ||
    (workOrder as any)?.dbData?.priority_description ||
    workOrder?.wopriority_description ||
    "N/A";
  function normalizeLookupKey(value: unknown) {
    return String(value ?? "")
      .trim()
      .toLowerCase();
  }
  const attachmentDocuments = documents || [];
  const openAttachmentModal = () => {
    setPendingAttachmentFiles([]);
    setIsAttachmentModalOpen(true);
  };
  const closeAttachmentModal = () => {
    setIsAttachmentModalOpen(false);
    setPendingAttachmentFiles([]);
    if (detailsAttachmentInputRef.current) {
      detailsAttachmentInputRef.current.value = "";
    }
  };
  const openAttachmentPreview = (item: any) => {
    const buildAttachmentUrl = (attachmentItem: any) => {
      const query = [
        `workorderid=${String(workOrder?.workorderid || "")}`,
        `attachmentId=${attachmentItem?.attachmentId || ""}`,
        `fileName=${encodeURI(String(attachmentItem?.fileName || attachmentItem?.description || "attachment"))}`,
      ].join("&");

      return `${process.env.REACT_APP_FIREBASE_BASE_URL}/clientPortal-getMaximoAttachment?${query}`;
    };

    setSelectedAttachmentPreview({
      href: buildAttachmentUrl(item),
      label: getAttachmentLabel(item),
      isImage: isImageAttachment(item),
    });
    setIsAttachmentPreviewLoading(true);
  };
  const closeAttachmentPreview = () => {
    setSelectedAttachmentPreview(null);
    setIsAttachmentPreviewLoading(false);
  };
  const removePendingAttachmentFile = (indexToRemove: number) => {
    setPendingAttachmentFiles((currentFiles) => currentFiles.filter((_, index) => index !== indexToRemove));
    if (detailsAttachmentInputRef.current) {
      detailsAttachmentInputRef.current.value = "";
    }
  };
  const isImageAttachment = (item: any) =>
    /\.(jpg|jpeg|png|gif|webp|heic|heif|bmp|svg)$/i.test(String(item?.fileName || item?.description || ""));
  const getAttachmentLabel = (item: any) => String(item?.fileName || item?.description || "Attachment");
  const selectedClientName = useMemo(() => {
    const bySelectedId = clients.find((client) => String(client.id) === String(selectedClientId));
    if (bySelectedId?.name) return bySelectedId.name;

    const customerKey = String(workOrder?.pluspcustomer?.customer || "");
    const byCustomer = clients.find(
      (client) => String(client.customerId) === customerKey || String(client.id) === customerKey,
    );

    const byName = clients.find(
      (client) => normalizeLookupKey(client.name) === normalizeLookupKey(workOrder?.pluspcustomer?.name),
    );

    return byCustomer?.name || byName?.name || workOrder?.pluspcustomer?.name || "N/A";
  }, [clients, selectedClientId, workOrder?.pluspcustomer?.customer, workOrder?.pluspcustomer?.name]);
  const resolvedLocationId = useMemo(() => {
    if (selectedLocationId) return String(selectedLocationId);

    const existingLocationId = String(workOrder?.location || "");
    if (existingLocationId) return existingLocationId;

    const matchedLocation = locations.find(
      (location) =>
        String(location.id) === String(workOrder?.locationData?.label || "") ||
        normalizeLookupKey(location.label) === normalizeLookupKey(workOrder?.locationData?.label) ||
        normalizeLookupKey(location.address) === normalizeLookupKey(workOrder?.locationData?.address),
    );

    return matchedLocation?.id ? String(matchedLocation.id) : "";
  }, [
    locations,
    selectedLocationId,
    workOrder?.location,
    workOrder?.locationData?.address,
    workOrder?.locationData?.label,
  ]);
  const selectedLocationLabel = useMemo(() => {
    const currentLocationId = String(workOrder?.location || "");
    const byId = locations.find((loc) => String(loc.id) === currentLocationId);
    if (byId) return byId.label || byId.address || "N/A";

    return workOrder?.locationData?.label || workOrder?.locationData?.address || "N/A";
  }, [locations, workOrder?.location, workOrder?.locationData?.address, workOrder?.locationData?.label]);
  const selectedServiceTypeLabel = useMemo(() => {
    const activeServiceTypeId = selectedServiceTypeId || fallbackServiceTypeId;
    const bySelectedId = editableServiceTypeOptions.find((serviceType) => serviceType.id === activeServiceTypeId);
    if (bySelectedId?.label) return bySelectedId.label;

    const classificationNode = workOrder?.classstructure?.[0];
    const nestedNode = classificationNode?.classstructure?.[0];
    const nodes = [classificationNode, nestedNode].filter(Boolean) as Array<{ description?: string }>;
    const byNodeLabel = editableServiceTypeOptions.find((serviceType) =>
      nodes.some((node) => normalizeLookupKey(serviceType.label) === normalizeLookupKey(node.description)),
    );
    if (byNodeLabel?.label) return byNodeLabel.label;

    const rawServiceType = String((workOrder as any)?.serviceType || "");
    const byRawField = editableServiceTypeOptions.find(
      (serviceType) =>
        serviceType.id === rawServiceType ||
        normalizeLookupKey(serviceType.label) === normalizeLookupKey(rawServiceType),
    );

    return (
      byRawField?.label || String((workOrder as any)?.dbData?.service_type_name || "") || nodes[0]?.description || "N/A"
    );
  }, [editableServiceTypeOptions, fallbackServiceTypeId, selectedServiceTypeId, workOrder]);
  // const selectedClassificationLabel = useMemo(() => {
  //   const activeClassificationId = selectedClassificationId || fallbackClassificationId;
  //   const bySelectedId = classificationOptions.find((classification) => classification.id === activeClassificationId);
  //   if (bySelectedId?.label) return bySelectedId.label;

  //   const classificationNode = workOrder?.classstructure?.[0];
  //   const nestedNode = classificationNode?.classstructure?.[0];
  //   const nodes = [classificationNode, nestedNode].filter(Boolean) as Array<{ description?: string }>;
  //   const byNodeLabel = classificationOptions.find((classification) =>
  //     nodes.some((node) => normalizeLookupKey(classification.label) === normalizeLookupKey(node.description)),
  //   );
  //   if (byNodeLabel?.label) return byNodeLabel.label;

  //   const rawClassification = String((workOrder as any)?.classification || "");
  //   const byRawField = classificationOptions.find(
  //     (classification) =>
  //       classification.id === rawClassification ||
  //       normalizeLookupKey(classification.label) === normalizeLookupKey(rawClassification),
  //   );

  //   const byFirebaseLabel = getClassificationLabelFromFirebase(
  //     String((workOrder as any)?.classificationId || (workOrder as any)?.dbData?.class_structure_id || ""),
  //     String((workOrder as any)?.serviceTypeId || (workOrder as any)?.dbData?.service_type_id || ""),
  //     rawClassification,
  //   );

  //   return (
  //     byRawField?.label ||
  //     byFirebaseLabel ||
  //     String((workOrder as any)?.dbData?.classification_name || "") ||
  //     nodes[0]?.description ||
  //     "N/A"
  //   );
  // }, [classificationOptions, fallbackClassificationId, selectedClassificationId, workOrder]);
  const selectedWorkTypeLabel = useMemo(() => {
    const byType = workTypes.find((workType) => workType.type === workOrder?.worktype);
    return byType?.name || workOrder?.workType || "N/A";
  }, [workTypes, workOrder?.workType, workOrder?.worktype]);
  const selectedStatusLabel = useMemo(() => {
    const byCode = statusList.find((statusOption) => String(statusOption.id) === String(workOrder?.status || ""));
    return byCode?.value || workOrder?.status_description || workOrder?.status || "N/A";
  }, [statusList, workOrder?.status, workOrder?.status_description]);

  // const statusCatalog = useMemo(
  //   () => [
  //     { label: "New", fallbackKeys: ["NEW"] },
  //     {
  //       label: "Waiting to be Scheduled",
  //       fallbackKeys: ["WTBS", "WTS", "WAITING_TO_BE_SCHEDULED"],
  //     },
  //     { label: "In Progress", fallbackKeys: ["INPRG"] },
  //     { label: "Scheduled", fallbackKeys: ["WSCH"] },
  //     { label: "Approval Required", fallbackKeys: ["WAPPR", "APPROVAL_REQUIRED"] },
  //     {
  //       label: "Client Approval Required",
  //       fallbackKeys: ["CLIENT_APPROVAL_REQUIRED", "CLNTAPPRREQ", "CAPPRREQ"],
  //     },
  //     { label: "Approved", fallbackKeys: ["APPR"] },
  //     { label: "Client Approved", fallbackKeys: ["CLIENT_APPROVED", "CLNTAPPR", "CAPPR"] },
  //     { label: "Rejected", fallbackKeys: ["REJECTED", "REJ"] },
  //     { label: "Client Rejected", fallbackKeys: ["CLIENT_REJECTED", "CLNTREJ", "CREJ"] },
  //     { label: "Revision Required", fallbackKeys: ["REVREQ", "REVISION_REQUIRED"] },
  //     { label: "Completed", fallbackKeys: ["COMP"] },
  //     { label: "Cancelled", fallbackKeys: ["CAN"] },
  //   ],
  //   [],
  // );

  const currentStatusCode = useMemo(
    () =>
      String(workOrder?.status || "")
        .trim()
        .toUpperCase(),
    [workOrder?.status],
  );

  const statusHighlightTone = useMemo(
    () => resolveStatusHighlightTone(currentStatusCode, selectedStatusLabel),
    [currentStatusCode, selectedStatusLabel],
  );

  const statusTransitionItems = useMemo(() => {
    const seenCodes = new Set<string>();

    return statusList
      .map((statusOption) => {
        const nextCode = String(statusOption.id || "")
          .trim()
          .toUpperCase();
        const nextLabel = String(statusOption.value || nextCode || "").trim();

        return {
          key: nextCode || nextLabel,
          code: nextCode,
          label: nextLabel,
          displayLabel: nextLabel,
          isCurrent: nextCode === currentStatusCode,
          isAvailable: Boolean(nextCode),
        };
      })
      .filter((item) => {
        if (!item.code || seenCodes.has(item.code)) {
          return false;
        }

        seenCodes.add(item.code);
        return true;
      });
  }, [currentStatusCode, statusList]);

  // const resolveStatusCatalogLabel = (value: string) => {
  //   const normalizedValue = normalizeLookupKey(value);
  //   if (!normalizedValue) return "";

  //   const byExactLabel = statusCatalog.find((item) => normalizeLookupKey(item.label) === normalizedValue);
  //   if (byExactLabel) return byExactLabel.label;

  //   const byIncludedLabel = statusCatalog.find((item) => {
  //     const normalizedLabel = normalizeLookupKey(item.label);
  //     return normalizedValue.includes(normalizedLabel) || normalizedLabel.includes(normalizedValue);
  //   });
  //   if (byIncludedLabel) return byIncludedLabel.label;

  //   const upperValue = value.trim().toUpperCase();
  //   const byCode = statusCatalog.find((item) => item.fallbackKeys.some((fallbackKey) => fallbackKey === upperValue));
  //   if (byCode) return byCode.label;

  //   return "";
  // };

  // const statusFlowLabels = useMemo(() => {
  //   const labels: string[] = [];
  //   const pushUnique = (label: string) => {
  //     if (!label || labels.includes(label)) return;
  //     labels.push(label);
  //   };

  //   // Every work order starts at New, so always anchor the stepper there.
  //   pushUnique(resolveStatusCatalogLabel("NEW") || "New");

  //   const patterns = [/status changed to\s+(.+?)(?:\.|$)/i, /changed from\s+.+?\s+to\s+(.+?)(?:\.|$)/i];

  //   timelineEntries.forEach((entry) => {
  //     const eventText = String(entry.event || "").trim();
  //     if (!eventText) return;

  //     for (const pattern of patterns) {
  //       const match = eventText.match(pattern);
  //       if (!match?.[1]) continue;

  //       const catalogLabel = resolveStatusCatalogLabel(match[1]);
  //       if (catalogLabel) {
  //         pushUnique(catalogLabel);
  //       }
  //       break;
  //     }
  //   });

  //   const currentCatalogLabel =
  //     resolveStatusCatalogLabel(currentStatusCode) ||
  //     resolveStatusCatalogLabel(selectedStatusLabel) ||
  //     selectedStatusLabel;
  //   pushUnique(currentCatalogLabel);

  //   const withoutCompleted = labels.filter((label) => normalizeLookupKey(label) !== "completed");
  //   return [...withoutCompleted, "Completed"];
  // }, [currentStatusCode, selectedStatusLabel, statusCatalog, timelineEntries]);

  // const statusStepperItems = useMemo(
  //   () =>
  //     statusFlowLabels.map((label, index) => ({
  //       key: `${label}-${index}`,
  //       label,
  //       isCurrent: index === Math.max(0, statusFlowLabels.length - 2),
  //     })),
  //   [statusFlowLabels],
  // );

  const availableSidebarTransitions = useMemo(() => {
    const seenCodes = new Set<string>();

    return statusTransitionItems.filter((item) => {
      if (!item.isAvailable || !item.code || item.isCurrent) {
        return false;
      }

      if (seenCodes.has(item.code)) {
        return false;
      }

      seenCodes.add(item.code);
      return true;
    });
  }, [statusTransitionItems]);

  const moveToSidebarOptions = useMemo(() => {
    const seenCodes = new Set<string>();

    return statusTransitionItems.filter((item) => {
      if (item.isCurrent || !item.code) {
        return false;
      }

      if (seenCodes.has(item.code)) {
        return false;
      }

      seenCodes.add(item.code);
      return true;
    });
  }, [statusTransitionItems]);

  // const activeStatusIndex = useMemo(() => statusStepperItems.findIndex((item) => item.isCurrent), [statusStepperItems]);

  useEffect(() => {
    if (!moveToSidebarOptions.length) {
      setSelectedSidebarStatusCode("");
      return;
    }

    setSelectedSidebarStatusCode((prev) => {
      if (prev && moveToSidebarOptions.some((item) => item.code === prev)) {
        return prev;
      }

      return moveToSidebarOptions[moveToSidebarOptions.length - 2].code;
    });
  }, [moveToSidebarOptions]);

  const updateDraftIdentifiers = (
    nextWorkOrder?: ExtendedWorkOrder,
    nextClients: Client[] = clients,
    nextServiceTypes: ServiceTypeList | undefined = serviceTypes,
  ) => {
    if (!nextWorkOrder) return;

    const matchedClient = nextClients.find(
      (client) =>
        String(client.customerId) === String(nextWorkOrder.pluspcustomer?.customer || "") ||
        String(client.id) === String(nextWorkOrder.pluspcustomer?.customer || ""),
    );
    const nextClientId = matchedClient ? String(matchedClient.id) : "";

    const classificationNode = nextWorkOrder.classstructure?.[0];
    const nestedNode = classificationNode?.classstructure?.[0];
    const nodes = [classificationNode, nestedNode].filter(Boolean) as Array<{
      classstructureid?: string;
      description?: string;
    }>;

    const serviceTypePool = nextServiceTypes?.[nextClientId] || [];
    const matchedServiceType = serviceTypePool.find((serviceType) =>
      nodes.some(
        (node) =>
          serviceType.id === node.classstructureid ||
          normalizeLookupKey(serviceType.description || serviceType.name) === normalizeLookupKey(node.description),
      ),
    );
    const nextServiceTypeId =
      matchedServiceType?.id ||
      String((nextWorkOrder as any)?.serviceTypeId || (nextWorkOrder as any)?.serviceType || "") ||
      "";
    const matchedClassification = objToArray(matchedServiceType?.classifications, (item, id) => ({
      ...(item || {}),
      id,
    })).find(
      (classification) =>
        classification.classstructureid === classificationNode?.classstructureid ||
        classification.classstructureid === nestedNode?.classstructureid ||
        normalizeLookupKey(classification.description || classification.name) ===
          normalizeLookupKey(classificationNode?.description) ||
        normalizeLookupKey(classification.description || classification.name) ===
          normalizeLookupKey(nestedNode?.description),
    );

    const nextServiceTypeLabel =
      matchedServiceType?.description || matchedServiceType?.name || String((nextWorkOrder as any)?.serviceType || "");
    const nextClassificationLabel =
      matchedClassification?.description ||
      matchedClassification?.name ||
      String((nextWorkOrder as any)?.classification || "") ||
      getClassificationLabelFromFirebase(
        String((nextWorkOrder as any)?.classificationId || (nextWorkOrder as any)?.dbData?.class_structure_id || ""),
        String((nextWorkOrder as any)?.serviceTypeId || (nextWorkOrder as any)?.dbData?.service_type_id || ""),
        String((nextWorkOrder as any)?.classification || ""),
      ) ||
      classificationNode?.description ||
      nestedNode?.description ||
      "";

    if (nextClientId) {
      setSelectedClientId(nextClientId);
    }
    const nextLocationId =
      locations.find(
        (location) =>
          String(location.id) === String(nextWorkOrder.location || "") ||
          normalizeLookupKey(location.label) === normalizeLookupKey(nextWorkOrder.locationData?.label) ||
          normalizeLookupKey(location.address) === normalizeLookupKey(nextWorkOrder.locationData?.address),
      )?.id || "";
    if (nextLocationId) {
      setSelectedLocationId(String(nextLocationId));
    }
    if (nextServiceTypeId) {
      setSelectedServiceTypeId(nextServiceTypeId);
    }
    const nextClassificationId =
      matchedClassification?.classstructureid ||
      String((nextWorkOrder as any)?.classificationId || (nextWorkOrder as any)?.classification || "") ||
      "";
    if (nextClassificationId) {
      setSelectedClassificationId(nextClassificationId);
    }
    setFormData((data) => ({
      ...data,
      serviceType: nextServiceTypeLabel,
      classification: nextClassificationLabel,
    }));
  };

  const parsedCreatedDate = useMemo(
    () => parseDateToFormat(workOrder?.reportdate as string, "MMMM Do YYYY, h:mm A"),
    [workOrder],
  );

  // CAP / critical gate — mirrors Kori's cap/capFiled/showCriticalGate
  // const capDoc = documents?.find((d: any) => d.type === "corrective_action_plan");
  // const capFiled = (capDoc as any)?.status === "filed";
  // const isCritical =
  //   workOrder?.wopriority_description?.toLowerCase() === "emergency" ||
  //   workOrder?.wopriority_description?.toLowerCase() === "critical";
  // const isCompleted = workOrder?.status === "CLOSE" || workOrder?.status === "COMP";
  // const showCriticalGate = isCritical && !isCompleted;

  // Next statuses — mirrors Kori's next[]
  // We derive the "primary next action label" from Maximo status flow.
  // const hasAssignee = !!workOrder?.wplabor?.find((l) => l.laborcode) || !!workOrder?.wpservice?.find((s) => s.vendor);
  const isConcern = workOrder?.request_type === "service_concern";

  // Billing
  // const isClientBilled = workOrder?.billable_type === "client" || workOrder?.billable_type === "both";
  // const isKsiOnly = workOrder?.billable_type === "ksi";
  const showBilling = !isConcern && !isTechnician;
  const hasAuthenticatedPortalUser = Boolean(clientUserId || email);
  const canEditWorkOrderFields = hasAuthenticatedPortalUser && !isNoAuthWorkRequest;

  const isFieldEditable = (fieldKey: EditableFieldKey) =>
    isSchedulingFieldEditable(fieldKey, canEditWorkOrderFields, isEditMode);

  const startFieldEdit = (fieldKey: EditableFieldKey) => {
    if (!canEditWorkOrderFields) return;
    setEditableField(fieldKey);
  };

  const finishFieldEdit = () => {
    setEditableField(null);
  };

  const toggleEditMode = async () => {
    if (!canEditWorkOrderFields || isSavingEdits || isEditLockLoading) return;

    if (isEditMode) {
      await releaseWorkOrderEditLock({
        silent: true,
        force: true,
        wonum: workOrder?.wonum,
        workOrderId: workOrder?.workorderid,
      });
      setIsEditMode(false);
      setPendingEditPatch({});
      setPendingResourceAssignment(null);
      setEditableField(null);
      setError("");
      void fetchData();
      return;
    }

    const lockAcquired = await acquireWorkOrderEditLock();
    if (!lockAcquired) {
      return;
    }

    setError("");
    setSelectedClientId(resolvedClientId);
    setSelectedLocationId(resolvedLocationId);
    setSelectedServiceTypeId(fallbackServiceTypeId);
    setSelectedClassificationId(fallbackClassificationId);
    setIsEditMode(true);
  };

  const hasPendingEdits = Object.keys(pendingEditPatch).length > 0 || !!pendingResourceAssignment;

  const normalizeEditPatch = (patch: Record<string, unknown>) => {
    const normalizedPatch: Record<string, unknown> = { ...patch };

    if ("schedstart" in normalizedPatch) {
      normalizedPatch.targstartdate = normalizedPatch.schedstart;
      delete normalizedPatch.schedstart;
    }

    if ("schedfinish" in normalizedPatch) {
      normalizedPatch.targcompdate = normalizedPatch.schedfinish;
      delete normalizedPatch.schedfinish;
    }

    if ("client" in normalizedPatch) {
      const clientValue = normalizedPatch.client as
        | { id?: string; clientId?: string; customerId?: string; customer?: string; name?: string }
        | string
        | null
        | undefined;

      const nextCustomerId =
        typeof clientValue === "string"
          ? clientValue
          : String(clientValue?.customerId || clientValue?.customer || clientValue?.id || "");
      const nextClientId =
        typeof clientValue === "string" ? "" : String(clientValue?.id || clientValue?.clientId || "");

      if (nextCustomerId) {
        normalizedPatch.pluspinsertcustomer = nextCustomerId;
        normalizedPatch.customer = nextCustomerId;
      }

      if (nextClientId) {
        normalizedPatch.clientId = nextClientId;
      }

      delete normalizedPatch.client;
    }

    if ("priorityName" in normalizedPatch && !("priority_description" in normalizedPatch)) {
      normalizedPatch.priority_description = normalizedPatch.priorityName;
    }

    if ("wopriority_description" in normalizedPatch && !("priority_description" in normalizedPatch)) {
      normalizedPatch.priority_description = normalizedPatch.wopriority_description;
    }

    if ("priority_description" in normalizedPatch && !("wopriority_description" in normalizedPatch)) {
      normalizedPatch.wopriority_description = normalizedPatch.priority_description;
    }

    return normalizedPatch;
  };

  const stageWorkOrderChanges = (patch: Record<string, unknown>, localPatch?: Record<string, unknown>) => {
    const normalizedPatch = normalizeEditPatch(patch);

    setPendingEditPatch((prev) => ({ ...prev, ...normalizedPatch }));
    setWorkOrder((prev) => (prev ? ({ ...prev, ...(localPatch || patch) } as ExtendedWorkOrder) : prev));
    setError("");

    return true;
  };

  const stageTextFieldChange = (fieldName: string, value: string) => {
    stageWorkOrderChanges({ [fieldName]: value }, { [fieldName]: value });
  };

  const buildPendingEditTimelineMessage = (patch: Record<string, unknown>) => {
    const changes: string[] = [];
    const changedKeys = new Set(Object.keys(patch));

    const clientChanged =
      changedKeys.has("clientId") || changedKeys.has("customer") || changedKeys.has("pluspinsertcustomer");
    const locationChanged = changedKeys.has("location");

    if (clientChanged) {
      changes.push(`Client changed to ${selectedClientName || "N/A"}`);
    }

    if (locationChanged) {
      changes.push(`Location changed to ${selectedLocationLabel || "N/A"}`);
    }

    if (changedKeys.has("classstructureid") && selectedServiceTypeLabel && selectedServiceTypeLabel !== "N/A") {
      changes.push(`Service type changed to ${selectedServiceTypeLabel}`);
    }

    const skippedKeys = new Set(["clientId", "customer", "pluspinsertcustomer", "location", "classstructureid"]);

    const fieldLabels: Record<string, string> = {
      description: "Title",
      description_longdescription: "Description",
      worktype: "Work Type",
      wopriority: "Priority",
      status: "Status",
      targstartdate: "Scheduled Start",
      targcompdate: "Scheduled Finish",
      actstart: "Actual Start",
      actfinish: "Actual Finish",
      siteid: "Site",
      parent: "Parent Work Order",
      assetnum: "Asset",
      pluspspecificarea: "Specific Area",
      billable_type: "Billable Type",
      estmatcost: "Estimated Cost",
      vendor_cost: "Vendor Cost",
      client_markup_pct: "Markup %",
      client_billing_mode: "Client Billing Mode",
      client_fixed_amount: "Client Fixed Amount",
      client_approval_status: "Client Approval",
      client_po_number: "Client PO Number",
      requires_quote: "Requires Quote",
    };

    const additionalFields = Array.from(changedKeys)
      .filter((key) => !skippedKeys.has(key))
      .map((key) => fieldLabels[key] || key)
      .filter(Boolean);

    if (additionalFields.length) {
      changes.push(`Updated ${additionalFields.join(", ")}`);
    }

    if (!changes.length) {
      return "Updated work order details.";
    }

    return changes.join(". ") + ".";
  };

  const buildResourceAssignmentTimelineMessage = (assignment: PendingResourceAssignment | null) => {
    if (!assignment) {
      return "";
    }

    if (assignment.vendorId) {
      return `Assigned vendor ${assignment.vendorId}.`;
    }

    if (assignment.laborCode) {
      return `Assigned team member ${assignment.laborCode}.`;
    }

    if (assignment.vendorId === "" && assignment.laborCode === "") {
      return "Cleared related resource assignment.";
    }

    return "";
  };

  const applyStatusTransitionIfNeeded = async (patch: Record<string, unknown>) => {
    const requestedStatus = patch.status;
    const nextStatus = requestedStatus !== undefined && requestedStatus !== null ? String(requestedStatus) : "";
    const currentStatus = String(workOrder?.status || "");

    if (!workOrder?.wonum || !nextStatus || nextStatus === currentStatus) {
      return;
    }

    const selectedOption = statusList.find((statusOption) => String(statusOption.id) === String(nextStatus));
    const nextStatusDescription = String(selectedOption?.value || patch.status_description || "").trim();

    const transitionResponse = await FirebaseDataService.updateWorkOrderStatus(
      String(workOrder.wonum),
      nextStatus,
      String(email || clientUserId || ""),
      nextStatusDescription,
    );

    if (transitionResponse.status === "error") {
      throw new Error(transitionResponse.message || "Unable to update work order status.");
    }
  };

  const savePendingWorkOrderChanges = async () => {
    if (!workOrder?.wonum || !hasPendingEdits || isSavingEdits || isWorkOrderLockedByAnotherUser) return;

    const latestLock = await getLatestWorkOrderEditLock({ suppressErrors: true });
    if (latestLock?.isLocked && !isLockOwnedByCurrentUser(latestLock)) {
      const lockOwner = String(
        latestLock.lockedByUserName || latestLock.lockedByUserId || workOrderLockOwner || "",
      ).trim();
      setError(getWorkOrderLockedMessage(lockOwner));
      return;
    }

    const pendingPatchSnapshot = { ...pendingEditPatch };
    const pendingResourceSnapshot = pendingResourceAssignment ? { ...pendingResourceAssignment } : null;

    setIsSavingEdits(true);
    try {
      await applyStatusTransitionIfNeeded(pendingPatchSnapshot);
      delete pendingPatchSnapshot.status;
      delete pendingPatchSnapshot.status_description;

      if (pendingResourceSnapshot) {
        const assignResponse = await FirebaseDataService.assignResourceInWorkOrder({
          wonum: workOrder.wonum,
          approvedamount: pendingResourceSnapshot.approvedamount,
          vendorId: pendingResourceSnapshot.vendorId,
          vendorName: pendingResourceSnapshot.vendorName,
          woacceptscharges: pendingResourceSnapshot.woacceptscharges,
          laborCode: pendingResourceSnapshot.laborCode,
          managerId: clientUserId,
          assignedEmployee: pendingResourceSnapshot.assignedEmployee,
        });

        if (assignResponse.status === "error") {
          throw new Error(assignResponse.message || "Unable to save resource assignment.");
        }
      }

      if (Object.keys(pendingPatchSnapshot).length > 0) {
        const response = await FirebaseDataService.editWorkOrder({
          workOrderId: workOrder.workorderid,
          wonum: workOrder.wonum,
          changedBy: String(clientUserId || ""),
          patch: pendingPatchSnapshot,
        });

        if (response.status === "error") {
          throw new Error(response.message || "Unable to save work order changes.");
        }
      }

      const mergedWorkOrder = { ...workOrder, ...pendingPatchSnapshot } as ExtendedWorkOrder;
      const vendorCost = Number((mergedWorkOrder as any)?.vendor_cost || mergedWorkOrder.estmatcost || 0);

      if (vendorCost > 0) {
        const selectedLocation = locations.find((location) => String(location.id) === String(mergedWorkOrder.location));
        const resolvedLocationName =
          selectedLocation?.label ||
          mergedWorkOrder.locationData?.label ||
          selectedLocation?.address ||
          mergedWorkOrder.locationData?.address ||
          String(mergedWorkOrder.location || "");
        const resolvedShippingAddress =
          selectedLocation?.address ||
          mergedWorkOrder.locationData?.address ||
          selectedLocation?.label ||
          mergedWorkOrder.locationData?.label ||
          String(mergedWorkOrder.location || "");
        const fallbackApprover = [firstName, lastName].filter(Boolean).join(" ").trim();

        try {
          await FirebaseDataService.ensurePurchaseOrderForWorkOrder(clientUserId, !!isManager, {
            documentType: "purchase_order",
            status: "draft",
            companyName: selectedClientName || mergedWorkOrder.pluspcustomer?.name || "",
            locationName: resolvedLocationName,
            billingAddress: "",
            shippingAddress: resolvedShippingAddress,
            contact: {
              name: fallbackApprover,
              phone: "",
              email: email || "",
            },
            vendorName: assignedVendor?.displayName || assignedVendor?.vendorId || "",
            vendorAddress: "",
            vendorContactInfo: "",
            vendorId: assignedVendor?.vendorId || "",
            lineItems: [
              {
                id: "1",
                description: mergedWorkOrder.description || "Work request service",
                sku: "",
                quantity: 1,
                unitOfMeasure: "EA",
                unitPrice: vendorCost,
                lineTotal: vendorCost,
              },
            ],
            subtotal: vendorCost,
            tax: 0,
            shippingCost: 0,
            totalAmount: vendorCost,
            requestedDeliveryDate: mergedWorkOrder.schedfinish || "",
            approverName: fallbackApprover,
            notes:
              mergedWorkOrder.description_longdescription ||
              mergedWorkOrder.description ||
              "Auto-generated from Billing and Procurement.",
            linkedWorkOrderId: String(mergedWorkOrder.workorderid || ""),
            linkedWonum: String(mergedWorkOrder.wonum || ""),
            source: "work_request_auto",
          });
        } catch (autoPoError) {
          console.error("Failed to auto-create purchase order from work order update:", autoPoError);
        }
      }

      const timelineMessages = [
        Object.keys(pendingPatchSnapshot).length > 0 ? buildPendingEditTimelineMessage(pendingPatchSnapshot) : "",
        buildResourceAssignmentTimelineMessage(pendingResourceSnapshot),
      ].filter(Boolean);
      try {
        for (const timelineMessage of timelineMessages) {
          await logTimelineActivity(timelineMessage);
        }
      } catch (_) {
        // Keep save success even if timeline logging fails.
      }

      setPendingEditPatch({});
      setPendingResourceAssignment(null);
      setIsEditMode(false);
      finishFieldEdit();
      await releaseWorkOrderEditLock({
        silent: true,
        force: true,
        wonum: workOrder.wonum,
        workOrderId: workOrder.workorderid,
      });
      await fetchData();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Unable to save work order changes.");
    } finally {
      setIsSavingEdits(false);
    }
  };

  const saveWorkOrderChanges = async (
    patch: Record<string, unknown>,
    options?: { message?: string; errorMessage?: string },
  ) => {
    if (!workOrder?.wonum) return false;

    const latestLock = await getLatestWorkOrderEditLock({ suppressErrors: true });
    if (latestLock?.isLocked && !isLockOwnedByCurrentUser(latestLock)) {
      const lockOwner = String(
        latestLock.lockedByUserName || latestLock.lockedByUserId || workOrderLockOwner || "",
      ).trim();
      setError(getWorkOrderLockedMessage(lockOwner));
      return false;
    }

    if (isWorkOrderLockedByAnotherUser) {
      setError(workOrderLockMessage || getWorkOrderLockedMessage(workOrderLockOwner));
      return false;
    }

    try {
      const normalizedPatch = normalizeEditPatch(patch);

      await applyStatusTransitionIfNeeded(normalizedPatch);
      delete normalizedPatch.status;
      delete normalizedPatch.status_description;

      const response = await FirebaseDataService.editWorkOrder({
        workOrderId: workOrder.workorderid,
        wonum: workOrder.wonum,
        changedBy: String(clientUserId || ""),
        patch: normalizedPatch,
      });
      if (response.status === "error") {
        throw new Error(response.message || options?.errorMessage || "Unable to save work order changes.");
      }

      setWorkOrder((prev) => (prev ? ({ ...prev, ...patch, ...normalizedPatch } as ExtendedWorkOrder) : prev));

      if (options?.message) {
        await logTimelineActivity(options.message);
      }

      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : options?.errorMessage || "Unable to save work order changes.");
      return false;
    }
  };

  // ─── Data helpers ─────────────────────────────────────────────────────────

  const getClientApprovalStatuses = async () => {
    try {
      const { success, data } = await FirebaseDataService.getClientApproveStatuses();
      if (success) setClientApprovalStatuses(data);
    } catch (_) {}
  };

  // const fetchApprovedCcEmailsForIssue = async () => {
  //   try {
  //     const response = await FirebaseDataService.getApprovedCcEmailsForIssue();
  //     const responseAny: any = response;
  //     const source = Array.isArray(responseAny)
  //       ? responseAny
  //       : Array.isArray(responseAny?.data)
  //         ? responseAny.data
  //         : Array.isArray(responseAny?.data?.data)
  //           ? responseAny.data.data
  //           : [];

  //     const normalizedOptions = source
  //       .filter((item: any) => item && typeof item.email === "string")
  //       .map((item: any) => ({ email: item.email, label: item.label }));

  //     setApprovedCcOptions(normalizedOptions);
  //   } catch (_) {
  //     setApprovedCcOptions([]);
  //   }
  // };

  const buildPhotoUrl = (photo: any, workorderid: number) => {
    const q = [
      `workorderid=${String(workorderid)}`,
      `attachmentId=${photo.attachmentId}`,
      `fileName=${encodeURI(photo.fileName)}`,
    ].join("&");
    return `${process.env.REACT_APP_FIREBASE_BASE_URL}/clientPortal-getMaximoAttachment?${q}`;
  };

  const normalizeClients = (rawClients: unknown): Client[] => {
    if (Array.isArray(rawClients)) {
      return rawClients
        .filter((client): client is Client => !!client)
        .map((client: any) => ({
          ...client,
          id: String(client.id || ""),
          customerId: String(client.customerId || client.customer || client.customerid || ""),
          name: client.name || client.companyName || "",
        }))
        .filter((client) => !!client.id || !!client.name);
    }

    if (rawClients && typeof rawClients === "object") {
      return objToArray(rawClients as Record<string, any>, (client, id) => ({
        ...(client || {}),
        id: String(client?.id || id || ""),
        customerId: String(client?.customerId || client?.customer || client?.customerid || ""),
        name: client?.name || client?.companyName || "",
      })).filter((client) => !!client.id || !!client.name);
    }

    return [];
  };

  const normalizeEmployees = (rawEmployees: unknown): ActiveEmployee[] => {
    if (!Array.isArray(rawEmployees)) {
      return [];
    }

    return rawEmployees
      .filter((employee): employee is Record<string, unknown> => !!employee && typeof employee === "object")
      .map((employee) => {
        const laborCode = String(employee.laborCode || employee.laborcode || "");
        const id = String(employee.id || employee.employeeId || "");
        const displayName = String(
          employee.displayName ||
            employee.displayname ||
            employee.name ||
            [employee.firstName, employee.lastName].filter(Boolean).join(" ") ||
            laborCode ||
            id ||
            "",
        );

        return {
          ...employee,
          id,
          laborCode,
          displayName,
          email: String(employee.email || "") || undefined,
        };
      })
      .filter((employee) => !!employee.id || !!employee.laborCode);
  };

  const normalizeVendors = (rawVendors: unknown): ActiveVendor[] => {
    if (!Array.isArray(rawVendors)) {
      return [];
    }

    return rawVendors
      .filter((vendor): vendor is Record<string, unknown> => !!vendor && typeof vendor === "object")
      .map((vendor) => {
        const vendorId = String(vendor.vendorId || vendor.vendorid || vendor.id || "");
        const id = String(vendor.id || vendorId || "");
        const displayName = String(
          vendor.displayName || vendor.displayname || vendor.vendorName || vendor.name || vendorId,
        );

        return {
          ...vendor,
          id,
          vendorId,
          displayName,
          contacts: Array.isArray(vendor.contacts) ? (vendor.contacts as ActiveVendor["contacts"]) : [],
          clients: Array.isArray(vendor.clients) ? vendor.clients.map((clientId) => String(clientId)) : [],
        };
      })
      .filter((vendor) => !!vendor.id || !!vendor.vendorId);
  };

  const normalizeLocations = (rawLocations: unknown): DBLocation[] => {
    if (Array.isArray(rawLocations)) {
      return rawLocations
        .filter((location): location is DBLocation => !!location)
        .map((location: any) => ({
          ...location,
          id: String(location.id || ""),
          clientId: String(location.clientId || ""),
        }))
        .filter((location) => !!location.id);
    }

    if (rawLocations && typeof rawLocations === "object") {
      return objToArray(rawLocations as Record<string, any>, (location, id) => ({
        ...(location || {}),
        id: String(location?.id || id || ""),
        clientId: String(location?.clientId || ""),
      })).filter((location) => !!location.id);
    }

    return [];
  };

  const applyFetchedData = async (viewTicketData: any) => {
    if (!viewTicketData) return;
    // if (viewTicketData.locationTimezone) setTimezone(viewTicketData.locationTimezone);
    const woid = viewTicketData.workOrder?.workorderid;
    setClientPhotos(viewTicketData.attachments.clientPhotos.map((p: any) => buildPhotoUrl(p, woid)));
    // setTechnicianPhotos(viewTicketData.attachments.technicianPhotos.map((p: any) => buildPhotoUrl(p, woid)));
    await getClientApprovalStatuses();

    let normalizedClients = normalizeClients(viewTicketData.clients);
    let normalizedLocations = normalizeLocations(viewTicketData.locations);
    let normalizedServiceTypes = normalizeServiceTypes(viewTicketData.serviceTypes, clientUserId);
    let normalizedPriorityLevels = viewTicketData.priorityLevels;
    let normalizedWorkTypes = viewTicketData.workTypes;

    if (
      !isNoAuthWorkRequest &&
      viewTicketData.workOrder?.wonum &&
      (!normalizedClients.length || !normalizedLocations.length)
    ) {
      try {
        const { data: createTicketData } = await FirebaseDataService.getDataForTicketCreateForm(
          String(viewTicketData.workOrder.wonum),
          clientUserId,
          isManager,
        );

        if (!normalizedClients.length) {
          normalizedClients = normalizeClients(createTicketData?.clients);
        }

        if (!normalizedLocations.length) {
          normalizedLocations = normalizeLocations(createTicketData?.locations);
        }

        normalizedServiceTypes =
          normalizedServiceTypes || normalizeServiceTypes(createTicketData?.serviceTypes, clientUserId);
        normalizedPriorityLevels = normalizedPriorityLevels || createTicketData?.priorityLevels;
        if (!Array.isArray(normalizedWorkTypes) || !normalizedWorkTypes.length) {
          normalizedWorkTypes = createTicketData?.workTypes;
        }
      } catch (_) {
        // Keep view-form payload as source of truth if fallback request fails.
      }
    }

    setClients(normalizedClients);
    setLocations(normalizedLocations);
    setServiceTypes(normalizedServiceTypes);
    setPriorityLevels(normalizedPriorityLevels);
    setStatusList(viewTicketData.statusList || []);
    setWorkOrder(normalizeWorkOrderForView(viewTicketData.workOrder, viewTicketData.procurement));
    setWorkTypes(normalizedWorkTypes);
    // setWorklog(viewTicketData.technicianNotesWorklog);
    // setPriorityLevel(viewTicketData.priorityLevel);
    setDocuments(viewTicketData.attachments.documents);
    // setCustomWorkRequestFields(viewTicketData.customWorkRequestFields);
    setEmployees(normalizeEmployees(viewTicketData.employees));
    setVendors(normalizeVendors(viewTicketData.vendors));
    updateDraftIdentifiers(
      normalizeWorkOrderForView(viewTicketData.workOrder, viewTicketData.procurement),
      normalizedClients,
      normalizedServiceTypes,
    );
    // Load timeline
    if (viewTicketData.workOrder?.wonum) {
      await loadTimeline(viewTicketData.workOrder.wonum);
    }
  };

  const fetchWorkRequestData = async () => {
    const workRequests = await FirebaseDataService.getTrackWorkOrders();
    const workRequestArray = objToArray(workRequests.data, (item: any, id: string) => ({ ...item, id }));
    const filtered = workRequestArray.filter((wr: any) => wr.trackingId === trackingId);
    if (filtered.length !== 0 && filtered[0].status !== "CLOSE") {
      fetchNoAuthWorkRequestData(filtered[0]);
    } else if (filtered.length !== 0 && filtered[0].status === "CLOSE") {
      setNoAuthActiveWorkOrder(true);
      await FirebaseDataService.deleteClosedTrackingIdFromDB(filtered[0].id);
    } else {
      setNoAuthDeletedWorkOrder(true);
    }
  };

  const fetchNoAuthWorkRequestData = async (filteredWR: any) => {
    setIsFormLoading(true);
    const { data: viewTicketData } = await FirebaseDataService.getDataForTicketViewForm(
      filteredWR.wonum as string,
      "MANAGER",
      true,
    );
    if (!viewTicketData) {
      setNoAuthDeletedWorkOrder(true);
      setIsFormLoading(false);
      return;
    }
    await applyFetchedData(viewTicketData);
    setIsFormLoading(false);
  };

  const fetchData = async () => {
    setIsFormLoading(true);
    const { data: viewTicketData } = await FirebaseDataService.getDataForTicketViewForm(
      id as string,
      clientUserId,
      isManager,
    );
    if (!viewTicketData) {
      navigate("/workrequests");
      return;
    }
    await applyFetchedData(viewTicketData);
    setIsFormLoading(false);
  };

  const setServiceType = () => {
    const rootClassstructure = Array.isArray(workOrder?.classstructure) ? workOrder?.classstructure?.[0] : undefined;
    const nestedServiceType = rootClassstructure?.classstructure?.[0];

    const serviceType = nestedServiceType?.description || rootClassstructure?.description || "";
    const classification = nestedServiceType ? rootClassstructure?.description || "" : "";

    // const serviceTypeHint = nestedServiceType?.classificationdesc_longdescription;
    // const classificationHint = rootClassstructure?.classificationdesc_longdescription;

    setFormData((d) => ({ ...d, serviceType, classification }));
    // setHints({ serviceType: serviceTypeHint as string, classification: classificationHint as string });
  };

  const onExitClick = () => {
    void (async () => {
      await releaseWorkOrderEditLock({
        silent: true,
        force: true,
        wonum: workOrder?.wonum,
        workOrderId: workOrder?.workorderid,
      });
      if (location?.state?.ticketNumber) navigate(-1);
      else navigate("/workrequests");
    })();
  };

  // ─── Timeline ─────────────────────────────────────────────────────────────

  const loadTimeline = async (wonum: string) => {
    try {
      const result = await FirebaseDataService.getWorkLogComments(wonum, true);
      const comments = result?.data?.worklogComments ?? [];
      const mappedEvents: AuditEvent[] = comments.map((entry: Worklog, index: number) => ({
        id: String(entry.worklogid || entry._rowstamp || index),
        created_at: normalizeActivityTimestamp(entry.createdate || entry.modifydate),
        who: String(entry.createby || entry.modifyby || "User"),
        event: formatActivityText(
          (entry.description_longdescription || "").replace(CommentRegEx, ""),
          entry.description || "",
        ),
      }));
      setEvents(mappedEvents.filter((entry) => entry.event));
    } catch (_) {}
  };

  const logNote = async () => {
    const text = noteDraft.trim();
    if (!text || !workOrder?.wonum || !workOrder?.workorderid) return;
    try {
      setError("");
      const activityText = `[${getActivityActorName()}] ${text}`;
      const response = await FirebaseDataService.createWorklogComment(
        "Activity Log",
        activityText,
        String(workOrder.workorderid),
        true,
        true,
      );
      if (response.status === "error") {
        throw new Error(response.message || "Unable to save Activity Log note.");
      }
      setNoteDraft("");
      await loadTimeline(workOrder.wonum);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Unable to save Activity Log note.");
    }
  };

  const onAttach = async (files: FileList | File[] | null) => {
    const filesToUpload = files ? Array.from(files as ArrayLike<File>) : [];

    if (!filesToUpload.length || !workOrder?.wonum || !workOrder?.workorderid) return false;
    setUploading(true);
    try {
      setError("");
      for (const file of filesToUpload) {
        const isImageByType = file.type.toLowerCase().includes("image");
        const isImageByExtension = /\.(jpg|jpeg|png|heic|heif|gif|webp)$/i.test(file.name);
        const folderName = isImageByType || isImageByExtension ? "Images" : "Attachments";

        const convertedFile = (await getBase64File(file)) as string;
        if (!convertedFile) continue;

        const fileToUpload = convertedFile.slice(convertedFile.indexOf(",") + 1);
        await FirebaseDataService.addMaximoWorkOrderAttachment(
          fileToUpload,
          String(workOrder.workorderid),
          file.name,
          file.type,
          folderName,
        );

        const response = await FirebaseDataService.createWorklogComment(
          "Activity Log",
          `[${getActivityActorName()}] Attached file: ${file.name}`,
          String(workOrder.workorderid),
          true,
          true,
        );
        if (response.status === "error") {
          throw new Error(response.message || "Attachment uploaded but Activity Log entry failed.");
        }
      }
      if (!isEditMode) {
        await loadTimeline(workOrder.wonum);
        await fetchData();
      }
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : "Unable to upload attachment.");
      return false;
    } finally {
      setUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
      if (detailsAttachmentInputRef.current) detailsAttachmentInputRef.current.value = "";
    }
  };

  const saveCompletionContact = async () => {
    if (!workOrder?.wonum) return;
    setCompletionContactSaving(true);
    try {
      const normalized = completionContactDraft.trim();
      await saveWorkOrderChanges(
        {
          completion_contact_name: normalized || null,
        },
        {
          errorMessage: "Unable to save completion contact.",
        },
      );
      try {
        await logTimelineActivity(
          normalized ? `Updated completion contact to ${normalized}.` : "Cleared completion contact.",
        );
      } catch (_) {}
    } finally {
      setCompletionContactSaving(false);
    }
  };

  const loadParentWorkOrderOptions = async () => {
    if (!clientUserId) {
      return;
    }

    try {
      const result = await FirebaseDataService.getWorkOrders(clientUserId, isManager);
      const source = result?.data?.workOrders || [];
      const filteredOptions = source.filter((ticket) => ticket.wonum && ticket.wonum !== workOrder?.wonum);
      setParentWorkOrderOptions(filteredOptions);
    } catch (error) {
      setError(error instanceof Error ? error.message : "Unable to load parent work orders.");
    }
  };

  const openParentWorkOrderModal = async () => {
    if (!parentWorkOrderOptions.length) {
      await loadParentWorkOrderOptions();
    }

    setIsParentModalOpen(true);
  };

  const handleParentWorkOrderConfirm = (wonum: string) => {
    const selectedParent = parentWorkOrderOptions.find((ticket) => ticket.wonum === wonum);
    const nextParentWonum = String(wonum || "").trim();

    stageWorkOrderChanges(
      { parent: nextParentWonum },
      {
        parent: nextParentWonum,
        parentData: selectedParent
          ? {
              ...(workOrder as any)?.parentData,
              wonum: selectedParent.wonum,
              description: selectedParent.description || selectedParent.name || "Untitled work order",
            }
          : undefined,
      },
    );
    setIsParentModalOpen(false);
  };

  const clearParentWorkOrder = () => {
    stageWorkOrderChanges({ parent: "" }, { parent: "", parentData: undefined });
  };

  const renderEventText = (text: string) => {
    const m = text.match(/^Attached file: (.+) — (https?:\/\/\S+)$/);
    if (m) {
      return (
        <span>
          Attached file:{" "}
          <a href={m[2]} target="_blank" rel="noreferrer" style={{ textDecoration: "underline" }}>
            {m[1]}
          </a>
        </span>
      );
    }
    return <span>{text}</span>;
  };

  // ─── Billing field update ─────────────────────────────────────────────────

  const logTimelineActivity = async (message: string) => {
    if (!workOrder?.wonum || !workOrder?.workorderid || !message.trim()) return;

    const response = await FirebaseDataService.createWorklogComment(
      "Activity Log",
      `[${getActivityActorName()}] ${message}`,
      String(workOrder.workorderid),
      true,
      true,
    );

    if (response.status === "error") {
      throw new Error(response.message || "Unable to save activity log entry.");
    }

    await loadTimeline(workOrder.wonum);
  };

  const updateBillingField = async (patch: Partial<ExtendedWorkOrder>, activityMessage?: string) => {
    stageWorkOrderChanges(patch as Record<string, unknown>);

    if (activityMessage) {
      // Keep the parameter for call-site readability; activity is logged on explicit save.
    }
  };

  const toDateTimeLocal = (value?: string) => formatDateTimeLocalValue(parseLocalDateTime(value));

  const updateScheduleField = async (
    fieldName: "schedstart" | "schedfinish" | "actstart" | "actfinish",
    _label: string,
    value?: string,
  ) => {
    if (!workOrder?.wonum) return;

    const rawValue = value ?? scheduleDrafts[fieldName];
    const valueToPersist = rawValue ? new Date(rawValue).toISOString() : "";

    stageWorkOrderChanges({
      [fieldName]: valueToPersist || null,
    });
  };

  const assignRelatedResource = async (kind: ResourceKind, selectedId: string) => {
    if (!workOrder) return;

    try {
      setAssignResourceErrorOnSubmit("");
      const selectedVendor =
        kind === "vendor"
          ? vendors.find((vendor) => getSelectionResourceId(vendor, "vendor") === String(selectedId))
          : undefined;
      const selectedEmployee =
        kind === "team_member"
          ? employees.find((employee) => getSelectionResourceId(employee, "team_member") === String(selectedId))
          : undefined;

      const resolvedVendorId = selectedVendor
        ? String((selectedVendor as any)?.vendorId || (selectedVendor as any)?.vendorid || selectedId || "")
        : "";
      const resolvedLaborCode = selectedEmployee
        ? String((selectedEmployee as any)?.laborCode || (selectedEmployee as any)?.laborcode || selectedId || "")
        : "";

      if (
        (kind === "vendor" && (!selectedVendor || !resolvedVendorId)) ||
        (kind === "team_member" && (!selectedEmployee || !resolvedLaborCode))
      ) {
        setError("Unable to resolve selected resource.");
        return;
      }

      setPendingResourceAssignment({
        approvedamount: selectedVendor ? workOrder.wpservice?.find((service) => service.vendor)?.linecost : undefined,
        vendorId: resolvedVendorId || undefined,
        vendorName: selectedVendor?.displayName || resolvedVendorId,
        woacceptscharges: workOrder.woacceptscharges ?? false,
        laborCode: resolvedLaborCode || undefined,
        assignedEmployee: selectedEmployee
          ? {
              id: selectedEmployee.id,
              laborCode: resolvedLaborCode,
              displayName: selectedEmployee.displayName,
              email: selectedEmployee.email,
            }
          : undefined,
      });

      setWorkOrder((prev) => {
        if (!prev) return prev;

        const nextWorkOrder = { ...prev } as ExtendedWorkOrder;

        if (resolvedVendorId) {
          nextWorkOrder.wpservice = [{ ...(nextWorkOrder.wpservice?.[0] || {}), vendor: resolvedVendorId } as any];
          nextWorkOrder.wplabor = [] as any;
        }

        if (resolvedLaborCode) {
          nextWorkOrder.wplabor = [{ ...(nextWorkOrder.wplabor?.[0] || {}), laborcode: resolvedLaborCode } as any];
          nextWorkOrder.wpservice = [] as any;
        }

        return nextWorkOrder;
      });

      if (kind === "team_member" && selectedEmployee?.email) {
        // const assignmentMessage = [
        //   `Work Order: ${workOrder.wonum}`,
        //   `Title: ${workOrder.description || "N/A"}`,
        //   `Location: ${addressId || "N/A"}`,
        //   `Priority: ${workOrder.wopriority_description || "N/A"}`,
        //   `Status: ${workOrder.status_description || workOrder.status || "N/A"}`,
        //   `Assigned Resource: ${selectedEmployee.displayName || selectedEmployee.laborCode || "N/A"}`,
        //   "",
        //   "Please proceed with the required work and update progress in the portal.",
        // ].join("\n");
        // onOpenMailAppForIssueWorkOrder({
        //   fromEmail: email || "",
        //   toEmails: [selectedEmployee.email],
        //   ccEmails: defaultApprovedCcEmails,
        //   message: assignmentMessage,
        // });
      }
      // setIssueWorkOrderError("");
      // setIsIssueWorkOrderModalVisible(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Unable to assign related resource.");
    }
  };

  const clearRelatedResourceAssignment = () => {
    if (!workOrder) return;

    const hasExistingAssignment = Boolean(assignedVendorId || assignedLaborCode);
    const hasPendingAssignment = Boolean(pendingResourceAssignment);

    setResourceKind("none");
    setResourceId("");
    setIsRelatedResourceModalOpen(false);

    if (!hasExistingAssignment && !hasPendingAssignment) {
      setPendingResourceAssignment(null);
      return;
    }

    setPendingResourceAssignment({
      approvedamount: undefined,
      vendorId: "",
      vendorName: "",
      woacceptscharges: workOrder.woacceptscharges ?? false,
      laborCode: "",
      assignedEmployee: undefined,
    });

    setWorkOrder((prev) => {
      if (!prev) return prev;

      const nextWorkOrder = { ...prev } as ExtendedWorkOrder;
      nextWorkOrder.wpservice = [] as any;
      nextWorkOrder.wplabor = [] as any;
      (nextWorkOrder as any).assigned_vendor_id = "";
      (nextWorkOrder as any).assigned_employee_labor_code = "";
      return nextWorkOrder;
    });

    setError("");
  };

  // ─── Misc helpers ─────────────────────────────────────────────────────────

  // const getApprovedAmount = (wo: WorkOrder) => {
  //   if (wo.woacceptscharges) {
  //     const service = wo.wpservice?.find((s) => s.vendor);
  //     return service?.linecost ? `$${roundTo2Decimals(service.linecost)}` : "Post-completion";
  //   }
  //   return "Non-billable";
  // };

  // const openOrCreateCAP = () => {
  //   if (capDoc) navigate(`/forms/cap/edit?id=${(capDoc as any).id}`);
  //   else navigate(`/quality`);
  // };

  // const getIssueWorkOrderDefaultMessage = () => {
  //   if (!workOrder) {
  //     return "Please find the work order details below.";
  //   }

  //   const resourceName = assignedVendor?.displayName || assignedEmployee?.displayName || "N/A";

  //   return [
  //     `Work Order: ${workOrder.wonum}`,
  //     `Title: ${workOrder.description || "N/A"}`,
  //     `Location: ${addressId || "N/A"}`,
  //     `Priority: ${workOrder.wopriority_description || "N/A"}`,
  //     `Status: ${workOrder.status_description || workOrder.status || "N/A"}`,
  //     `Assigned Resource: ${resourceName}`,
  //     "",
  //     "Please proceed with the required work and update progress in the portal.",
  //   ].join("\n");
  // };

  // const onOpenIssueWorkOrderModal = () => {
  //   setIssueWorkOrderError("");
  //   setIsIssueWorkOrderModalVisible(true);
  // };

  // const onOpenMailAppForIssueWorkOrder = (payload: IssueWorkOrderPayload) => {
  //   if (!workOrder) {
  //     return;
  //   }

  //   const query = new URLSearchParams();
  //   query.set("subject", `Work Order ${workOrder.wonum}: ${workOrder.description || "Work Request"}`);
  //   query.set("body", payload.message);
  //   if (payload.ccEmails.length) {
  //     query.set("cc", payload.ccEmails.join(","));
  //   }

  //   window.location.href = `mailto:${payload.toEmails.join(",")}?${query.toString()}`;
  // };

  // const onIssueWorkOrder = async (payload: IssueWorkOrderPayload) => {
  //   if (!workOrder) {
  //     return;
  //   }

  //   setIssueWorkOrderError("");
  //   setIsIssueWorkOrderSending(true);

  //   try {
  //     const recipientEmails = payload.toEmails.map((emailAddress) => ({
  //       id: emailAddress,
  //       value: emailAddress,
  //     }));
  //     const ccEmails = payload.ccEmails.map((emailAddress) => ({
  //       id: emailAddress,
  //       value: emailAddress,
  //     }));

  //     await FirebaseDataService.issueWorkOrder({
  //       wonum: workOrder.wonum,
  //       workorderid: Number(workOrder.workorderid),
  //       senderName: `${firstName} ${lastName}`,
  //       senderEmail: payload.fromEmail || email || "",
  //       recipientEmails,
  //       ccEmails,
  //       customMessage: payload.message,
  //     });

  //     try {
  //       await logTimelineActivity(
  //         `Issued work order${payload.toEmails.length ? ` to ${payload.toEmails.join(", ")}` : ""}.`,
  //       );
  //     } catch (_) {}
  //     setIsIssueWorkOrderModalVisible(false);
  //   } catch (err) {
  //     setIssueWorkOrderError(err?.message || "Failed to issue work order email.");
  //   } finally {
  //     setIsIssueWorkOrderSending(false);
  //   }
  // };

  const transitionWorkOrderStatus = async (nextStatus: string) => {
    if (!workOrder?.wonum || !nextStatus || nextStatus === String(workOrder.status || "")) {
      return;
    }

    if (isWorkOrderLockedByAnotherUser) {
      setError(workOrderLockMessage || getWorkOrderLockedMessage(workOrderLockOwner));
      return;
    }

    setError("");
    setStatusTransitionSuccess("");
    setIsStatusTransitioning(true);
    try {
      const selectedOption = statusList.find((statusOption) => String(statusOption.id) === String(nextStatus));

      const response = await FirebaseDataService.updateWorkOrderStatus(
        String(workOrder.wonum),
        nextStatus,
        String(email || clientUserId || ""),
        String(selectedOption?.value || ""),
      );

      if (response.status === "error") {
        throw new Error(response.message || "Unable to update work order status.");
      }

      setWorkOrder((prev) =>
        prev
          ? {
              ...prev,
              status: nextStatus,
              status_description: selectedOption?.value || prev.status_description,
            }
          : prev,
      );

      if (Array.isArray(response.data)) {
        setStatusList(response.data);
      }

      setStatusTransitionSuccess(`Status updated to ${selectedOption?.value || nextStatus}.`);

      try {
        await logTimelineActivity(`Status changed to ${selectedOption?.value || nextStatus}.`);
      } catch (_) {
        // Keep transition success even if timeline logging fails.
      }
    } catch (error) {
      setError(error instanceof Error ? error.message : "Unable to update work order status.");
    } finally {
      setIsStatusTransitioning(false);
    }
  };

  // ─── Effects ──────────────────────────────────────────────────────────────

  useEffect(() => {
    if (isNoAuthWorkRequest) fetchWorkRequestData();
  }, [isNoAuthWorkRequest]);
  useEffect(() => {
    if (!isNoAuthWorkRequest) {
      void releaseWorkOrderEditLock({ silent: true });
      setPendingEditPatch({});
      setPendingResourceAssignment(null);
      setEditableField(null);
      fetchData();
    }
  }, [id]);
  useEffect(() => {
    if (isNoAuthWorkRequest || !workOrder?.wonum || !canEditWorkOrderFields) {
      return;
    }

    void getLatestWorkOrderEditLock({ suppressErrors: true });

    const intervalId = window.setInterval(() => {
      void getLatestWorkOrderEditLock({ suppressErrors: true });
    }, 20000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [isNoAuthWorkRequest, canEditWorkOrderFields, workOrder?.wonum, clientUserId]);
  useEffect(() => {
    return () => {
      const wonumToRelease = activeWorkOrderLockRef.current;
      const identity = getEditLockIdentity();

      if (!hasLocalEditLockRef.current || !wonumToRelease || !identity.userId) {
        return;
      }

      void FirebaseDataService.setWorkOrderEditLock({
        wonum: wonumToRelease,
        workOrderId: activeWorkOrderIdRef.current,
        userId: identity.userId,
        userName: identity.userName,
        firstName: identity.firstName,
        lastName: identity.lastName,
        email: identity.email,
        lock: false,
      });
    };
  }, [clientUserId, email, firstName, lastName]);
  useEffect(() => {
    if (isNoAuthWorkRequest || !canEditWorkOrderFields) {
      return;
    }

    const releaseLockOnPageExit = () => {
      if (!hasLocalEditLockRef.current && !isEditMode) {
        return;
      }

      const wonumToRelease = activeWorkOrderLockRef.current || workOrder?.wonum;
      const workOrderIdToRelease = activeWorkOrderIdRef.current || String(workOrder?.workorderid || "");
      const identity = getEditLockIdentity();

      if (!wonumToRelease || !identity.userId) {
        return;
      }

      void FirebaseDataService.setWorkOrderEditLock({
        wonum: wonumToRelease,
        workOrderId: workOrderIdToRelease,
        userId: identity.userId,
        userName: identity.userName,
        firstName: identity.firstName,
        lastName: identity.lastName,
        email: identity.email,
        lock: false,
      });

      hasLocalEditLockRef.current = false;
      activeWorkOrderLockRef.current = "";
      activeWorkOrderIdRef.current = "";
    };

    window.addEventListener("beforeunload", releaseLockOnPageExit);
    window.addEventListener("pagehide", releaseLockOnPageExit);

    return () => {
      window.removeEventListener("beforeunload", releaseLockOnPageExit);
      window.removeEventListener("pagehide", releaseLockOnPageExit);
    };
  }, [
    isNoAuthWorkRequest,
    canEditWorkOrderFields,
    workOrder?.wonum,
    workOrder?.workorderid,
    clientUserId,
    email,
    firstName,
    lastName,
    isEditMode,
  ]);
  useEffect(() => {
    setServiceType();
  }, [workOrder]);
  useEffect(() => {
    if (!isEditMode) {
      updateDraftIdentifiers(workOrder);
    }
  }, [
    isEditMode,
    workOrder?.workorderid,
    workOrder?.pluspcustomer?.customer,
    workOrder?.classstructure,
    clients,
    serviceTypes,
  ]);
  useEffect(() => {
    dispatch(setPageNameHeader("Work Request Details"));
    return () => {
      dispatch(setPageNameHeader(""));
    };
  }, []);
  // useEffect(() => {
  //   fetchApprovedCcEmailsForIssue();
  // }, []);
  // useEffect(() => {
  //   if (isNoAuthWorkRequest || !workOrder || hasAutoOpenedIssueWorkOrder || !location?.state?.openIssueWorkOrderModal) {
  //     return;
  //   }

  //   setHasAutoOpenedIssueWorkOrder(true);
  //   onOpenIssueWorkOrderModal();
  // }, [isNoAuthWorkRequest, workOrder, hasAutoOpenedIssueWorkOrder, location?.state?.openIssueWorkOrderModal]);
  useEffect(() => {
    setCompletionContactDraft(workOrder?.completion_contact_name || "");
  }, [workOrder?.completion_contact_name]);
  useEffect(() => {
    setScheduleDrafts({
      schedstart: toDateTimeLocal(workOrder?.schedstart),
      schedfinish: toDateTimeLocal(workOrder?.schedfinish),
      actstart: toDateTimeLocal(workOrder?.actstart),
      actfinish: toDateTimeLocal(workOrder?.actfinish),
    });
  }, [workOrder?.schedstart, workOrder?.schedfinish, workOrder?.actstart, workOrder?.actfinish]);
  useEffect(() => {
    if (assignedVendor) {
      setResourceKind("vendor");
      setResourceId(getSelectionResourceId(assignedVendor, "vendor"));
      return;
    }

    if (assignedEmployee) {
      setResourceKind("team_member");
      setResourceId(getSelectionResourceId(assignedEmployee, "team_member"));
      return;
    }

    setResourceKind("none");
    setResourceId("");
  }, [assignedVendor?.id, assignedVendor?.vendorId, assignedEmployee?.id, assignedEmployee?.laborCode]);
  useEffect(() => {
    if (!statusTransitionSuccess) return;

    const timeoutId = setTimeout(() => {
      setStatusTransitionSuccess("");
    }, 3500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [statusTransitionSuccess]);

  // ─── Modal handlers ───────────────────────────────────────────────────────

  const shareWorkRequest = async (value: ShareFormValues) => {
    try {
      if (workOrder) {
        await FirebaseDataService.shareWorkRequest(
          value.emailTo,
          value.emailMessage,
          workOrder.workorderid,
          `${firstName} ${lastName}`,
          workOrder.wonum,
          email ?? "",
        );
        setIsShareWorkRequestModalVisible(false);
      }
    } catch (err) {
      setShareFormError(err.message);
    }
  };

  const onSubmitAssignResourceHandler = async (data: AssignWOResourceFormValues) => {
    if (workOrder) {
      setAssignResourceErrorOnSubmit("");
      const selectedEmployee = employees.find((employee) => employee.laborCode === data.employees.laborCode);
      const selectedVendor = vendors.find((vendor) => vendor.vendorId === data.vendors.vendorId);
      setPendingResourceAssignment({
        approvedamount: data.vendors.approvedamount,
        vendorId: data.vendors.vendorId,
        vendorName: selectedVendor?.displayName,
        woacceptscharges: data.vendors.woacceptscharges,
        laborCode: data.employees.laborCode,
        assignedEmployee: selectedEmployee
          ? {
              id: selectedEmployee.id,
              laborCode: selectedEmployee.laborCode,
              displayName: selectedEmployee.displayName,
              email: selectedEmployee.email,
            }
          : undefined,
      });

      setWorkOrder((prev) => {
        if (!prev) return prev;

        const nextWorkOrder = { ...prev } as ExtendedWorkOrder;

        if (data.vendors.vendorId) {
          nextWorkOrder.wpservice = [{ ...(nextWorkOrder.wpservice?.[0] || {}), vendor: data.vendors.vendorId } as any];
          nextWorkOrder.wplabor = [] as any;
        }

        if (data.employees.laborCode) {
          nextWorkOrder.wplabor = [
            { ...(nextWorkOrder.wplabor?.[0] || {}), laborcode: data.employees.laborCode } as any,
          ];
          nextWorkOrder.wpservice = [] as any;
        }

        return nextWorkOrder;
      });

      if (selectedEmployee?.email) {
        // const assignmentMessage = [
        //   `Work Order: ${workOrder.wonum}`,
        //   `Title: ${workOrder.description || "N/A"}`,
        //   `Location: ${addressId || "N/A"}`,
        //   `Priority: ${workOrder.wopriority_description || "N/A"}`,
        //   `Status: ${workOrder.status_description || workOrder.status || "N/A"}`,
        //   `Assigned Resource: ${selectedEmployee.displayName || selectedEmployee.laborCode || "N/A"}`,
        //   "",
        //   "Please proceed with the required work and update progress in the portal.",
        // ].join("\n");
        // onOpenMailAppForIssueWorkOrder({
        //   fromEmail: email || "",
        //   toEmails: [selectedEmployee.email],
        //   ccEmails: defaultApprovedCcEmails,
        //   message: assignmentMessage,
        // });
      }

      setIsModalVisible(false);
    }
  };

  const requestQuotationHandler = () => {
    if (workOrder) {
      void updateBillingField({ requires_quote: true }, "Enabled requires quote and opened quote generation.");
    }
    setIsQuoteModalVisible(true);
  };

  const handleClientModalConfirm = (nextClientId: string, nextLocationId: string) => {
    const selectedClient = clients.find((client) => String(client.id) === String(nextClientId));
    const selectedLocation = locations.find((loc) => String(loc.id) === String(nextLocationId));
    const selectedCustomerId = String(
      selectedClient?.customerId || (selectedClient as any)?.customer || selectedClient?.id || "",
    );

    setSelectedClientId(nextClientId);
    setSelectedLocationId(nextLocationId);
    setSelectedServiceTypeId("");
    setSelectedClassificationId("");
    setFormData((data) => ({ ...data, serviceType: "", classification: "" }));

    stageWorkOrderChanges(
      {
        client: selectedClient
          ? { ...selectedClient, customerId: selectedCustomerId, customer: selectedCustomerId }
          : null,
        location: nextLocationId,
        siteid: workOrder?.siteid || "KLEENWAY",
      },
      {
        pluspcustomer: selectedClient
          ? { name: selectedClient.name, customer: selectedCustomerId }
          : workOrder?.pluspcustomer,
        location: nextLocationId,
        locationData: {
          label: selectedLocation?.label || "",
          address: selectedLocation?.address || "",
        },
        classstructure: [],
      },
    );

    setIsClientModalOpen(false);
  };

  const handleServiceTypeModalConfirm = (nextServiceTypeId: string, nextClassificationId: string) => {
    const selectedServiceType = editableServiceTypeOptions.find((serviceType) => serviceType.id === nextServiceTypeId);
    const selectedClassification = getClassificationsByServiceType(nextServiceTypeId).find(
      (classification) => classification.id === nextClassificationId,
    );

    setSelectedServiceTypeId(nextServiceTypeId);
    setSelectedClassificationId(nextClassificationId);
    setFormData((data) => ({
      ...data,
      serviceType: selectedServiceType?.label || "",
      classification: selectedClassification?.label || "",
    }));

    stageWorkOrderChanges(
      {
        classstructureid: nextClassificationId || nextServiceTypeId,
        classification: selectedClassification?.label || "",
        classification_name: selectedClassification?.label || "",
        serviceType: selectedServiceType?.label || "",
        service_type_name: selectedServiceType?.label || "",
      },
      {
        classstructure: [
          {
            description: selectedClassification?.label || selectedServiceType?.label || "",
            classstructureid: nextClassificationId || nextServiceTypeId,
            classstructure: [
              {
                description: selectedServiceType?.label || "",
                classstructureid: nextServiceTypeId,
              },
            ],
          },
        ],
      },
    );

    setIsServiceTypeModalOpen(false);
  };

  // const transitionToStatus = async (nextStatus?: OptionItem) => {
  //   if (!workOrder || !nextStatus) return;

  //   const newWorkOrder = {
  //     ...workOrder,
  //     status: nextStatus.id,
  //     status_description: nextStatus.value,
  //   };

  //   try {
  //     await FirebaseDataService.updateMaximoStatus(newWorkOrder);
  //     await fetchData();
  //   } catch (_) {}
  // };

  // ─── Guards ───────────────────────────────────────────────────────────────

  if (noAuthActiveWorkOrder) return <ErrorPage subtitle="Work Request Closed" />;
  if (noAuthDeletedWorkOrder) return <ErrorPage subtitle="Work Request Not Found or Closed" />;

  // ─── Sub-panels (exact Kori structure) ───────────────────────────────────

  // Next Required Action — mirrors Kori's <NextRequiredAction> props exactly
  // const nextActionSeverity: Severity = isCritical
  //   ? "critical"
  //   : workOrder?.wopriority_description?.toLowerCase() === "high" ||
  //       workOrder?.wopriority_description?.toLowerCase() === "emergency"
  //     ? "high"
  //     : "normal";
  // const nextStatus = statusList?.[0];
  // const nextActionTitle = showCriticalGate && !capFiled ? "File Corrective Action Plan" : "Complete and close out";
  // const nextActionSub = `Currently ${workOrder?.status_description || workOrder?.status || "—"}.`;
  // const nextActionLabel =
  //   showCriticalGate && !capFiled ? "Open CAP →" : nextStatus ? `→ ${nextStatus.value.toUpperCase()}` : undefined;
  // const nextActionHandler = () => {
  //   if (showCriticalGate && !capFiled) {
  //     openOrCreateCAP();
  //     return;
  //   }

  //   void transitionToStatus(nextStatus);
  // };

  // Activity panel — exact Kori markup, adapted to styled-components
  const activityPanel = (
    <ActivityPanel>
      <ActivityPanelHeader>
        <div>
          <EyebrowStrong>Activity Log</EyebrowStrong>
          <ActivityPanelSub>
            Add notes or attach documents. Saved activity appears in the timeline below.
          </ActivityPanelSub>
        </div>
        <TimelineEyebrow>Timeline</TimelineEyebrow>
      </ActivityPanelHeader>

      <ActivityPanelBody>
        {isNoAuthWorkRequest ? (
          <>
            <NoAuthCompletionSection>
              <Eyebrow style={{ marginBottom: 8 }}>Completion Contact</Eyebrow>
              <KInputStyled
                value={completionContactDraft}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompletionContactDraft(e.target.value)}
                placeholder="Enter cleaner or technician name"
              />
              <NoAuthCompletionActions>
                <KButtonStyled
                  onClick={saveCompletionContact}
                  disabled={
                    completionContactSaving ||
                    completionContactDraft.trim() === (workOrder?.completion_contact_name || "")
                  }
                >
                  {completionContactSaving ? "Saving..." : "Save Name"}
                </KButtonStyled>
                <NoAuthCompletionHint>
                  Set completion date in the Actual Finish field and add photos/notes below.
                </NoAuthCompletionHint>
              </NoAuthCompletionActions>
            </NoAuthCompletionSection>

            <div>
              <Eyebrow style={{ marginBottom: 8 }}>Add Note</Eyebrow>
              <KTextareaStyled
                rows={3}
                value={noteDraft}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setNoteDraft(e.target.value)}
                placeholder="Log an update, observation, instruction, cost change, or follow-up."
              />
              <KButtonStyled onClick={logNote} disabled={!noteDraft.trim()} style={{ marginTop: 12 }}>
                Save Note to Timeline
              </KButtonStyled>
            </div>

            <div style={{ marginTop: 20 }}>
              <Eyebrow style={{ marginBottom: 8 }}>Attach Pictures / Documents</Eyebrow>
              <AttachLabel>
                <AttachLabelText>
                  {uploading ? "Uploading…" : "Select one or more files to save them to this record."}
                </AttachLabelText>
                <AttachLabelButton>+ Attach Files</AttachLabelButton>
                <input
                  ref={fileInputRef}
                  type="file"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => onAttach(e.target.files)}
                />
              </AttachLabel>
            </div>
          </>
        ) : (
          <>
            <InlineComposerRow>
              <InlineComposerMeta>
                <Eyebrow style={{ marginBottom: 4 }}>Comment as</Eyebrow>
                <InlineComposerUser>{getActivityActorName()}</InlineComposerUser>
              </InlineComposerMeta>
              <InlinePlusButton type="button" onClick={() => setIsInternalComposerOpen((prev) => !prev)}>
                +
              </InlinePlusButton>
            </InlineComposerRow>

            {isInternalComposerOpen && (
              <InlineComposerExpanded>
                <KTextareaStyled
                  rows={3}
                  value={noteDraft}
                  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setNoteDraft(e.target.value)}
                  placeholder="Add a comment update..."
                />

                <AttachLabel style={{ marginTop: 12 }}>
                  <AttachLabelText>
                    {uploading ? "Uploading…" : "Attach one or more files to this comment."}
                  </AttachLabelText>
                  <AttachLabelButton>+ Attach Files</AttachLabelButton>
                  <input
                    ref={fileInputRef}
                    type="file"
                    multiple
                    style={{ display: "none" }}
                    onChange={(e) => onAttach(e.target.files)}
                  />
                </AttachLabel>

                <InlineComposerActions>
                  <KButtonStyled onClick={logNote} disabled={!noteDraft.trim() || uploading}>
                    Save
                  </KButtonStyled>
                  <InlineCancelButton
                    type="button"
                    onClick={() => {
                      setNoteDraft("");
                      setIsInternalComposerOpen(false);
                    }}
                  >
                    Cancel
                  </InlineCancelButton>
                </InlineComposerActions>
              </InlineComposerExpanded>
            )}
          </>
        )}
      </ActivityPanelBody>
    </ActivityPanel>
  );

  // Timeline list — exact Kori structure
  const timelinePanel = (
    <div style={!isEditMode ? { marginTop: 32 } : { marginTop: 32, order: 4 }}>
      <TimelineHeader>
        <Eyebrow style={{ marginBottom: 0 }}>Timeline</Eyebrow>
        <ActivityFilterTabs>
          <ActivityFilterTabButton
            type="button"
            $active={activityFilter === "all"}
            onClick={() => setActivityFilter("all")}
          >
            All
          </ActivityFilterTabButton>
          <ActivityFilterTabButton
            type="button"
            $active={activityFilter === "comments"}
            onClick={() => setActivityFilter("comments")}
          >
            Comments
          </ActivityFilterTabButton>
          <ActivityFilterTabButton
            type="button"
            $active={activityFilter === "system"}
            onClick={() => setActivityFilter("system")}
          >
            System
          </ActivityFilterTabButton>
        </ActivityFilterTabs>
      </TimelineHeader>
      <TimelineList>
        {filteredTimelineEntries.map((ev) => (
          <TimelineRow key={ev.id}>
            <TimelineTime>
              {/* {(() => {
                const parsed = new Date(ev.created_at);
                return Number.isNaN(parsed.getTime()) ? "N/A" : parsed.toLocaleString();
              })()} */}
              {ev.created_at ? new Date(ev.created_at).toLocaleString() : "N/A"}
            </TimelineTime>
            <TimelineWho>{ev.who}</TimelineWho>
            <TimelineEvent>{renderEventText(ev.event)}</TimelineEvent>
          </TimelineRow>
        ))}
        {!filteredTimelineEntries.length && <TimelineEmpty>No activity log entries match this filter.</TimelineEmpty>}
      </TimelineList>
    </div>
  );

  // Linked documents — exact Kori structure
  // const linkedDocsPanel = documents && documents.length > 0 && (
  //   <div style={{ marginTop: 32 }}>
  //     <Eyebrow style={{ marginBottom: 12 }}>Linked Documents</Eyebrow>
  //     <LinkedDocsList>
  //       {documents.map((d: any) => (
  //         <LinkedDocRow
  //           key={d.id}
  //           onClick={() => {
  //             if (d.type === "corrective_action_plan") navigate(`/forms/cap/edit?id=${d.id}`);
  //             else if (d.type === "formal_warning") navigate(`/forms/formal-warning/edit?id=${d.id}`);
  //           }}
  //         >
  //           <LinkedDocType>{String(d?.type || "unknown").replace(/_/g, " ")}</LinkedDocType>
  //           <LinkedDocMeta>
  //             {d.status}
  //             {d.due_at ? ` · due ${new Date(d.due_at).toLocaleDateString()}` : ""}
  //           </LinkedDocMeta>
  //         </LinkedDocRow>
  //       ))}
  //     </LinkedDocsList>
  //   </div>
  // );

  // Billing panel — exact Kori structure mapped to WorkOrder fields
  const isClientOnlyBilling = workOrder?.billable_type === "client";
  const isBothBilling = workOrder?.billable_type === "both";
  const isClientBilled = isClientOnlyBilling || isBothBilling;
  const showVendorCost = true;

  const billingPanel = showBilling && workOrder && (
    <BillingPanel style={!isViewOnlyMode ? { marginTop: 32 } : { marginTop: 32, order: 3 }}>
      <BillingSectionRow>
        <BillingSectionMeta>
          <BillingSectionEyebrow>03B</BillingSectionEyebrow>
          <BillingSectionTitle>Billing &amp; Procurement</BillingSectionTitle>
          <BillingSectionHelper>
            Setting any billable type other than Not Billable will auto-generate a Service PO in Draft, linked to this
            work request.
          </BillingSectionHelper>
          {workOrder.linked_po_id && (
            <LinkedPoButton onClick={() => navigate(`/financials/service-purchasing/${workOrder.linked_po_id}`)}>
              View linked Service PO →
            </LinkedPoButton>
          )}
        </BillingSectionMeta>

        <BillingSectionBody>
          <BillingField>
            <FieldLabelRow>
              <BillingFieldLabel>Billable Type</BillingFieldLabel>
              {canEditWorkOrderFields && (
                <FieldEditButton
                  $isActive={isFieldEditable("billable_type")}
                  type="button"
                  onClick={() => startFieldEdit("billable_type")}
                >
                  <FontAwesomeIcon icon={faIcons.faPencil as any} />
                </FieldEditButton>
              )}
            </FieldLabelRow>
            <BillingFieldHelper>
              KSI = KSI pays vendor, absorbs cost. Client = KSI pays vendor, bills client. Both = KSI pays vendor, bills
              part to client.
            </BillingFieldHelper>
            <SegmentedRow>
              {[
                { value: "not_billable", label: "Not Billable" },
                { value: "ksi", label: "KSI" },
                { value: "client", label: "Client" },
                { value: "both", label: "Both" },
              ].map((option) => (
                <SegmentedButton
                  key={option.value}
                  type="button"
                  disabled={!isFieldEditable("billable_type")}
                  $isActive={(workOrder.billable_type ?? "not_billable") === option.value}
                  onClick={() =>
                    void updateBillingField(
                      { billable_type: option.value as BillableType },
                      `Changed billable type to ${option.label}.`,
                    ).finally(() => finishFieldEdit())
                  }
                >
                  {option.label}
                </SegmentedButton>
              ))}
            </SegmentedRow>
          </BillingField>

          {workOrder.billable_type === "ksi" && (
            <BillingField>
              <FieldLabelRow>
                <BillingFieldLabel>Estimated Cost</BillingFieldLabel>
                {canEditWorkOrderFields && (
                  <FieldEditButton
                    $isActive={isFieldEditable("estmatcost")}
                    type="button"
                    onClick={() => startFieldEdit("estmatcost")}
                  >
                    <FontAwesomeIcon icon={faIcons.faPencil as any} />
                  </FieldEditButton>
                )}
              </FieldLabelRow>
              <BillingFieldHelper>What KSI expects the vendor to charge. Absorbed by KSI.</BillingFieldHelper>
              <BillingInput
                type="number"
                min={0}
                step="0.01"
                disabled={!isFieldEditable("estmatcost")}
                value={workOrder.estmatcost ?? ""}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  updateBillingField({ estmatcost: e.target.value === "" ? 0 : Number(e.target.value) } as any)
                }
                onBlur={() => {
                  if (!isFieldEditable("estmatcost")) return;
                  finishFieldEdit();
                }}
                placeholder="0.00"
              />
            </BillingField>
          )}

          {isClientBilled && (
            <>
              {showVendorCost && (
                <BillingField>
                  <FieldLabelRow>
                    <BillingFieldLabel>Vendor Cost</BillingFieldLabel>
                    {canEditWorkOrderFields && (
                      <FieldEditButton
                        $isActive={isFieldEditable("vendor_cost")}
                        type="button"
                        onClick={() => startFieldEdit("vendor_cost")}
                      >
                        <FontAwesomeIcon icon={faIcons.faPencil as any} />
                      </FieldEditButton>
                    )}
                  </FieldLabelRow>
                  <BillingFieldHelper>What the vendor will invoice KSI.</BillingFieldHelper>
                  <BillingInput
                    type="number"
                    min={0}
                    step="0.01"
                    disabled={!isFieldEditable("vendor_cost")}
                    value={(workOrder as any).vendor_cost ?? workOrder.estmatcost ?? ""}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const nextValue = e.target.value === "" ? null : Number(e.target.value);
                      updateBillingField({ vendor_cost: nextValue as any, estmatcost: nextValue as any } as any);
                    }}
                    onBlur={() => {
                      if (!isFieldEditable("vendor_cost")) return;
                      finishFieldEdit();
                    }}
                    placeholder="0.00"
                  />
                </BillingField>
              )}

              {isBothBilling && (
                <BillingField>
                  <FieldLabelRow>
                    <BillingFieldLabel>Client Billing Mode</BillingFieldLabel>
                    {canEditWorkOrderFields && (
                      <FieldEditButton
                        $isActive={isFieldEditable("client_billing_mode")}
                        type="button"
                        onClick={() => startFieldEdit("client_billing_mode")}
                      >
                        <FontAwesomeIcon icon={faIcons.faPencil as any} />
                      </FieldEditButton>
                    )}
                  </FieldLabelRow>
                  <BillingFieldHelper>How KSI bills this client.</BillingFieldHelper>
                  <SegmentedRow>
                    {[
                      { value: "fixed", label: "Fixed" },
                      { value: "cost_plus", label: "Cost-plus" },
                    ].map((option) => (
                      <SegmentedButton
                        key={option.value}
                        type="button"
                        disabled={!isFieldEditable("client_billing_mode")}
                        $isActive={(workOrder.client_billing_mode ?? "fixed") === option.value}
                        onClick={() =>
                          void updateBillingField(
                            { client_billing_mode: option.value as ClientBillingMode },
                            `Changed client billing mode to ${option.label}.`,
                          ).finally(() => finishFieldEdit())
                        }
                      >
                        {option.label}
                      </SegmentedButton>
                    ))}
                  </SegmentedRow>
                </BillingField>
              )}

              {isBothBilling || workOrder.client_billing_mode === "fixed" || !workOrder.client_billing_mode ? (
                <>
                  <BillingField>
                    <FieldLabelRow>
                      <BillingFieldLabel>Markup %</BillingFieldLabel>
                      {canEditWorkOrderFields && (
                        <FieldEditButton
                          $isActive={isFieldEditable("client_markup_pct")}
                          type="button"
                          onClick={() => startFieldEdit("client_markup_pct")}
                        >
                          <FontAwesomeIcon icon={faIcons.faPencil as any} />
                        </FieldEditButton>
                      )}
                    </FieldLabelRow>
                    <BillingFieldHelper>
                      Applied to Vendor Cost to auto-calculate the fixed client billed amount.
                    </BillingFieldHelper>
                    <BillingInput
                      type="number"
                      min={0}
                      step="0.01"
                      disabled={!isFieldEditable("client_markup_pct")}
                      value={(workOrder as any).client_markup_pct ?? ""}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        updateBillingField({
                          client_markup_pct: e.target.value === "" ? null : Number(e.target.value),
                        } as any)
                      }
                      onBlur={() => {
                        if (!isFieldEditable("client_markup_pct")) return;
                        finishFieldEdit();
                      }}
                      placeholder="0"
                    />
                  </BillingField>

                  <BillingField>
                    <FieldLabelRow>
                      <BillingFieldLabel>Client Billed Amount (Fixed)</BillingFieldLabel>
                      {canEditWorkOrderFields && (
                        <FieldEditButton
                          $isActive={isFieldEditable("client_fixed_amount")}
                          type="button"
                          onClick={() => startFieldEdit("client_fixed_amount")}
                        >
                          <FontAwesomeIcon icon={faIcons.faPencil as any} />
                        </FieldEditButton>
                      )}
                    </FieldLabelRow>
                    <BillingFieldHelper>Whatever amount KSI agreed to bill the client.</BillingFieldHelper>
                    <BillingInput
                      type="number"
                      min={0}
                      step="0.01"
                      disabled={!isFieldEditable("client_fixed_amount")}
                      value={workOrder.client_fixed_amount ?? ""}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        updateBillingField({
                          client_fixed_amount: e.target.value === "" ? null : Number(e.target.value),
                        })
                      }
                      onBlur={() => {
                        if (!isFieldEditable("client_fixed_amount")) return;
                        finishFieldEdit();
                      }}
                      placeholder="0.00"
                    />
                  </BillingField>
                </>
              ) : (
                <BillingField>
                  <BillingFieldLabel>Client Billed Amount (Cost-plus)</BillingFieldLabel>
                  <BillingDisplayBox>
                    <BillingAmountText>
                      {workOrder.client_fixed_amount != null
                        ? `$${roundTo2Decimals(workOrder.client_fixed_amount)}`
                        : "—"}
                    </BillingAmountText>
                    <BillingDetailsMeta>
                      Cost-plus billing is managed from the client profile and is not editable here.
                    </BillingDetailsMeta>
                  </BillingDisplayBox>
                </BillingField>
              )}
            </>
          )}

          {workOrder.billable_type && workOrder.billable_type !== "not_billable" && (
            <>
              <BillingField>
                <FieldLabelRow>
                  <BillingFieldLabel>Client Approval</BillingFieldLabel>
                  {canEditWorkOrderFields && (
                    <FieldEditButton
                      $isActive={isFieldEditable("client_approval_status")}
                      type="button"
                      onClick={() => startFieldEdit("client_approval_status")}
                    >
                      <FontAwesomeIcon icon={faIcons.faPencil as any} />
                    </FieldEditButton>
                  )}
                </FieldLabelRow>
                <SegmentedRow>
                  {[
                    { value: "not_required", label: "Not Required" },
                    { value: "pending", label: "Pending" },
                    { value: "approved", label: "Approved" },
                    { value: "declined", label: "Declined" },
                  ].map((option) => (
                    <SegmentedButton
                      key={option.value}
                      type="button"
                      disabled={!isFieldEditable("client_approval_status")}
                      $isActive={(workOrder.client_approval_status ?? "not_required") === option.value}
                      onClick={() =>
                        void updateBillingField(
                          { client_approval_status: option.value as ClientApprovalStatus },
                          `Changed client approval to ${option.label}.`,
                        ).finally(() => finishFieldEdit())
                      }
                    >
                      {option.label}
                    </SegmentedButton>
                  ))}
                </SegmentedRow>
              </BillingField>

              <BillingField>
                <FieldLabelRow>
                  <BillingFieldLabel>Client PO Number</BillingFieldLabel>
                  {canEditWorkOrderFields && (
                    <FieldEditButton
                      $isActive={isFieldEditable("client_po_number")}
                      type="button"
                      onClick={() => startFieldEdit("client_po_number")}
                    >
                      <FontAwesomeIcon icon={faIcons.faPencil as any} />
                    </FieldEditButton>
                  )}
                </FieldLabelRow>
                <BillingFieldHelper>Optional. The client&apos;s reference number for this work.</BillingFieldHelper>
                <BillingInput
                  disabled={!isFieldEditable("client_po_number")}
                  value={workOrder.client_po_number ?? ""}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    updateBillingField({ client_po_number: e.target.value })
                  }
                  onBlur={() => {
                    if (!isFieldEditable("client_po_number")) return;
                    finishFieldEdit();
                  }}
                  placeholder="e.g. ANCHOR-2461"
                />
              </BillingField>

              <BillingField>
                <FieldLabelRow>
                  <BillingFieldLabel>Requires Quote</BillingFieldLabel>
                  {canEditWorkOrderFields && (
                    <FieldEditButton
                      $isActive={isFieldEditable("requires_quote")}
                      type="button"
                      onClick={() => startFieldEdit("requires_quote")}
                    >
                      <FontAwesomeIcon icon={faIcons.faPencil as any} />
                    </FieldEditButton>
                  )}
                </FieldLabelRow>
                <BillingFieldHelper>
                  Launch quote generation and mark this work order as quote-required.
                </BillingFieldHelper>
                <GenerateQuoteButton
                  type="button"
                  disabled={!isFieldEditable("requires_quote")}
                  onClick={() => {
                    void updateBillingField(
                      { requires_quote: true },
                      "Enabled requires quote and opened quote generation.",
                    ).finally(() => finishFieldEdit());
                    setIsQuoteModalVisible(true);
                  }}
                >
                  Generate Quote
                </GenerateQuoteButton>
                {workOrder.requires_quote && <CheckboxSub>Quote required is enabled for this work order.</CheckboxSub>}
              </BillingField>
            </>
          )}

          {!workOrder.billable_type || workOrder.billable_type === "not_billable" ? (
            <BillingNoticeBox>No cost fields. No PO will be created.</BillingNoticeBox>
          ) : null}
        </BillingSectionBody>
      </BillingSectionRow>
    </BillingPanel>
  );

  // Critical gate — exact Kori structure
  // const criticalGatePanel = showCriticalGate && (
  //   <CriticalGate $satisfied={capFiled} style={{ marginTop: 32 }}>
  //     <div>
  //       <CriticalGateTitle>{capFiled ? "Closure gate satisfied" : "Closure gate locked"}</CriticalGateTitle>
  //       <CriticalGateSub>
  //         {capFiled
  //           ? "CAP filed — this work request may be closed."
  //           : "Critical concern requires a Filed Corrective Action Plan before closure."}
  //       </CriticalGateSub>
  //     </div>
  //     {!capFiled && (
  //       <CriticalGateButton onClick={openOrCreateCAP}>
  //         {capDoc ? "Open Draft →" : "View Quality Control →"}
  //       </CriticalGateButton>
  //     )}
  //   </CriticalGate>
  // );

  // Completion notes (low/medium severity, mirrors Kori)
  // const isLowMediumSeverity =
  //   workOrder?.wopriority_description?.toLowerCase() === "low" ||
  //   workOrder?.wopriority_description?.toLowerCase() === "medium";
  // const completionNotesPanel = isLowMediumSeverity && !isCompleted && (
  //   <CompletionNotesPanel style={{ marginTop: 32 }}>
  //     <CompletionNotesHeader>
  //       <div>
  //         <CompletionNotesTitle>Completion Notes</CompletionNotesTitle>
  //         <CompletionNotesSub>Required before closing low/medium severity work.</CompletionNotesSub>
  //       </div>
  //       {completionNotes && <CompletionNotesSaved>✓ Saved</CompletionNotesSaved>}
  //     </CompletionNotesHeader>
  //     <CompletionNotesField
  //       value={completionNotes}
  //       onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setCompletionNotes(e.target.value)}
  //       style={{ marginTop: 14 }}
  //       placeholder="Summarize what was fixed, verification steps, and any follow-up needed."
  //     />
  //     <CompletionNotesActions>
  //       <CompletionNotesHint>
  //         Keep this client-ready: include outcome, impact, and whether additional action is required.
  //       </CompletionNotesHint>
  //       <KButtonStyled
  //         style={{ marginTop: 12 }}
  //         onClick={async () => {
  //           try {
  //             if (!workOrder?.wonum) return;
  //             await saveWorkOrderChanges(
  //               {
  //                 completion_notes: completionNotes,
  //               },
  //               {
  //                 errorMessage: "Unable to save completion notes.",
  //               },
  //             );
  //             try {
  //               await logTimelineActivity(
  //                 completionNotes.trim()
  //                   ? `Updated completion notes: ${completionNotes.trim()}`
  //                   : "Cleared completion notes.",
  //               );
  //             } catch (_) {}
  //           } catch (_) {}
  //         }}
  //       >
  //         Save Notes
  //       </KButtonStyled>
  //     </CompletionNotesActions>
  //   </CompletionNotesPanel>
  // );

  // ─── Render ───────────────────────────────────────────────────────────────

  return (
    <LoadingContainer isLoading={isFormLoading}>
      {isModalVisible && workOrder && (
        <AssignWOResourceModal
          closeModal={() => {
            setAssignResourceErrorOnSubmit("");
            setIsModalVisible(false);
          }}
          errorMsg={assignResourceErrorOnSubmit}
          onSubmit={onSubmitAssignResourceHandler}
          employees={employees}
          vendors={vendors.filter((v) => v.clients && v.clients.includes(workOrder.pluspcustomer?.customer ?? ""))}
          defaultValues={{
            employees: { laborCode: workOrder.wplabor?.find((l) => l.laborcode)?.laborcode },
            vendors: {
              woacceptscharges: workOrder.woacceptscharges ?? false,
              approvedamount: workOrder.wpservice?.find((s) => s.vendor)?.linecost,
              vendorId: workOrder.wpservice?.find((s) => s.vendor)?.vendor,
            },
            activetab: workOrder.wpservice?.find((s) => s.vendor)?.vendor ? "vendors" : "employees",
          }}
        />
      )}

      {/* {!isNoAuthWorkRequest && isIssueWorkOrderModalVisible && workOrder && (
        <IssueWorkOrderModal
          isOpen={isIssueWorkOrderModalVisible}
          closeModal={() => setIsIssueWorkOrderModalVisible(false)}
          title={issueActionLabel}
          approvedSenderEmails={approvedSenderEmails}
          defaultSenderEmail={email || ""}
          defaultToEmails={defaultIssueRecipients}
          defaultCcEmails={defaultApprovedCcEmails}
          approvedCcOptions={approvedCcOptions}
          defaultMessage={getIssueWorkOrderDefaultMessage()}
          isSending={isIssueWorkOrderSending}
          error={issueWorkOrderError}
          onSend={onIssueWorkOrder}
          onOpenMailApp={onOpenMailAppForIssueWorkOrder}
        />
      )} */}

      {isQuoteModalVisible && (
        <QuoteModalOverlay>
          <QuoteModalCard>
            <QuoteModalHeader>
              <h3>Generate Quote</h3>
              <QuoteModalCloseButton type="button" onClick={() => setIsQuoteModalVisible(false)}>
                Close
              </QuoteModalCloseButton>
            </QuoteModalHeader>
            <QuoteModalBody>
              <RequestQuoteForm onCancel={() => setIsQuoteModalVisible(false)} />
            </QuoteModalBody>
          </QuoteModalCard>
        </QuoteModalOverlay>
      )}

      {isAttachmentModalOpen && (
        <AttachmentModalOverlay>
          <AttachmentModalCard>
            <AttachmentModalHeader>
              <div>
                <h3>Attach Files</h3>
                <AttachmentModalSubTitle>
                  Upload documents or images to this work order. The gallery on the right updates after upload.
                </AttachmentModalSubTitle>
              </div>
              <AttachmentModalCloseButton type="button" onClick={closeAttachmentModal}>
                Close
              </AttachmentModalCloseButton>
            </AttachmentModalHeader>

            <AttachmentModalBody>
              <AttachmentDropZone>
                <AttachmentDropZoneTitle>Choose one or more files</AttachmentDropZoneTitle>
                <AttachmentDropZoneText>
                  Images, PDFs, Word files, spreadsheets, and other work order attachments.
                </AttachmentDropZoneText>
                <AttachmentBrowseButton type="button" onClick={() => detailsAttachmentInputRef.current?.click()}>
                  Browse Files
                </AttachmentBrowseButton>
                <input
                  ref={detailsAttachmentInputRef}
                  type="file"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const pickedFiles = Array.from(e.target.files || []);
                    if (!pickedFiles.length) {
                      return;
                    }

                    setPendingAttachmentFiles((currentFiles) => [...currentFiles, ...pickedFiles]);
                    e.target.value = "";
                  }}
                />
              </AttachmentDropZone>

              <AttachmentSelectedHeader>
                <span>Selected Files</span>
                <span>{pendingAttachmentFiles.length}</span>
              </AttachmentSelectedHeader>
              {pendingAttachmentFiles.length > 0 ? (
                <AttachmentSelectedList>
                  {pendingAttachmentFiles.map((file, index) => (
                    <AttachmentSelectedItem key={`${file.name}-${file.size}-${index}`}>
                      <div style={{ minWidth: 0 }}>
                        <AttachmentSelectedFileName>{file.name}</AttachmentSelectedFileName>
                        <AttachmentSelectedFileMeta>{Math.ceil(file.size / 1024)} KB</AttachmentSelectedFileMeta>
                      </div>
                      <button
                        type="button"
                        onClick={() => removePendingAttachmentFile(index)}
                        style={{
                          border: `1px solid ${colors.grey.light12}`,
                          background: colors.white.default,
                          color: colors.black.light2,
                          padding: "8px 12px",
                          fontSize: 11,
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.08em",
                          cursor: "pointer",
                          flexShrink: 0,
                        }}
                      >
                        Remove
                      </button>
                    </AttachmentSelectedItem>
                  ))}
                </AttachmentSelectedList>
              ) : (
                <AttachmentSelectedEmpty>No files selected yet.</AttachmentSelectedEmpty>
              )}
            </AttachmentModalBody>

            <AttachmentModalFooter>
              <AttachmentModalCancelButton type="button" onClick={closeAttachmentModal}>
                Cancel
              </AttachmentModalCancelButton>
              <AttachmentModalActionButton
                type="button"
                disabled={!pendingAttachmentFiles.length || uploading}
                onClick={async () => {
                  const success = await onAttach(pendingAttachmentFiles);
                  if (success) {
                    closeAttachmentModal();
                  }
                }}
              >
                {uploading ? "Uploading..." : "Upload Files"}
              </AttachmentModalActionButton>
            </AttachmentModalFooter>
          </AttachmentModalCard>
        </AttachmentModalOverlay>
      )}

      {selectedAttachmentPreview && (
        <AttachmentPreviewOverlay>
          <AttachmentPreviewCard>
            <AttachmentPreviewHeader>
              <div>
                <h3>{selectedAttachmentPreview.label}</h3>
                <AttachmentPreviewSubTitle>Preview attachment</AttachmentPreviewSubTitle>
              </div>
              <AttachmentPreviewCloseButton type="button" onClick={closeAttachmentPreview}>
                Close
              </AttachmentPreviewCloseButton>
            </AttachmentPreviewHeader>
            <AttachmentPreviewBody>
              {isAttachmentPreviewLoading && (
                <AttachmentPreviewLoaderOverlay>
                  <AttachmentPreviewSpinner />
                  <AttachmentPreviewLoaderText>Loading file preview...</AttachmentPreviewLoaderText>
                </AttachmentPreviewLoaderOverlay>
              )}
              {selectedAttachmentPreview.isImage ? (
                <AttachmentPreviewImage
                  src={selectedAttachmentPreview.href}
                  alt={selectedAttachmentPreview.label}
                  onLoad={() => setIsAttachmentPreviewLoading(false)}
                  onError={() => setIsAttachmentPreviewLoading(false)}
                  $isVisible={!isAttachmentPreviewLoading}
                />
              ) : (
                <AttachmentPreviewFrame
                  src={selectedAttachmentPreview.href}
                  title={selectedAttachmentPreview.label}
                  onLoad={() => setIsAttachmentPreviewLoading(false)}
                  onError={() => setIsAttachmentPreviewLoading(false)}
                  $isVisible={!isAttachmentPreviewLoading}
                />
              )}
            </AttachmentPreviewBody>
          </AttachmentPreviewCard>
        </AttachmentPreviewOverlay>
      )}

      {canEditWorkOrderFields && (
        <RelatedResourceSelectionModal
          isOpen={isRelatedResourceModalOpen && resourceKind !== "none"}
          onClose={() => setIsRelatedResourceModalOpen(false)}
          resourceType={resourceKind === "vendor" ? "vendor" : "team_member"}
          resources={relatedResourceModalOptions}
          selectedResourceId={resourceId}
          onConfirm={async (selectedResourceId) => {
            setResourceId(selectedResourceId);
            setIsRelatedResourceModalOpen(false);
            await assignRelatedResource(resourceKind, selectedResourceId);
          }}
        />
      )}

      <ClientSelectionModal
        isOpen={isClientModalOpen}
        onClose={() => setIsClientModalOpen(false)}
        onConfirm={handleClientModalConfirm}
        clients={clients.map((client) => ({ id: String(client.id), name: client.name }))}
        locations={locations}
        currentClientId={resolvedClientId}
        currentLocationId={resolvedLocationId}
      />

      <ParentWorkOrderSelectionModal
        isOpen={isParentModalOpen}
        onClose={() => setIsParentModalOpen(false)}
        workOrders={parentWorkOrderOptions}
        selectedWonum={String((workOrder?.parent as string) || "")}
        onConfirm={handleParentWorkOrderConfirm}
      />

      <ServiceTypeClassificationModal
        isOpen={isServiceTypeModalOpen}
        onClose={() => setIsServiceTypeModalOpen(false)}
        serviceTypes={editableServiceTypeOptions}
        getClassifications={getClassificationsByServiceType}
        selectedServiceTypeId={fallbackServiceTypeId}
        // selectedClassificationId={fallbackClassificationId}
        onConfirm={handleServiceTypeModalConfirm}
      />

      <Container>
        {isNoAuthWorkRequest ? <Header name="Work Request Tracking" logo="" noLink noUserLoginPage /> : null}
        <Content>
          {/* ── Top bar (back button + action buttons) ── */}
          <Stack direction="horizontal" className="align-items-center justify-content-between">
            {!isNoAuthWorkRequest ? <BackButton backHandler={onExitClick} /> : <EmptyContainer />}
            <Stack direction="horizontal" gap={3}>
              {isManager && (
                <Button
                  text="Generate Quote"
                  variant="white"
                  additionalStyles={{ display: "flex" }}
                  icon={faIcons.faShare as any}
                  onClick={requestQuotationHandler}
                />
              )}
              <Button
                text="Share"
                variant="white"
                additionalStyles={{ display: "flex" }}
                icon={faIcons.faShare as any}
                onClick={() => setIsShareWorkRequestModalVisible(true)}
              />
            </Stack>
          </Stack>

          {isShareWorkRequestModalVisible && (
            <ShareFormModal
              closeModal={() => setIsShareWorkRequestModalVisible(false)}
              error={shareFormError}
              onSubmit={shareWorkRequest}
            />
          )}

          {canEditWorkOrderFields && workOrderLockMessage && !isEditMode && (
            <Alert text={workOrderLockMessage} variant={AlertVariants.danger} />
          )}

          {workOrder &&
            clientApprovalStatuses &&
            workOrder.status === clientApprovalStatuses.approvalRequired.abbreviation && (
              <ClientApprovalWindow
                workOrder={workOrder}
                documents={documents}
                setError={setError}
                clientApprovalStatuses={clientApprovalStatuses}
                setWorkOrder={setWorkOrder}
                setAddCommentSuccess={setAddCommentSuccess}
              />
            )}

          {/* ── Page header — mirrors Kori's <PageHeader> ── */}
          <PageHeaderBlock>
            <PageHeaderTopRow>
              <PageHeaderDetails>
                <PageEyebrow>{workOrder?.wonum}</PageEyebrow>
                <PageTitle>{workOrder?.description || "Work Request Details"}</PageTitle>
                <PageMeta>
                  {workOrder?.pluspcustomer?.name ?? "—"} · {addressId ?? "—"} · Opened {parsedCreatedDate}
                </PageMeta>
              </PageHeaderDetails>
              <StickyActionGroup>
                <StickyAttachButton type="button" disabled={uploading} onClick={openAttachmentModal}>
                  {uploading ? "Uploading..." : "+ Attach Files"}
                </StickyAttachButton>
                {canEditWorkOrderFields && (
                  <EditModeButton
                    type="button"
                    disabled={isSavingEdits || isEditLockLoading || (isWorkOrderLockedByAnotherUser && !isEditMode)}
                    $isActive={isEditMode}
                    onClick={() => {
                      void toggleEditMode();
                    }}
                  >
                    {isEditMode ? "Cancel Edit" : isEditLockLoading ? "Checking..." : "Edit"}
                  </EditModeButton>
                )}
                {canEditWorkOrderFields && (
                  <SaveChangesButton
                    type="button"
                    disabled={!hasPendingEdits || isSavingEdits || isEditLockLoading || isWorkOrderLockedByAnotherUser}
                    onClick={() => void savePendingWorkOrderChanges()}
                  >
                    {isSavingEdits ? "Saving..." : hasPendingEdits ? "Save Changes" : "No Changes"}
                  </SaveChangesButton>
                )}
              </StickyActionGroup>
            </PageHeaderTopRow>
          </PageHeaderBlock>

          {/* ── Two-column grid — mirrors Kori's grid grid-cols-12 gap-10 ── */}
          <TwoColGrid $isEditMode={isEditMode}>
            {/* ── LEFT col (col-span-7) ── */}
            <LeftCol>
              {/* <ControlGroup>
                <ControlLabel>Status</ControlLabel>
                <StatusStepperTrack>
                  {statusStepperItems.map((statusItem, index) => {
                    const isDone = activeStatusIndex >= 0 && index <= activeStatusIndex;
                    const isCurrent = index === activeStatusIndex;
                    const isCompletedTarget = index === statusStepperItems.length - 1;

                    return (
                      <StatusStepperItem key={statusItem.key}>
                        <StatusStepperNodeRow>
                          <StatusStepperDot $active={!isCompletedTarget && isDone} />
                          {index < statusStepperItems.length - 1 && (
                            <StatusStepperLine $active={!isCompletedTarget && isDone} />
                          )}
                        </StatusStepperNodeRow>
                        <StatusStepperLabel $active={!isCompletedTarget && isCurrent}>
                          {statusItem.label}
                        </StatusStepperLabel>
                      </StatusStepperItem>
                    );
                  })}
                </StatusStepperTrack>
              </ControlGroup> */}

              {/* {!isNoAuthWorkRequest && (
                <DispatchPanel>
                  <DispatchPanelHeader>
                    <div>
                      <DispatchTitle>{issueActionLabel}</DispatchTitle>
                      <DispatchSubTitle>{issueActionContext}</DispatchSubTitle>
                    </div>
                    <Button text={issueActionLabel} onClick={onOpenIssueWorkOrderModal} />
                  </DispatchPanelHeader>
                  <DispatchHint>
                    Use this to send the work order details to the relevant resource and add dispatch in CC.
                  </DispatchHint>
                </DispatchPanel>
              )} */}

              {/* Next Required Action banner */}
              {/* {!isCompleted && (
                <NextActionBanner $severity={nextActionSeverity}>
                  <NextActionText>
                    <NextActionTitle>{nextActionTitle}</NextActionTitle>
                    <NextActionSub>{nextActionSub}</NextActionSub>
                  </NextActionText>
                  {nextActionLabel && (
                    <NextActionBtn $severity={nextActionSeverity} onClick={nextActionHandler}>
                      {nextActionLabel}
                    </NextActionBtn>
                  )}
                </NextActionBanner>
              )} */}

              {/* ── Meta grid (4 cols) — mirrors Kori's grid-cols-4 ── */}
              {/* <MetaGrid>
                <MetaCell>
                  <Eyebrow>Request Type</Eyebrow>
                  <MetaValue>{workOrder?.worktype?.replace(/_/g, " ") || "—"}</MetaValue>
                </MetaCell>
                <MetaCell>
                  <Eyebrow>Priority</Eyebrow>
                  <MetaValue style={{ color: priorityLevel?.color }}>
                    {workOrder?.wopriority_description || "—"}
                  </MetaValue>
                </MetaCell>
                <MetaCell>
                  <Eyebrow>Status</Eyebrow>
                  <MetaValue>{workOrder?.status_description || workOrder?.status || "—"}</MetaValue>
                </MetaCell>
                <MetaCell>
                  <Eyebrow>Site</Eyebrow>
                  <MetaValue style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {addressId || "—"}
                  </MetaValue>
                </MetaCell>
              </MetaGrid> */}

              {/* Description / location block */}
              {/* {(description || addressId) && (
                <DescriptionPanel style={{ marginTop: 32 }}>
                  {addressId && (
                    <div style={{ marginBottom: 8 }}>
                      <Eyebrow>Location</Eyebrow>
                      <DescValue>{addressId}</DescValue>
                    </div>
                  )}
                  {description && (
                    <div>
                      <Eyebrow>Description</Eyebrow>
                      <ReactQuill readOnly theme="snow" value={description} style={{ width: "100%" }} />
                    </div>
                  )}
                </DescriptionPanel>
              )} */}

              <ViewSectionRow style={!isViewOnlyMode ? undefined : { order: 1 }}>
                <ViewSectionMeta>
                  <ViewSectionTitle>Overview</ViewSectionTitle>
                </ViewSectionMeta>
                <ViewSectionBody>
                  {isViewOnlyMode ? (
                    <>
                      <ViewField>
                        <ViewFieldLabel>Description of Work</ViewFieldLabel>
                        <ViewFieldTextArea disabled value={getWorkOrderDescription(workOrder)} />
                      </ViewField>
                      <ViewField>
                        <ViewFieldLabel>Area/Room</ViewFieldLabel>
                        <ViewFieldInput disabled value={specificArea} />
                      </ViewField>
                      {hasParentWorkOrder && (
                        <ViewField>
                          <ViewFieldLabel>Parent Work Order</ViewFieldLabel>
                          <ParentWorkOrderButton type="button" onClick={() => navigate(`/workrequests/${parentWonum}`)}>
                            <ParentWorkOrderButtonText>{`${parentWonum}: ${parentDescription}`}</ParentWorkOrderButtonText>
                            <ParentWorkOrderButtonChevron>›</ParentWorkOrderButtonChevron>
                          </ParentWorkOrderButton>
                        </ViewField>
                      )}
                      {!hasParentWorkOrder && hasChildWorkRequests && (
                        <ViewField>
                          <ViewFieldLabel>Child Work Requests</ViewFieldLabel>
                          <ViewChildList>
                            {childWorkRequests.map((child: WorkOrder) => {
                              const childWonum = child.displaywonum || child.wonum;
                              return (
                                <ChildWorkRequestRow key={childWonum}>
                                  <a href={`/workrequests/${childWonum}`}>
                                    {childWonum}: {child.description}
                                  </a>
                                </ChildWorkRequestRow>
                              );
                            })}
                          </ViewChildList>
                        </ViewField>
                      )}
                    </>
                  ) : (
                    <>
                      <ViewField>
                        <ViewFieldLabel>WONUM *</ViewFieldLabel>
                        <ViewFieldHelper>Auto-generated</ViewFieldHelper>
                        <ViewFieldInput disabled value={workOrder?.wonum || ""} />
                      </ViewField>
                      <ViewField>
                        <FieldLabelRow>
                          <ViewFieldLabel>Title *</ViewFieldLabel>
                          {canEditWorkOrderFields && (
                            <FieldEditButton
                              $isActive={isFieldEditable("title")}
                              type="button"
                              onClick={() => startFieldEdit("title")}
                            >
                              <FontAwesomeIcon icon={faIcons.faPencil as any} />
                            </FieldEditButton>
                          )}
                        </FieldLabelRow>
                        <ViewFieldHelper>Short description shown in lists</ViewFieldHelper>
                        <ViewFieldInput
                          $isEditActive={isFieldEditable("title")}
                          disabled={!isFieldEditable("title")}
                          value={workOrder?.description || ""}
                          onChange={(e) =>
                            setWorkOrder((prev) => (prev ? { ...prev, description: e.target.value } : prev))
                          }
                          onBlur={() => {
                            if (!isFieldEditable("title")) return;
                            stageWorkOrderChanges({ description: (workOrder?.description || "").trim() });
                            finishFieldEdit();
                          }}
                        />
                      </ViewField>
                      <ViewField>
                        <ViewFieldLabel>Client *</ViewFieldLabel>
                        <ViewFieldHelper>Client record for this work order</ViewFieldHelper>
                        {!isFieldEditable("title") ? (
                          <ViewFieldInput disabled value={selectedClientName} />
                        ) : (
                          <ParentWorkOrderButton
                            type="button"
                            disabled={!isFieldEditable("title")}
                            onClick={() => setIsClientModalOpen(true)}
                          >
                            <ParentWorkOrderButtonText>
                              {selectedClientName || "Select client..."}
                            </ParentWorkOrderButtonText>
                            <ParentWorkOrderButtonChevron>›</ParentWorkOrderButtonChevron>
                          </ParentWorkOrderButton>
                        )}
                      </ViewField>
                      <ViewField>
                        <ViewFieldLabel>Location *</ViewFieldLabel>
                        <ViewFieldHelper>Location under the selected client</ViewFieldHelper>
                        {!isFieldEditable("title") ? (
                          <ViewFieldInput disabled value={selectedLocationLabel} />
                        ) : (
                          <ParentWorkOrderButton
                            type="button"
                            disabled={!isFieldEditable("title") || !resolvedClientId}
                            onClick={() => setIsClientModalOpen(true)}
                          >
                            <ParentWorkOrderButtonText>
                              {selectedLocationLabel ||
                                (resolvedClientId ? "Select location..." : "Select client first")}
                            </ParentWorkOrderButtonText>
                            <ParentWorkOrderButtonChevron>›</ParentWorkOrderButtonChevron>
                          </ParentWorkOrderButton>
                        )}
                      </ViewField>
                      <ViewField>
                        <FieldLabelRow>
                          <ViewFieldLabel>Specific area / room</ViewFieldLabel>
                          {canEditWorkOrderFields && (
                            <FieldEditButton
                              $isActive={isFieldEditable("specificArea")}
                              type="button"
                              onClick={() => startFieldEdit("specificArea")}
                            >
                              <FontAwesomeIcon icon={faIcons.faPencil as any} />
                            </FieldEditButton>
                          )}
                        </FieldLabelRow>
                        <ViewFieldInput
                          $isEditActive={isFieldEditable("specificArea")}
                          disabled={!isFieldEditable("specificArea")}
                          value={specificArea === "N/A" ? "" : specificArea}
                          placeholder="e.g. Conference Room A - Level 3 East"
                          onChange={(e) => {
                            const nextSpecificArea = e.target.value;
                            setWorkOrder((prev) =>
                              prev
                                ? ({
                                    ...prev,
                                    pluspspecificarea: nextSpecificArea,
                                    pluspcspecificarea: nextSpecificArea,
                                    specificArea: nextSpecificArea,
                                  } as ExtendedWorkOrder)
                                : prev,
                            );
                          }}
                          onBlur={() => {
                            if (!isFieldEditable("specificArea")) return;
                            const nextSpecificArea = String(
                              (workOrder as any)?.pluspspecificarea ||
                                (workOrder as any)?.pluspcspecificarea ||
                                (workOrder as any)?.specificArea ||
                                "",
                            ).trim();

                            stageWorkOrderChanges(
                              {
                                pluspspecificarea: nextSpecificArea,
                                pluspcspecificarea: nextSpecificArea,
                              },
                              {
                                pluspspecificarea: nextSpecificArea,
                                pluspcspecificarea: nextSpecificArea,
                                specificArea: nextSpecificArea,
                              },
                            );
                            finishFieldEdit();
                          }}
                        />
                      </ViewField>
                      <ViewField>
                        <FieldLabelRow>
                          <ViewFieldLabel>Parent Work Order</ViewFieldLabel>
                          {canEditWorkOrderFields && (
                            <FieldEditButton
                              $isActive={isFieldEditable("parent")}
                              type="button"
                              onClick={() => startFieldEdit("parent")}
                            >
                              <FontAwesomeIcon icon={faIcons.faPencil as any} />
                            </FieldEditButton>
                          )}
                        </FieldLabelRow>
                        {!isFieldEditable("parent") ? (
                          hasParentWorkOrder ? (
                            <ParentWorkOrderButton
                              type="button"
                              onClick={() => navigate(`/workrequests/${parentWonum}`)}
                            >
                              <ParentWorkOrderButtonText>{`${parentWonum}: ${parentDescription}`}</ParentWorkOrderButtonText>
                              <ParentWorkOrderButtonChevron>›</ParentWorkOrderButtonChevron>
                            </ParentWorkOrderButton>
                          ) : (
                            <ViewFieldInput disabled value="No parent work order" />
                          )
                        ) : (
                          <>
                            <ParentWorkOrderButton
                              type="button"
                              disabled={!isFieldEditable("parent")}
                              onClick={() => void openParentWorkOrderModal()}
                            >
                              <ParentWorkOrderButtonText>
                                {hasParentWorkOrder
                                  ? `${parentWonum}: ${parentDescription}`
                                  : "Search and select parent work order..."}
                              </ParentWorkOrderButtonText>
                              <ParentWorkOrderButtonChevron>›</ParentWorkOrderButtonChevron>
                            </ParentWorkOrderButton>
                            {!!parentWonum && (
                              <ClearParentLink type="button" onClick={clearParentWorkOrder}>
                                Clear parent work order
                              </ClearParentLink>
                            )}
                          </>
                        )}
                      </ViewField>
                      <ViewField>
                        <ViewFieldLabel>Asset</ViewFieldLabel>
                        <ViewFieldInput
                          $isEditActive={isFieldEditable("title")}
                          disabled={!isFieldEditable("title")}
                          value={String((workOrder as any)?.assetnum || (workOrder as any)?.asset?.assetnum || "")}
                          placeholder={assetLabel}
                          onChange={(e) =>
                            setWorkOrder((prev) =>
                              prev
                                ? ({
                                    ...prev,
                                    assetnum: e.target.value,
                                  } as ExtendedWorkOrder)
                                : prev,
                            )
                          }
                          onBlur={() => {
                            if (!isFieldEditable("title")) return;
                            stageTextFieldChange("assetnum", String((workOrder as any)?.assetnum || ""));
                          }}
                        />
                      </ViewField>
                    </>
                  )}
                </ViewSectionBody>
              </ViewSectionRow>

              <ViewSectionRow style={!isViewOnlyMode ? undefined : { display: "none" }}>
                <ViewSectionMeta>
                  <ViewSectionTitle>Classification</ViewSectionTitle>
                </ViewSectionMeta>
                <ViewSectionBody>
                  <ViewField>
                    <FieldLabelRow>
                      <ViewFieldLabel>Work Type *</ViewFieldLabel>
                      {canEditWorkOrderFields && (
                        <FieldEditButton
                          $isActive={isFieldEditable("worktype")}
                          type="button"
                          onClick={() => startFieldEdit("worktype")}
                        >
                          <FontAwesomeIcon icon={faIcons.faPencil as any} />
                        </FieldEditButton>
                      )}
                    </FieldLabelRow>
                    {!isFieldEditable("worktype") ? (
                      <ViewFieldInput disabled value={selectedWorkTypeLabel} />
                    ) : (
                      <ViewFieldSelect
                        disabled={!isFieldEditable("worktype")}
                        value={workOrder?.worktype || ""}
                        onChange={(e) => {
                          const nextValue = e.target.value;
                          const nextWorkType = workTypes.find((workType) => workType.type === nextValue);
                          stageWorkOrderChanges(
                            { worktype: nextValue },
                            { worktype: nextValue, workType: nextWorkType?.name || nextValue },
                          );
                        }}
                      >
                        <option value="">Select work type...</option>
                        {workTypes.map((workType) => (
                          <option key={workType.id || workType.type} value={workType.type}>
                            {workType.name}
                          </option>
                        ))}
                      </ViewFieldSelect>
                    )}
                  </ViewField>
                  <ViewField>
                    <FieldLabelRow>
                      <ViewFieldLabel>Service Type *</ViewFieldLabel>
                      {canEditWorkOrderFields && (
                        <FieldEditButton
                          $isActive={isFieldEditable("serviceType")}
                          type="button"
                          onClick={() => startFieldEdit("serviceType")}
                        >
                          <FontAwesomeIcon icon={faIcons.faPencil as any} />
                        </FieldEditButton>
                      )}
                    </FieldLabelRow>
                    {!isFieldEditable("serviceType") ? (
                      <ViewFieldInput disabled value={selectedServiceTypeLabel} />
                    ) : (
                      <ParentWorkOrderButton
                        type="button"
                        disabled={!isFieldEditable("serviceType") || !resolvedClientId}
                        onClick={() => setIsServiceTypeModalOpen(true)}
                      >
                        <ParentWorkOrderButtonText>
                          {selectedServiceTypeLabel ||
                            (resolvedClientId ? "Select service type..." : "Select client first")}
                        </ParentWorkOrderButtonText>
                        <ParentWorkOrderButtonChevron>›</ParentWorkOrderButtonChevron>
                      </ParentWorkOrderButton>
                    )}
                  </ViewField>
                  <ViewField>
                    <FieldLabelRow>
                      <ViewFieldLabel>Priority *</ViewFieldLabel>
                      {canEditWorkOrderFields && (
                        <FieldEditButton
                          $isActive={isFieldEditable("priority")}
                          type="button"
                          onClick={() => startFieldEdit("priority")}
                        >
                          <FontAwesomeIcon icon={faIcons.faPencil as any} />
                        </FieldEditButton>
                      )}
                    </FieldLabelRow>
                    {!isFieldEditable("priority") ? (
                      <ViewFieldInput disabled value={priorityLabel} />
                    ) : (
                      <ViewFieldSelect
                        disabled={!isFieldEditable("priority") || !resolvedClientId}
                        value={
                          workOrder?.wopriority !== undefined && workOrder?.wopriority !== null
                            ? String(workOrder.wopriority)
                            : ""
                        }
                        onChange={(e) => {
                          const nextValue = Number(e.target.value);
                          const nextPriority = priorityOptions.find(
                            (priority: PriorityLevel) => String(priority.priority) === e.target.value,
                          );

                          if (Number.isNaN(nextValue)) return;

                          const nextPriorityDescription =
                            nextPriority?.name ||
                            workOrder?.wopriority_description ||
                            (workOrder as any)?.priority_description ||
                            "";

                          stageWorkOrderChanges(
                            {
                              wopriority: nextValue,
                              wopriority_description: nextPriorityDescription,
                              priority_description: nextPriorityDescription,
                            },
                            {
                              wopriority: nextValue,
                              wopriority_description: nextPriorityDescription,
                              priority_description: nextPriorityDescription,
                            },
                          );
                        }}
                      >
                        <option value="">Select priority...</option>
                        {priorityOptions.map((priority) => (
                          <option key={priority.priority} value={priority.priority}>
                            {priority.name}
                          </option>
                        ))}
                      </ViewFieldSelect>
                    )}
                  </ViewField>
                </ViewSectionBody>
              </ViewSectionRow>

              <ViewSectionRow style={!isViewOnlyMode ? undefined : { display: "none" }}>
                <ViewSectionMeta>
                  <ViewSectionTitle>Related Resource</ViewSectionTitle>
                </ViewSectionMeta>
                <ViewSectionBody>
                  <ViewField>
                    <ViewFieldLabel>Resource</ViewFieldLabel>
                    <ViewFieldHelper>
                      Who is this job assigned to for completion, or to monitor, from field-level workers
                    </ViewFieldHelper>
                    <SegmentedRow>
                      {(["none", "vendor", "team_member"] as ResourceKind[]).map((kind) => {
                        const label = kind === "none" ? "None" : kind === "vendor" ? "Vendor" : "Team Member";
                        return (
                          <SegmentedButton
                            key={kind}
                            type="button"
                            disabled={!isManager}
                            $isActive={resourceKind === kind}
                            onClick={() => {
                              if (kind === "none") {
                                clearRelatedResourceAssignment();
                                return;
                              }

                              setResourceKind(kind);
                              if (resourceKind !== kind) {
                                setResourceId("");
                              }
                              setIsRelatedResourceModalOpen(true);
                            }}
                          >
                            {label}
                          </SegmentedButton>
                        );
                      })}
                    </SegmentedRow>

                    {resourceKind !== "none" && (
                      <ResourceDropdownWrapper>
                        <ParentWorkOrderButton
                          type="button"
                          disabled={!canEditWorkOrderFields}
                          onClick={() => setIsRelatedResourceModalOpen(true)}
                        >
                          <ParentWorkOrderButtonText>
                            {selectedResourceLabel ||
                              (resourceOptions.length === 0
                                ? `No ${resourceKind === "vendor" ? "vendors" : "team members"} on file`
                                : `Search and select ${resourceKind === "vendor" ? "vendor" : "team member"}...`)}
                          </ParentWorkOrderButtonText>
                          <ParentWorkOrderButtonChevron>›</ParentWorkOrderButtonChevron>
                        </ParentWorkOrderButton>
                        {!!resourceId && canEditWorkOrderFields && (
                          <ClearParentLink type="button" onClick={clearRelatedResourceAssignment}>
                            Clear selected resource
                          </ClearParentLink>
                        )}
                      </ResourceDropdownWrapper>
                    )}
                  </ViewField>
                </ViewSectionBody>
              </ViewSectionRow>

              {billingPanel}

              <ViewSectionRow style={!isViewOnlyMode ? undefined : { display: "none" }}>
                <ViewSectionMeta>
                  <ViewSectionTitle>Details</ViewSectionTitle>
                </ViewSectionMeta>
                <ViewSectionBody>
                  <ViewField>
                    <FieldLabelRow>
                      <ViewFieldLabel>Description of work *</ViewFieldLabel>
                      {canEditWorkOrderFields && (
                        <FieldEditButton
                          $isActive={isFieldEditable("description_longdescription")}
                          type="button"
                          onClick={() => startFieldEdit("description_longdescription")}
                        >
                          <FontAwesomeIcon icon={faIcons.faPencil as any} />
                        </FieldEditButton>
                      )}
                    </FieldLabelRow>
                    <ViewFieldHelper>Detailed job description</ViewFieldHelper>
                    <ViewFieldTextArea
                      $isEditActive={isFieldEditable("description_longdescription")}
                      disabled={!isFieldEditable("description_longdescription")}
                      value={getWorkOrderDescription(workOrder)}
                      onChange={(e) =>
                        setWorkOrder((prev) =>
                          prev ? ({ ...prev, description_longdescription: e.target.value } as ExtendedWorkOrder) : prev,
                        )
                      }
                      onBlur={() => {
                        if (!isFieldEditable("description_longdescription")) return;
                        const nextValue = (workOrder?.description_longdescription || "").trim();
                        stageWorkOrderChanges({ description_longdescription: nextValue });
                        finishFieldEdit();
                      }}
                    />
                  </ViewField>

                  <ViewField>
                    <ViewFieldLabel>Attachments</ViewFieldLabel>
                    <ViewFieldHelper>PDF, JPG/photos, Excel, Word, etc.</ViewFieldHelper>
                    <DetailsAttachLabel $disabled={uploading || (!isManager && !isNoAuthWorkRequest)}>
                      <DetailsAttachText>
                        {uploading ? "Uploading..." : "No files attached. Drop files here or click to browse."}
                      </DetailsAttachText>
                      <DetailsAttachButton as="span">+ Attach Files</DetailsAttachButton>
                      <input
                        ref={detailsAttachmentInputRef}
                        type="file"
                        multiple
                        disabled={uploading || (!isManager && !isNoAuthWorkRequest)}
                        style={{ display: "none" }}
                        onChange={(e) => onAttach(e.target.files)}
                      />
                    </DetailsAttachLabel>
                    {clientPhotos?.length > 0 && (
                      <InputsRow>
                        <PhotoInput $isMobile={isMobile}>
                          <label>
                            Photos<span>(optional):</span>
                          </label>
                          <PhotoUpload
                            files={files}
                            isLoading={false}
                            images={clientPhotos}
                            setFiles={setFiles}
                            isViewMode
                          />
                        </PhotoInput>
                      </InputsRow>
                    )}
                    {/* <AttachmentRow>
                      <Attachments
                        documents={documents}
                        workOrderHref={workOrder?.href}
                        workOrderId={workOrder?.workorderid}
                      />
                    </AttachmentRow> */}
                  </ViewField>
                </ViewSectionBody>
              </ViewSectionRow>

              <ViewSectionRow style={!isViewOnlyMode ? undefined : { order: 2 }}>
                <ViewSectionMeta>
                  <ViewSectionTitle>Scheduling</ViewSectionTitle>
                </ViewSectionMeta>
                <ViewSectionBody>
                  <ViewField>
                    <FieldLabelRow>
                      <ViewFieldLabel>Scheduled Start</ViewFieldLabel>
                      {canEditWorkOrderFields && (
                        <FieldEditButton
                          $isActive={isFieldEditable("schedstart")}
                          type="button"
                          onClick={() => startFieldEdit("schedstart")}
                        >
                          <FontAwesomeIcon icon={faIcons.faPencil as any} />
                        </FieldEditButton>
                      )}
                    </FieldLabelRow>
                    <DateTimePickerWrapper>
                      <ReactDatePicker
                        selected={parseLocalDateTime(scheduleDrafts.schedstart)}
                        onChange={(date) => {
                          const nextValue = formatDateTimeLocalValue(date as Date | null);
                          setScheduleDrafts((prev) => ({ ...prev, schedstart: nextValue }));
                          void updateScheduleField("schedstart", "Scheduled Start", nextValue);
                        }}
                        showTimeSelect
                        timeIntervals={15}
                        dateFormat="MM/dd/yyyy h:mm aa"
                        placeholderText="Select date and time"
                        popperClassName="kw-datepicker-popper"
                        calendarClassName="kw-datepicker"
                        showPopperArrow={false}
                        customInput={<ViewDateTimePickerInput $isEditActive={isFieldEditable("schedstart")} />}
                      />
                    </DateTimePickerWrapper>
                  </ViewField>

                  <ViewField>
                    <FieldLabelRow>
                      <ViewFieldLabel>Scheduled Finish</ViewFieldLabel>
                      {canEditWorkOrderFields && (
                        <FieldEditButton
                          $isActive={isFieldEditable("schedfinish")}
                          type="button"
                          onClick={() => startFieldEdit("schedfinish")}
                        >
                          <FontAwesomeIcon icon={faIcons.faPencil as any} />
                        </FieldEditButton>
                      )}
                    </FieldLabelRow>
                    <DateTimePickerWrapper>
                      <ReactDatePicker
                        selected={parseLocalDateTime(scheduleDrafts.schedfinish)}
                        onChange={(date) => {
                          const nextValue = formatDateTimeLocalValue(date as Date | null);
                          setScheduleDrafts((prev) => ({ ...prev, schedfinish: nextValue }));
                          void updateScheduleField("schedfinish", "Scheduled Finish", nextValue);
                        }}
                        showTimeSelect
                        timeIntervals={15}
                        dateFormat="MM/dd/yyyy h:mm aa"
                        placeholderText="Select date and time"
                        popperClassName="kw-datepicker-popper"
                        calendarClassName="kw-datepicker"
                        showPopperArrow={false}
                        customInput={<ViewDateTimePickerInput $isEditActive={isFieldEditable("schedfinish")} />}
                      />
                    </DateTimePickerWrapper>
                  </ViewField>

                  <ViewField>
                    <FieldLabelRow>
                      <ViewFieldLabel>Actual Start</ViewFieldLabel>
                      {canEditWorkOrderFields && (
                        <FieldEditButton
                          $isActive={isFieldEditable("actstart")}
                          type="button"
                          onClick={() => startFieldEdit("actstart")}
                        >
                          <FontAwesomeIcon icon={faIcons.faPencil as any} />
                        </FieldEditButton>
                      )}
                    </FieldLabelRow>
                    <DateTimePickerWrapper>
                      <ReactDatePicker
                        selected={parseLocalDateTime(scheduleDrafts.actstart)}
                        onChange={(date) => {
                          const nextValue = formatDateTimeLocalValue(date as Date | null);
                          setScheduleDrafts((prev) => ({ ...prev, actstart: nextValue }));
                          void updateScheduleField("actstart", "Actual Start", nextValue);
                        }}
                        showTimeSelect
                        timeIntervals={15}
                        dateFormat="MM/dd/yyyy h:mm aa"
                        placeholderText="Select date and time"
                        popperClassName="kw-datepicker-popper"
                        calendarClassName="kw-datepicker"
                        showPopperArrow={false}
                        customInput={<ViewDateTimePickerInput $isEditActive={isFieldEditable("actstart")} />}
                      />
                    </DateTimePickerWrapper>
                  </ViewField>

                  <ViewField>
                    <FieldLabelRow>
                      <ViewFieldLabel>Actual Finish</ViewFieldLabel>
                      {canEditWorkOrderFields && (
                        <FieldEditButton
                          $isActive={isFieldEditable("actfinish")}
                          type="button"
                          onClick={() => startFieldEdit("actfinish")}
                        >
                          <FontAwesomeIcon icon={faIcons.faPencil as any} />
                        </FieldEditButton>
                      )}
                    </FieldLabelRow>
                    <DateTimePickerWrapper>
                      <ReactDatePicker
                        selected={parseLocalDateTime(scheduleDrafts.actfinish)}
                        onChange={(date) => {
                          const nextValue = formatDateTimeLocalValue(date as Date | null);
                          setScheduleDrafts((prev) => ({ ...prev, actfinish: nextValue }));
                          void updateScheduleField("actfinish", "Actual Finish", nextValue);
                        }}
                        showTimeSelect
                        timeIntervals={15}
                        dateFormat="MM/dd/yyyy h:mm aa"
                        placeholderText="Select date and time"
                        popperClassName="kw-datepicker-popper"
                        calendarClassName="kw-datepicker"
                        showPopperArrow={false}
                        customInput={<ViewDateTimePickerInput $isEditActive={isFieldEditable("actfinish")} />}
                      />
                    </DateTimePickerWrapper>
                  </ViewField>
                </ViewSectionBody>
              </ViewSectionRow>

              <ViewSectionRow style={!isViewOnlyMode ? undefined : { order: 6 }}>
                <ViewSectionMeta>
                  <ViewSectionTitle>Requestor</ViewSectionTitle>
                </ViewSectionMeta>
                <ViewSectionBody>
                  <ViewFieldGrid>
                    <ViewField>
                      <ViewFieldLabel>First Name</ViewFieldLabel>
                      <ViewFieldInput
                        $isEditActive={isFieldEditable("title")}
                        disabled={!isFieldEditable("title")}
                        value={workOrder?.firstname || ""}
                        onChange={(e) => setWorkOrder((prev) => (prev ? { ...prev, firstname: e.target.value } : prev))}
                        onBlur={() => {
                          if (!isFieldEditable("title")) return;
                          stageTextFieldChange("firstname", workOrder?.firstname || "");
                        }}
                      />
                    </ViewField>
                    <ViewField>
                      <ViewFieldLabel>Last Name</ViewFieldLabel>
                      <ViewFieldInput
                        $isEditActive={isFieldEditable("title")}
                        disabled={!isFieldEditable("title")}
                        value={workOrder?.lastname || ""}
                        onChange={(e) => setWorkOrder((prev) => (prev ? { ...prev, lastname: e.target.value } : prev))}
                        onBlur={() => {
                          if (!isFieldEditable("title")) return;
                          stageTextFieldChange("lastname", workOrder?.lastname || "");
                        }}
                      />
                    </ViewField>
                    <ViewField>
                      <ViewFieldLabel>Email</ViewFieldLabel>
                      <ViewFieldInput
                        $isEditActive={isFieldEditable("title")}
                        type="email"
                        disabled={!isFieldEditable("title")}
                        value={workOrder?.email || ""}
                        onChange={(e) => setWorkOrder((prev) => (prev ? { ...prev, email: e.target.value } : prev))}
                        onBlur={() => {
                          if (!isFieldEditable("title")) return;
                          stageTextFieldChange("email", workOrder?.email || "");
                        }}
                      />
                    </ViewField>
                    <ViewField>
                      <ViewFieldLabel>Phone Number</ViewFieldLabel>
                      <ViewFieldInput
                        $isEditActive={isFieldEditable("title")}
                        disabled={!isFieldEditable("title")}
                        value={workOrder?.phonenumber || ""}
                        onChange={(e) =>
                          setWorkOrder((prev) => (prev ? { ...prev, phonenumber: e.target.value } : prev))
                        }
                        onBlur={() => {
                          if (!isFieldEditable("title")) return;
                          stageTextFieldChange("phonenumber", workOrder?.phonenumber || "");
                        }}
                      />
                    </ViewField>
                  </ViewFieldGrid>
                </ViewSectionBody>
              </ViewSectionRow>

              {error && <ErrorMessage>{error}</ErrorMessage>}
              {statusTransitionSuccess && <SuccessMessage>{statusTransitionSuccess}</SuccessMessage>}

              {/* {workOrder && (
                <Details>
                  <DetailsSection
                    isNoAuthWorkRequest={isNoAuthWorkRequest}
                    technicianPhotos={technicianPhotos}
                    $isMobile={isMobile}
                    workOrder={workOrder as WorkOrder}
                    workOrderWorklog={worklog}
                    isViewMode
                    areImagesLoading={false}
                    timezone={timezone}
                    workOrderID={workOrder.wonum as string}
                  />
                </Details>
              )} */}

              <div style={{ order: 7, marginTop: 32 }}>{timelinePanel}</div>
            </LeftCol>

            {/* ── RIGHT col (col-span-5) — mirrors Kori's aside ── */}
            <RightCol>
              {isViewOnlyMode ? (
                <>
                  <Eyebrow style={{ marginBottom: 16 }}>Overview</Eyebrow>

                  <ControlGroup>
                    <ControlLabel>Current Status</ControlLabel>
                    <StatusSpotlight $tone={statusHighlightTone}>
                      <StatusBeacon $tone={statusHighlightTone} />
                      <StatusContent>
                        <StatusTitle>{selectedStatusLabel}</StatusTitle>
                        <StatusCode>Code: {currentStatusCode || "N/A"}</StatusCode>
                      </StatusContent>
                    </StatusSpotlight>
                  </ControlGroup>

                  <ControlGroup>
                    <ControlLabel>Change Status</ControlLabel>
                    {canEditWorkOrderFields && !isWorkOrderLockedByAnotherUser ? (
                      moveToSidebarOptions.length ? (
                        <StatusTransitionInline>
                          <ViewFieldSelect
                            $isEditActive
                            value={selectedSidebarStatusCode}
                            disabled={isStatusTransitioning || isSavingEdits || isEditLockLoading}
                            onChange={(e) => setSelectedSidebarStatusCode(e.target.value)}
                          >
                            {moveToSidebarOptions.map((statusItem) => (
                              <option
                                key={`transition-${statusItem.key}`}
                                value={statusItem.code}
                                disabled={!statusItem.isAvailable || !statusItem.code}
                              >
                                {statusItem.label}
                                {!statusItem.isAvailable ? " (Unavailable)" : ""}
                              </option>
                            ))}
                          </ViewFieldSelect>
                          <StatusApplyButton
                            type="button"
                            disabled={
                              !selectedSidebarStatusCode ||
                              isStatusTransitioning ||
                              isSavingEdits ||
                              isEditLockLoading ||
                              !availableSidebarTransitions.some((item) => item.code === selectedSidebarStatusCode)
                            }
                            onClick={() => {
                              if (!selectedSidebarStatusCode) return;
                              void transitionWorkOrderStatus(selectedSidebarStatusCode);
                            }}
                          >
                            {isStatusTransitioning ? "Applying..." : "Apply"}
                          </StatusApplyButton>
                        </StatusTransitionInline>
                      ) : (
                        <StatusTransitionHint>No status transitions available.</StatusTransitionHint>
                      )
                    ) : (
                      <StatusTransitionHint>
                        {canEditWorkOrderFields
                          ? "Status changes are disabled while another user is editing this work order."
                          : "Only managers can change status."}
                      </StatusTransitionHint>
                    )}
                  </ControlGroup>

                  <ControlGroup>
                    <ControlLabel>Priority</ControlLabel>
                    <ViewFieldInput disabled value={priorityLabel} />
                  </ControlGroup>

                  <ControlGroup>
                    <ControlLabel>Assignee</ControlLabel>
                    <ViewFieldInput disabled value={assigneeLabel} />
                  </ControlGroup>

                  <ControlGroup>
                    <ControlLabel>Work Type</ControlLabel>
                    <ViewFieldInput disabled value={selectedWorkTypeLabel} />
                  </ControlGroup>

                  <ControlGroup>
                    <ControlLabel>Service</ControlLabel>
                    <ViewFieldInput disabled value={selectedServiceTypeLabel} />
                  </ControlGroup>

                  <div style={{ marginTop: 24 }}>{activityPanel}</div>

                  <AttachmentGallerySection>
                    <Eyebrow style={{ marginBottom: 12 }}>Attachments</Eyebrow>
                    {attachmentDocuments.length > 0 ? (
                      <AttachmentGalleryGrid>
                        {attachmentDocuments.map((documentItem: any) => {
                          const label = getAttachmentLabel(documentItem);
                          const isImage = isImageAttachment(documentItem);
                          return (
                            <AttachmentGalleryCard
                              key={documentItem.attachmentId || documentItem.href || documentItem.fileName}
                              type="button"
                              onClick={() => openAttachmentPreview(documentItem)}
                            >
                              <AttachmentGalleryThumb $isImage={isImage}>
                                {isImage ? (
                                  <img src={documentItem.href} alt={label} />
                                ) : (
                                  <AttachmentGalleryIcon>
                                    {label.split(".").pop()?.toUpperCase() || "FILE"}
                                  </AttachmentGalleryIcon>
                                )}
                              </AttachmentGalleryThumb>
                              <AttachmentGalleryMeta>
                                <AttachmentGalleryName title={label}>{label}</AttachmentGalleryName>
                                <AttachmentGalleryHint>Open attachment</AttachmentGalleryHint>
                              </AttachmentGalleryMeta>
                            </AttachmentGalleryCard>
                          );
                        })}
                      </AttachmentGalleryGrid>
                    ) : (
                      <AttachmentEmptyState>No attachments uploaded yet.</AttachmentEmptyState>
                    )}
                  </AttachmentGallerySection>
                </>
              ) : (
                <>
                  <Eyebrow style={{ marginBottom: 16 }}>Control</Eyebrow>

                  <ControlGroup>
                    <ControlLabel>Current Status</ControlLabel>
                    <StatusSpotlight $tone={statusHighlightTone}>
                      <StatusBeacon $tone={statusHighlightTone} />
                      <StatusContent>
                        <StatusTitle>{selectedStatusLabel}</StatusTitle>
                        <StatusCode>Code: {currentStatusCode || "N/A"}</StatusCode>
                      </StatusContent>
                    </StatusSpotlight>
                  </ControlGroup>

                  <ControlGroup>
                    <ControlLabel>Change Status</ControlLabel>
                    {canEditWorkOrderFields ? (
                      <ViewFieldSelect
                        disabled={
                          isStatusTransitioning ||
                          isSavingEdits ||
                          !statusList.length ||
                          isWorkOrderLockedByAnotherUser ||
                          isEditLockLoading
                        }
                        value={String(workOrder?.status || "")}
                        onChange={(e) => {
                          void transitionWorkOrderStatus(e.target.value);
                        }}
                      >
                        <option value={String(workOrder?.status || "")}>{selectedStatusLabel}</option>
                        {statusList
                          .filter((statusOption) => String(statusOption.id) !== String(workOrder?.status || ""))
                          .map((statusOption) => (
                            <option key={statusOption.id} value={statusOption.id}>
                              {statusOption.value}
                            </option>
                          ))}
                      </ViewFieldSelect>
                    ) : (
                      <ViewFieldInput disabled value={selectedStatusLabel} />
                    )}
                  </ControlGroup>

                  <ControlGroup>
                    <ControlLabel>Priority</ControlLabel>
                    <ViewFieldInput disabled value={priorityLabel} />
                  </ControlGroup>

                  <ControlGroup>
                    <ControlLabel>Assignee</ControlLabel>
                    <ViewFieldInput disabled value={assigneeLabel} />
                  </ControlGroup>
                </>
              )}
            </RightCol>
          </TwoColGrid>
        </Content>
      </Container>
    </LoadingContainer>
  );
};

// ─── Styled components ─────────────────────────────────────────────────────────

const Container = styled.div`
  width: 100%;
  height: inherit;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 40px;
`;

const EmptyContainer = styled.div`
  width: 32px;
  height: 32px;
`;

const SaveChangesButton = styled.button`
  border: 1px solid ${colors.black.light2};
  background: ${colors.black.light2};
  color: ${colors.white.default};
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;

const EditModeButton = styled(SaveChangesButton)<{ $isActive?: boolean }>`
  background: ${({ $isActive }) => ($isActive ? colors.white.default : colors.black.light2)};
  color: ${({ $isActive }) => ($isActive ? colors.black.light2 : colors.white.default)};
`;

const Content = styled.div`
  margin: 30px;
  background-color: ${colors.white.default};
`;

// Page header
const PageHeaderBlock = styled.div`
  margin-bottom: 12px;
  // padding-bottom: 20px;
  padding-top: 12px;
  // border-bottom: 1px solid ${colors.grey.light12};
  position: sticky;
  top: 60px; /* ← match the height of the app's top nav/search bar */
  z-index: 20;
  background-color: ${colors.white.default};
`;

const PageHeaderTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

const PageHeaderDetails = styled.div`
  min-width: 0;
  flex: 1 1 320px;
`;

const StickyActionGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-left: auto;
`;

const StickyAttachButton = styled(SaveChangesButton)`
  font-size: 11px;
  letter-spacing: 0.08em;
`;

const PageEyebrow = styled.div`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: ${colors.grey.default};
  margin-bottom: 6px;
`;

const PageTitle = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: ${colors.black.light2};
  margin: 0 0 6px;
`;

const PageMeta = styled.p`
  font-size: 12px;
  font-weight: 300;
  color: ${colors.grey.default};
  margin: 0;
`;

// Two-column grid — mirrors Kori's grid grid-cols-12 gap-10
const TwoColGrid = styled.div<{ $isEditMode?: boolean }>`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 340px);
  gap: 40px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const LeftCol = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

const RightCol = styled.aside`
  border-left: 1px solid ${colors.grey.light12};
  padding-left: 28px;
  position: sticky;
  top: 180px;
  width: 100%;
  max-width: 340px;
  justify-self: end;

  @media (max-width: 900px) {
    border-left: none;
    border-top: 1px solid ${colors.grey.light12};
    padding-left: 0;
    padding-top: 24px;
    max-width: none;
    justify-self: stretch;
  }
`;

const AttachmentEmptyState = styled.div`
  border: 1px dashed ${colors.grey.light12};
  padding: 12px 14px;
  font-size: 12px;
  color: ${colors.grey.default};
  background: #fafafa;
`;

// Eyebrow labels
const Eyebrow = styled.div`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${colors.grey.default};
`;

const EyebrowStrong = styled(Eyebrow)`
  font-size: 12px;
  color: ${colors.black.light2};
`;

const ViewSectionRow = styled.section`
  display: grid;
  grid-template-columns: 156px 1fr;
  gap: 48px;
  padding: 32px 0;
  border-top: 1px solid ${colors.grey.light12};

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const ViewSectionMeta = styled.div``;

// const ViewSectionIndex = styled.div`
//   font-size: 11px;
//   color: ${colors.grey.default};
//   letter-spacing: 0.04em;
// `;

const ViewSectionTitle = styled.h2`
  margin: 8px 0 0;
  font-size: 20px;
  line-height: 1.25;
  color: ${colors.black.light2};
`;

// const ViewSectionHelper = styled.p`
//   margin: 10px 0 0;
//   font-size: 12px;
//   font-weight: 300;
//   color: ${colors.grey.default};
//   line-height: 1.5;
// `;

const ViewSectionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ViewField = styled.div``;

const ViewFieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

const ViewFieldLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${colors.black.light2};
  font-weight: 600;
`;

const ViewFieldHelper = styled.p`
  margin: -4px 0 12px;
  font-size: 12px;
  font-weight: 300;
  color: ${colors.grey.default};
  line-height: 1.5;
`;

const ViewFieldInput = styled.input<{ $isEditActive?: boolean }>`
  width: 100%;
  border: 1px solid ${({ $isEditActive }) => ($isEditActive ? colors.black.light2 : colors.grey.light12)};
  padding: 10px 12px;
  font-size: 13px;
  background: ${({ $isEditActive }) => ($isEditActive ? colors.white.default : "#f7f8fa")};
  color: ${colors.black.light2};

  &:disabled {
    color: ${colors.black.light2};
    opacity: 1;
    cursor: default;
  }
`;

const ViewDateTimePickerInput = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement> & { $isEditActive?: boolean }
>(({ $isEditActive, ...props }, ref) => <ViewFieldInput {...props} ref={ref} readOnly $isEditActive={$isEditActive} />);

ViewDateTimePickerInput.displayName = "ViewDateTimePickerInput";

const DateTimePickerWrapper = styled.div`
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    display: block;
  }

  .kw-datepicker-popper {
    z-index: 4;
  }

  .kw-datepicker {
    border: 1px solid ${colors.grey.light12};
    border-radius: 0;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.1);
    font-family: inherit;
  }

  .kw-datepicker .react-datepicker__header {
    background: #f7f8fa;
    border-bottom: 1px solid ${colors.grey.light12};
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .kw-datepicker .react-datepicker__current-month,
  .kw-datepicker .react-datepicker-time__header,
  .kw-datepicker .react-datepicker-year-header {
    color: ${colors.black.light2};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .kw-datepicker .react-datepicker__day-name,
  .kw-datepicker .react-datepicker__day,
  .kw-datepicker .react-datepicker__time-name {
    color: ${colors.black.light2};
    width: 2rem;
    line-height: 2rem;
    margin: 0.18rem;
  }

  .kw-datepicker .react-datepicker__day:hover,
  .kw-datepicker .react-datepicker__time-list-item:hover {
    background: #eef2f6;
  }

  .kw-datepicker .react-datepicker__day--selected,
  .kw-datepicker .react-datepicker__day--keyboard-selected,
  .kw-datepicker .react-datepicker__time-list-item--selected {
    background: ${colors.black.light2};
    color: ${colors.white.default};
    font-weight: 600;
  }

  .kw-datepicker .react-datepicker__time-container {
    border-left: 1px solid ${colors.grey.light12};
  }

  .kw-datepicker .react-datepicker__time-box {
    width: 7.5rem;
  }

  .kw-datepicker .react-datepicker__time-list {
    padding: 6px 0;
  }

  .kw-datepicker .react-datepicker__time-list-item {
    height: 2.2rem !important;
    line-height: 2.2rem !important;
    margin: 0;
    padding: 0 10px;
    font-size: 13px;
  }

  .kw-datepicker .react-datepicker__navigation-icon::before {
    border-color: ${colors.grey.dark3};
  }
`;

const ViewFieldSelect = styled.select<{ $isEditActive?: boolean }>`
  width: 100%;
  border: 1px solid ${({ $isEditActive }) => ($isEditActive ? colors.black.light2 : colors.grey.light12)};
  padding: 10px 12px;
  font-size: 13px;
  background: ${({ $isEditActive }) => ($isEditActive ? colors.white.default : "#f7f8fa")};
  color: ${colors.black.light2};

  &:disabled {
    color: ${colors.black.light2};
    opacity: 1;
    cursor: default;
  }
`;

const ViewFieldTextArea = styled.textarea<{ $isEditActive?: boolean }>`
  width: 100%;
  min-height: 140px;
  border: 1px solid ${({ $isEditActive }) => ($isEditActive ? colors.black.light2 : colors.grey.light12)};
  padding: 14px 16px;
  font-size: 14px;
  resize: vertical;
  background: ${({ $isEditActive }) => ($isEditActive ? colors.white.default : "#f7f8fa")};
  color: ${colors.black.light2};

  &:disabled {
    color: ${colors.black.light2};
    opacity: 1;
    cursor: default;
  }
`;

const ViewChildList = styled.div`
  border: 1px solid ${colors.grey.light12};
  padding: 12px 14px;
  background: #ffffff;
`;

// Next Required Action banner
// type Severity = "critical" | "high" | "normal";

// const severityStyles: Record<Severity, { bg: string; border: string; color: string }> = {
//   critical: { bg: colors.black.light2, border: colors.black.light2, color: colors.white.default },
//   high: { bg: "#fff3cd", border: "#ffc107", color: "#664d03" },
//   normal: { bg: "#f0f4ff", border: "#c7d7f5", color: "#1a3068" },
// };

// const NextActionBanner = styled.div<{ $severity: Severity }>`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 16px;
//   padding: 14px 20px;
//   border: 1px solid ${({ $severity }) => severityStyles[$severity].border};
//   background: ${({ $severity }) => severityStyles[$severity].bg};
//   color: ${({ $severity }) => severityStyles[$severity].color};
//   margin-bottom: 8px;
// `;

// const NextActionText = styled.div`
//   flex: 1;
// `;

// const NextActionTitle = styled.div`
//   font-size: 13px;
//   font-weight: 700;
// `;

// const NextActionSub = styled.div`
//   font-size: 11px;
//   font-weight: 300;
//   margin-top: 2px;
//   opacity: 0.85;
// `;

// const NextActionBtn = styled.button<{ $severity: Severity }>`
//   font-size: 11px;
//   font-weight: 700;
//   text-transform: uppercase;
//   letter-spacing: 0.1em;
//   padding: 8px 14px;
//   background: transparent;
//   border: 1px solid
//     ${({ $severity }) => ($severity === "critical" ? colors.white.default : severityStyles[$severity].border)};
//   color: inherit;
//   cursor: pointer;
//   white-space: nowrap;
//   &:hover {
//     opacity: 0.8;
//   }
// `;

// Meta grid (4 cols)
// const MetaGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(4, 1fr);
//   gap: 24px;
//   margin-top: 32px;
// `;

// const MetaCell = styled.div``;

// const MetaValue = styled.div`
//   font-size: 13px;
//   font-weight: 600;
//   margin-top: 4px;
//   color: ${colors.black.light2};
// `;

// Description panel
// const DescriptionPanel = styled.div`
//   border: 1px solid ${colors.grey.light12};
//   padding: 20px;

//   .ql-toolbar.ql-snow {
//     display: none;
//     border: none;
//   }
//   .ql-container.ql-snow {
//     border: none;
//   }
//   .ql-editor {
//     border: 1px solid ${colors.grey.light13};
//     padding: 10px;
//     font-size: 13px;
//   }
// `;

// const DescValue = styled.div`
//   font-size: 13px;
//   margin-top: 4px;
//   color: ${colors.grey.dark};
// `;

// Activity panel
const ActivityPanel = styled.div`
  border: 1px solid ${colors.grey.light12};
`;

const ActivityPanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px 12px;
  border-bottom: 1px solid ${colors.grey.light12};
`;

const ActivityPanelSub = styled.p`
  font-size: 12px;
  font-weight: 300;
  color: ${colors.grey.default};
  margin: 4px 0 0;
`;

const TimelineEyebrow = styled(Eyebrow)``;

const ActivityPanelBody = styled.div`
  padding: 16px 20px;

  @media (max-width: 900px) {
    padding: 12px;
  }
`;

const NoAuthCompletionSection = styled.div`
  margin-bottom: 20px;

  @media (max-width: 900px) {
    margin-bottom: 14px;
  }
`;

const NoAuthCompletionActions = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const NoAuthCompletionHint = styled.p`
  margin: 0;
  font-size: 11px;
  font-weight: 300;
  color: ${colors.grey.default};
`;

const KTextareaStyled = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 300;
  color: ${colors.black.light2};
  border: 1px solid ${colors.grey.light12};
  resize: vertical;
  outline: none;
  font-family: inherit;
  &:focus {
    border-color: ${colors.grey.dark};
  }
`;

const KButtonStyled = styled.button`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  padding: 10px 18px;
  background: ${colors.black.light2};
  color: ${colors.white.default};
  border: none;
  cursor: pointer;
  &:hover {
    opacity: 0.85;
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const InlineComposerRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const InlineComposerMeta = styled.div`
  min-width: 0;
`;

const InlineComposerUser = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${colors.black.light2};
`;

const InlinePlusButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid ${colors.grey.light12};
  background: ${colors.white.default};
  font-size: 22px;
  line-height: 1;
  color: ${colors.black.light2};
  cursor: pointer;

  &:hover {
    background: #f9f9f9;
  }
`;

const InlineComposerExpanded = styled.div`
  margin-top: 12px;
`;

const InlineComposerActions = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const InlineCancelButton = styled.button`
  border: 1px solid ${colors.grey.light12};
  background: ${colors.white.default};
  color: ${colors.black.light2};
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 10px 14px;
  cursor: pointer;
`;

const AttachLabel = styled.label`
  border: 1px dashed ${colors.grey.light4};
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  cursor: pointer;
  &:hover {
    background: #f9f9f9;
  }

  @media (max-width: 900px) {
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const AttachLabelText = styled.span`
  font-size: 12px;
  font-weight: 300;
  color: ${colors.grey.default};
`;

const AttachLabelButton = styled.span`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  background: ${colors.black.light2};
  color: ${colors.white.default};
  padding: 8px 14px;
  white-space: nowrap;
`;

// Timeline
const TimelineHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

const ActivityFilterTabs = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid ${colors.grey.light12};
  background: ${colors.white.default};
`;

const ActivityFilterTabButton = styled.button<{ $active: boolean }>`
  border: none;
  border-left: 1px solid ${colors.grey.light12};
  background: ${({ $active }) => ($active ? colors.black.light2 : colors.white.default)};
  color: ${({ $active }) => ($active ? colors.white.default : colors.black.light2)};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 8px 12px;
  cursor: pointer;

  &:first-child {
    border-left: none;
  }
`;

const TimelineList = styled.div`
  border: 1px solid ${colors.grey.light12};
`;

const TimelineRow = styled.div`
  display: grid;
  grid-template-columns: 160px 120px 1fr;
  padding: 10px 16px;
  border-top: 1px solid ${colors.grey.light12};
  &:first-child {
    border-top: none;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 4px;
    padding: 10px 12px;
  }
`;

const TimelineTime = styled.span`
  font-size: 11px;
  font-weight: 300;
  color: ${colors.grey.default};
`;

const TimelineWho = styled.span`
  font-size: 12px;
  color: ${colors.black.light2};
`;

const TimelineEvent = styled.span`
  font-size: 12px;
  color: ${colors.black.light2};
`;

const TimelineEmpty = styled.div`
  padding: 16px;
  font-size: 13px;
  color: ${colors.grey.default};
`;

// Linked documents
// const LinkedDocsList = styled.div`
//   border: 1px solid ${colors.grey.light12};
// `;

// const LinkedDocRow = styled.div`
//   padding: 12px 16px;
//   border-top: 1px solid ${colors.grey.light12};
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   cursor: pointer;
//   &:first-child {
//     border-top: none;
//   }
//   &:hover {
//     background: #f9f9f9;
//   }
// `;

// const LinkedDocType = styled.div`
//   font-size: 13px;
//   color: ${colors.black.light2};
//   text-transform: capitalize;
// `;

// const LinkedDocMeta = styled.div`
//   font-size: 11px;
//   font-weight: 300;
//   color: ${colors.grey.default};
// `;

const AttachmentGallerySection = styled.div`
  margin-top: 20px;
`;

const AttachmentGalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(88px, 1fr));
  gap: 6px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(auto-fill, minmax(84px, 1fr));
  }
`;

const AttachmentGalleryCard = styled.a`
  display: flex;
  flex-direction: column;
  gap: 4px;
  border: 1px solid ${colors.grey.light12};
  background: ${colors.white.default};
  padding: 6px;
  text-decoration: none;
  color: inherit;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: ${colors.black.light2};
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
  }
`;

const AttachmentGalleryThumb = styled.div<{ $isImage: boolean }>`
  width: 100%;
  aspect-ratio: 3 / 2;
  border: 1px solid ${colors.grey.light12};
  background: ${({ $isImage }) => ($isImage ? "#f8fafc" : "#f4f4f4")};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const AttachmentGalleryIcon = styled.div`
  padding: 6px;
  font-size: 9px;
  font-weight: 800;
  color: ${colors.black.light2};
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const AttachmentGalleryMeta = styled.div`
  min-width: 0;
`;

const AttachmentGalleryName = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${colors.black.light2};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const AttachmentGalleryHint = styled.div`
  margin-top: 1px;
  font-size: 9px;
  color: ${colors.grey.default};
`;

// Billing panel
const BillingPanel = styled.div`
  border-top: 1px solid ${colors.grey.light12};
  border-bottom: 1px solid ${colors.grey.light12};
  padding: 0;
  background: ${colors.white.default};
`;

const BillingSectionRow = styled.div`
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 40px;
  padding: 28px 0px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const BillingSectionMeta = styled.div``;

const BillingSectionEyebrow = styled.div`
  font-size: 11px;
  color: ${colors.grey.default};
  letter-spacing: 0.08em;
  font-weight: 700;
`;

const BillingSectionTitle = styled.h3`
  margin: 8px 0 0;
  font-size: 20px;
  line-height: 1.25;
  color: ${colors.black.light2};
`;

const BillingSectionHelper = styled.p`
  margin: 8px 0 0;
  font-size: 12px;
  color: ${colors.grey.default};
`;

const BillingSectionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const BillingField = styled.div``;

const FieldLabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const FieldEditButton = styled.button<{ $isActive?: boolean }>`
  border: 1px solid ${colors.grey.light12};
  background: ${({ $isActive }) => ($isActive ? colors.black.light2 : colors.white.default)};
  color: ${({ $isActive }) => ($isActive ? colors.white.default : colors.black.light2)};
  width: 28px;
  height: 28px;
  display: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${colors.black.light2};
  }
`;

const BillingFieldLabel = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${colors.black.light2};
  font-weight: 600;
  margin-bottom: 8px;
`;

const BillingFieldHelper = styled.div`
  font-size: 12px;
  color: ${colors.grey.default};
  margin-bottom: 10px;
`;

const SegmentedRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const SegmentedButton = styled.button<{ $isActive: boolean }>`
  border: 1px solid ${({ $isActive }) => ($isActive ? colors.black.light2 : colors.grey.light12)};
  background: ${({ $isActive }) => ($isActive ? colors.black.light2 : colors.white.default)};
  color: ${({ $isActive }) => ($isActive ? colors.white.default : colors.black.light2)};
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    border-color: ${colors.black.light2};
  }
`;

const ResourceDropdownWrapper = styled.div`
  margin-top: 14px;
`;

const ParentWorkOrderButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #c9d2dc;
  background: #ffffff;
  padding: 14px 16px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    background: #f5f7fa;
  }
`;

const ParentWorkOrderButtonText = styled.span`
  font-size: 14px;
  color: #1f2a37;
  text-align: left;
`;

const ParentWorkOrderButtonChevron = styled.span`
  color: #6f7782;
  font-size: 18px;
  line-height: 1;
`;

const ClearParentLink = styled.button`
  margin-top: 8px;
  border: none;
  background: transparent;
  color: #6f7782;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
`;

const DetailsAttachLabel = styled.label<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 1px dashed #c9d2dc;
  padding: 20px 16px;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};

  &:hover {
    border-color: #1f2a37;
  }
`;

const DetailsAttachText = styled.span`
  font-size: 13px;
  font-weight: 300;
  color: #6f7782;
`;

const DetailsAttachButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  background: #1f2a37;
  color: #ffffff;
  border: 1px solid #1f2a37;
`;

const BillingNoticeBox = styled.div`
  border: 1px solid ${colors.grey.light12};
  background: #f8fafc;
  color: ${colors.grey.default};
  padding: 14px 16px;
  font-size: 12px;
`;

const BillingDisplayBox = styled.div`
  border: 1px solid ${colors.grey.light12};
  background: #f8fafc;
  padding: 16px;
`;

const BillingAmountText = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: ${colors.black.light2};
`;

const BillingDetailsMeta = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: ${colors.grey.default};
`;

const LinkedPoButton = styled.button`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${colors.black.light2};
  border: none;
  background: transparent;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
`;

// const KSelectStyled = styled.select`
//   width: 100%;
//   padding: 8px 12px;
//   font-size: 13px;
//   border: 1px solid ${colors.grey.light12};
//   background: ${colors.white.default};
//   color: ${colors.black.light2};
//   outline: none;
//   cursor: pointer;

//   &:focus {
//     border-color: ${colors.grey.dark};
//   }
// `;

const KInputStyled = styled.input`
  width: 100%;
  padding: 6px 10px;
  font-size: 13px;
  border: 1px solid ${colors.grey.light12};
  color: ${colors.black.light2};
  outline: none;

  &:focus {
    border-color: ${colors.grey.dark};
  }
`;

const BillingInput = styled.input`
  width: 100%;
  border: 1px solid ${colors.grey.light12};
  background: ${colors.white.default};
  color: ${colors.black.light2};
  font-size: 13px;
  padding: 10px 12px;
  outline: none;

  &:focus {
    border-color: ${colors.black.light2};
  }
`;

// const CheckboxLabel = styled.label`
//   display: flex;
//   align-items: flex-start;
//   gap: 10px;
//   cursor: pointer;
// `;

// const CheckboxMain = styled.span`
//   font-size: 12px;
//   font-weight: 700;
//   color: ${colors.black.light2};
//   display: block;
// `;

const CheckboxSub = styled.span`
  font-size: 11px;
  font-weight: 300;
  color: ${colors.grey.default};
  display: block;
  margin-top: 2px;
`;

const GenerateQuoteButton = styled.button`
  border: 1px solid ${colors.black.light2};
  background: ${colors.black.light2};
  color: ${colors.white.default};
  font-size: 12px;
  font-weight: 700;
  padding: 10px 14px;
  cursor: pointer;

  &:disabled {
    background: ${colors.grey.light12};
    border-color: ${colors.grey.light12};
    cursor: not-allowed;
  }
`;

const QuoteModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const QuoteModalCard = styled.div`
  width: min(1100px, 100%);
  max-height: 92vh;
  overflow: auto;
  background: ${colors.white.default};
  border: 1px solid ${colors.grey.light12};
`;

const QuoteModalHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
  background: ${colors.white.default};
  border-bottom: 1px solid ${colors.grey.light12};
  padding: 14px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h3 {
    margin: 0;
    font-size: 18px;
    color: ${colors.black.light2};
  }
`;

const QuoteModalCloseButton = styled.button`
  border: 1px solid ${colors.grey.light12};
  background: ${colors.white.default};
  color: ${colors.black.light2};
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 8px 12px;
  cursor: pointer;
`;

const QuoteModalBody = styled.div`
  padding: 16px;
`;

const AttachmentModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10002;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const AttachmentModalCard = styled.div`
  width: min(760px, 100%);
  max-height: 92vh;
  overflow: auto;
  background: ${colors.white.default};
  border: 1px solid ${colors.grey.light12};
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
`;

const AttachmentModalHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
  background: ${colors.white.default};
  border-bottom: 1px solid ${colors.grey.light12};
  padding: 14px 18px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  h3 {
    margin: 0;
    font-size: 18px;
    color: ${colors.black.light2};
  }
`;

const AttachmentModalSubTitle = styled.p`
  margin: 6px 0 0;
  font-size: 12px;
  color: ${colors.grey.default};
  line-height: 1.5;
`;

const AttachmentModalCloseButton = styled.button`
  border: 1px solid ${colors.grey.light12};
  background: ${colors.white.default};
  color: ${colors.black.light2};
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 8px 12px;
  cursor: pointer;
`;

const AttachmentModalBody = styled.div`
  padding: 16px 18px 20px;
`;

const AttachmentDropZone = styled.div`
  border: 1px dashed ${colors.grey.light12};
  background: #fafafa;
  padding: 18px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

const AttachmentDropZoneTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: ${colors.black.light2};
`;

const AttachmentDropZoneText = styled.div`
  font-size: 12px;
  color: ${colors.grey.default};
  line-height: 1.5;
`;

const AttachmentBrowseButton = styled.button`
  border: 1px solid ${colors.black.light2};
  background: ${colors.black.light2};
  color: ${colors.white.default};
  padding: 10px 14px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  cursor: pointer;
`;

const AttachmentSelectedHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 18px 0 10px;
  font-size: 12px;
  font-weight: 700;
  color: ${colors.black.light2};
  text-transform: uppercase;
  letter-spacing: 0.08em;
`;

const AttachmentSelectedList = styled.div`
  display: grid;
  gap: 8px;
`;

const AttachmentSelectedItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid ${colors.grey.light12};
  background: ${colors.white.default};
  padding: 12px 14px;
`;

const AttachmentSelectedFileName = styled.div`
  font-size: 13px;
  color: ${colors.black.light2};
  word-break: break-word;
`;

const AttachmentSelectedFileMeta = styled.div`
  font-size: 11px;
  color: ${colors.grey.default};
  white-space: nowrap;
`;

const AttachmentSelectedEmpty = styled.div`
  border: 1px dashed ${colors.grey.light12};
  padding: 12px 14px;
  font-size: 12px;
  color: ${colors.grey.default};
  background: #fafafa;
`;

const AttachmentModalFooter = styled.div`
  padding: 0 18px 18px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

const AttachmentModalCancelButton = styled.button`
  border: 1px solid ${colors.grey.light12};
  background: ${colors.white.default};
  color: ${colors.black.light2};
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  cursor: pointer;
`;

const AttachmentModalActionButton = styled.button`
  border: 1px solid ${colors.black.light2};
  background: ${colors.black.light2};
  color: ${colors.white.default};
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  cursor: pointer;

  &:disabled {
    background: ${colors.grey.light12};
    border-color: ${colors.grey.light12};
    cursor: not-allowed;
  }
`;

const AttachmentPreviewOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 10003;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const AttachmentPreviewCard = styled.div`
  width: min(1100px, 100%);
  height: min(90vh, 900px);
  display: flex;
  flex-direction: column;
  background: ${colors.white.default};
  border: 1px solid ${colors.grey.light12};
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
`;

const AttachmentPreviewHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 18px;
  border-bottom: 1px solid ${colors.grey.light12};

  h3 {
    margin: 0;
    font-size: 18px;
    color: ${colors.black.light2};
    word-break: break-word;
  }
`;

const AttachmentPreviewSubTitle = styled.p`
  margin: 6px 0 0;
  font-size: 12px;
  color: ${colors.grey.default};
`;

const AttachmentPreviewCloseButton = styled.button`
  border: 1px solid ${colors.grey.light12};
  background: ${colors.white.default};
  color: ${colors.black.light2};
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 8px 12px;
  cursor: pointer;
`;

const AttachmentPreviewBody = styled.div`
  flex: 1;
  min-height: 0;
  background: #f7f8fa;
  position: relative;
`;

const AttachmentPreviewFrame = styled.iframe<{ $isVisible?: boolean }>`
  width: 100%;
  height: 100%;
  border: 0;
  background: ${colors.white.default};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

const AttachmentPreviewImage = styled.img<{ $isVisible?: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  background: ${colors.white.default};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

const attachmentPreviewSpin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const AttachmentPreviewLoaderOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(247, 248, 250, 0.9);
  z-index: 2;
`;

const AttachmentPreviewSpinner = styled.div`
  width: 30px;
  height: 30px;
  border: 3px solid ${colors.grey.light12};
  border-top-color: ${colors.black.light2};
  border-radius: 50%;
  animation: ${attachmentPreviewSpin} 0.8s linear infinite;
`;

const AttachmentPreviewLoaderText = styled.div`
  font-size: 12px;
  color: ${colors.grey.default};
`;

// Critical gate
// const CriticalGate = styled.div<{ $satisfied: boolean }>`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 16px;
//   padding: 16px 20px;
//   border: 1px solid ${({ $satisfied }) => ($satisfied ? colors.grey.light12 : colors.black.light2)};
//   background: ${({ $satisfied }) => ($satisfied ? "#f4f4f4" : colors.black.light2)};
//   color: ${({ $satisfied }) => ($satisfied ? colors.black.light2 : colors.white.default)};
// `;

// const CriticalGateTitle = styled.div`
//   font-size: 13px;
//   font-weight: 700;
// `;

// const CriticalGateSub = styled.div`
//   font-size: 11px;
//   font-weight: 300;
//   margin-top: 4px;
//   opacity: 0.9;
// `;

// const CriticalGateButton = styled.button`
//   font-size: 11px;
//   font-weight: 700;
//   text-transform: uppercase;
//   letter-spacing: 0.1em;
//   padding: 8px 14px;
//   background: transparent;
//   border: 1px solid ${colors.white.default};
//   color: ${colors.white.default};
//   cursor: pointer;
//   white-space: nowrap;
//   &:hover {
//     opacity: 0.8;
//   }
// `;

// // Completion notes
// const CompletionNotesPanel = styled.div`
//   border: 1px solid ${colors.grey.light12};
//   border-left: 4px solid ${colors.black.light2};
//   padding: 20px;
//   background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
// `;

// const CompletionNotesHeader = styled.div`
//   display: flex;
//   align-items: flex-start;
//   justify-content: space-between;
//   gap: 12px;
// `;

// const CompletionNotesTitle = styled.h3`
//   margin: 0;
//   font-size: 16px;
//   font-weight: 700;
//   color: ${colors.black.light2};
// `;

// const CompletionNotesSaved = styled.span`
//   font-size: 10px;
//   font-weight: 300;
//   color: ${colors.grey.default};
// `;

// const CompletionNotesSub = styled.p`
//   font-size: 12px;
//   font-weight: 300;
//   color: ${colors.grey.default};
//   margin: 6px 0 0;
// `;

// const CompletionNotesField = styled(KTextareaStyled)`
//   min-height: 120px;
//   background: ${colors.white.default};
// `;

// const CompletionNotesActions = styled.div`
//   margin-top: 10px;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 16px;

//   @media (max-width: 900px) {
//     flex-direction: column;
//     align-items: flex-start;
//   }
// `;

// const CompletionNotesHint = styled.p`
//   margin: 0;
//   font-size: 11px;
//   font-weight: 300;
//   color: ${colors.grey.default};
// `;

// const DispatchPanel = styled.div`
//   border: 1px solid ${colors.grey.light12};
//   border-left: 4px solid ${colors.green.default};
//   padding: 20px;
//   background: #f9fdf8;
// `;

// const DispatchPanelHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 16px;

//   @media (max-width: 900px) {
//     flex-direction: column;
//     align-items: flex-start;
//   }
// `;

// const DispatchTitle = styled.h3`
//   margin: 0;
//   font-size: 16px;
//   font-weight: 700;
//   color: ${colors.black.light2};
// `;

// const DispatchSubTitle = styled.p`
//   margin: 6px 0 0;
//   font-size: 12px;
//   font-weight: 300;
//   color: ${colors.grey.default};
// `;

// const DispatchHint = styled.p`
//   margin: 14px 0 0;
//   font-size: 12px;
//   color: ${colors.grey.dark};
// `;

// Sidebar
const ControlGroup = styled.div`
  margin-bottom: 2px;
`;

const ControlLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  color: ${colors.black.light2};
  margin-bottom: 4px;
`;

const statusPulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.55);
    opacity: 0;
  }
`;

const StatusSpotlight = styled.div<{ $tone: StatusHighlightTone }>`
  border: 1px solid
    ${({ $tone }) => {
      if ($tone === "success") return colors.green.default;
      if ($tone === "danger") return colors.red.default;
      if ($tone === "warning") return colors.orange.default;
      if ($tone === "active") return colors.blue.default;
      return colors.grey.light12;
    }};
  background: ${({ $tone }) => {
    if ($tone === "success") return "#f3fbef";
    if ($tone === "danger") return "#fff3f1";
    if ($tone === "warning") return "#fff6eb";
    if ($tone === "active") return "#eef6ff";
    return colors.white.default;
  }};
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin-bottom: 10px;
`;

const StatusBeacon = styled.span<{ $tone: StatusHighlightTone }>`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
  background: ${({ $tone }) => {
    if ($tone === "success") return colors.green.default;
    if ($tone === "danger") return colors.red.default;
    if ($tone === "warning") return colors.orange.default;
    if ($tone === "active") return colors.blue.default;
    return colors.grey.default;
  }};

  &::after {
    content: "";
    position: absolute;
    inset: -4px;
    border-radius: 50%;
    border: 1px solid currentColor;
    color: inherit;
    animation: ${statusPulse} 1.6s ease-out infinite;
  }
`;

const StatusContent = styled.div`
  min-width: 0;
`;

const StatusTitle = styled.div`
  font-size: 13px;
  line-height: 1.2;
  font-weight: 700;
  color: ${colors.black.light2};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

const StatusCode = styled.div`
  margin-top: 2px;
  font-size: 11px;
  color: ${colors.grey.dark3};
  letter-spacing: 0.03em;
`;

// const StatusStepperTrack = styled.div`
//   display: flex;
//   align-items: flex-start;
//   overflow-x: auto;
//   padding-bottom: 2px;
//   max-width: 100%;
//   scrollbar-width: thin;
// `;

// const StatusStepperItem = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   flex-shrink: 0;
//   width: 80px;
// `;

// const StatusStepperNodeRow = styled.div`
//   display: flex;
//   align-items: center;
//   width: 100%;
// `;

// const StatusStepperDot = styled.span<{ $active?: boolean }>`
//   width: 12px;
//   height: 12px;
//   border: 1px solid ${colors.black.light2};
//   background: ${({ $active }) => ($active ? colors.black.light2 : colors.white.default)};
//   flex-shrink: 0;
// `;

// const StatusStepperLine = styled.span<{ $active?: boolean }>`
//   width: 34px;
//   height: 1px;
//   background: ${({ $active }) => ($active ? colors.black.light2 : colors.grey.light12)};
//   margin: 0 3px;
// `;

// const StatusStepperLabel = styled.span<{ $active?: boolean }>`
//   margin-top: 8px;
//   font-size: 10px;
//   color: ${({ $active }) => ($active ? colors.black.light2 : colors.grey.default)};
//   font-weight: ${({ $active }) => ($active ? 700 : 400)};
//   display: -webkit-box;
//   -webkit-line-clamp: 2;
//   -webkit-box-orient: vertical;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   line-height: 1.2;
//   max-width: 80px;
//   min-height: 24px;
// `;

const StatusTransitionInline = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const StatusApplyButton = styled.button`
  border: 1px solid ${colors.black.light2};
  background: ${colors.black.light2};
  color: ${colors.white.default};
  padding: 10px 12px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  white-space: nowrap;
  cursor: pointer;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

const StatusTransitionHint = styled.div`
  font-size: 11px;
  color: ${colors.grey.default};
`;

// const ControlHelper = styled.div`
//   font-size: 10px;
//   font-weight: 300;
//   color: ${colors.grey.default};
//   margin-top: 4px;
// `;

// const SidebarDivider = styled.hr`
//   border: none;
//   border-top: 1px solid ${colors.grey.light12};
//   margin: 16px 0;
// `;

// const IdTagBox = styled.div`
//   display: inline-block;
//   font-size: 11px;
//   font-weight: 700;
//   font-family: monospace;
//   letter-spacing: 0.06em;
//   padding: 4px 10px;
//   background: #f0f0f0;
//   border: 1px solid ${colors.grey.light12};
//   color: ${colors.black.light2};
// `;

// const ParentWorkOrderCard = styled.button`
//   width: 100%;
//   border: 1px solid ${colors.grey.light12};
//   background: #fafbfd;
//   padding: 12px 16px;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 12px;
//   cursor: pointer;
//   text-align: left;

//   &:hover {
//     background: #f3f7fb;
//     border-color: ${colors.grey.light4};
//   }
// `;

// const ParentWorkOrderCardContent = styled.div`
//   min-width: 0;
//   display: flex;
//   flex-direction: column;
//   gap: 6px;
// `;

// const ParentWorkOrderTopRow = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   min-width: 0;
// `;

// const ParentWorkOrderBadge = styled.span`
//   font-size: 10px;
//   font-weight: 700;
//   letter-spacing: 0.08em;
//   text-transform: uppercase;
//   color: ${colors.black.light2};
//   background: ${colors.white.default};
//   border: 1px solid ${colors.grey.light12};
//   padding: 4px 8px;
//   white-space: nowrap;
// `;

// const ParentWorkOrderCardText = styled.span`
//   font-size: 13px;
//   font-weight: 600;
//   color: ${colors.black.light2};
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
// `;

// const ParentWorkOrderMeta = styled.span`
//   font-size: 11px;
//   font-weight: 300;
//   color: ${colors.grey.default};
// `;

// const ParentWorkOrderCardChevron = styled.span`
//   font-size: 18px;
//   color: ${colors.grey.default};
// `;

// ─── Preserved originals ──────────────────────────────────────────────────────

export const PhotoInput = styled.div<MobileProps>`
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 40px;
  width: 100%;
  border-bottom: 1px solid ${colors.grey.light12};
  border-top: 1px solid ${colors.grey.light12};
  padding: 30px 0;

  label {
    font-weight: 600;
    font-size: 14px;
    flex: 0 0 195px;
    color: ${colors.black.light2};
    white-space: nowrap;
    margin-right: 20px;
    display: flex;
    align-items: baseline;

    span {
      display: block;
      font-size: 14px;
      font-weight: 400;
      padding-left: 5px;
    }

    ${(props) => props.$isMobile && `width: 100px;`}
  }
`;

// const Details = styled.div`
//   padding: 30px 0;
// `;

const ErrorMessage = styled.p`
  color: ${colors.red.default};
  font-size: 14px;
  text-align: center;
`;

const SuccessMessage = styled.p`
  color: ${colors.green.default};
  font-size: 14px;
  text-align: center;
`;

interface InputRowProps extends MobileProps {
  $marginBottom?: string;
  isSelectSearch?: boolean;
  ismanager?: number;
}

export const InputRow = styled.div<InputRowProps>`
  display: flex;
  align-items: center;
  margin-bottom: ${({ $marginBottom }) => `${$marginBottom === undefined ? "40" : $marginBottom}px`};
  max-width: ${({ ismanager }) => (ismanager ? "unset" : "600px")};
  width: 100%;
  position: relative;
  margin-right: 40px;

  & div {
    width: ${({ ismanager }) => ismanager && "100%"};
  }
  ${(props) =>
    props.$topLabel &&
    css`
      align-items: flex-start;
    `}

  div {
    ${(props) =>
      props.$isMobile &&
      css`
        font-size: 14px;
      `}
    p {
      font-size: 14px;
      margin-top: 8px;
      color: ${colors.grey.dark};
      max-width: 400px;
    }
  }

  label {
    font-size: 14px;
    font-weight: 600;
    width: 200px;
    color: ${colors.black.light2};
    white-space: nowrap;
    flex: 0 0 200px;
    margin-right: 20px;
  }

  input {
    width: ${({ ismanager }) => (ismanager ? "100%" : "360px")};
    ${(props) =>
      !props.isSelectSearch &&
      css`
        padding: 0px 7px;
      `}
    ${(props) =>
      props.$isMobile &&
      css`
        width: 200px;
      `}
  }

  a {
    font-weight: 500;
    color: ${colors.grey.dark};
  }
`;

export const RawValue = styled.p<{ color?: string }>`
  border-bottom: 1px solid ${colors.grey.light4};
  width: 100%;
  font-size: 14px;
  padding-bottom: 4px;
  color: ${({ color }) => (color ? color : colors.grey.dark)};
`;

export const InputsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  .tooltip {
    max-width: 70%;
  }
`;

// const HintIcon = styled(FontAwesomeIcon)`
//   color: ${colors.grey.dark};
//   height: 20px;
//   width: 20px;
//   position: absolute;
//   right: -25px;
//   @media (max-width: 480px) {
//     right: -5%;
//   }
// `;

// const InputsContainer = styled.div<MobileProps>`
//   display: flex;
//   flex-direction: column;

//   ${(props) =>
//     props.$isMobile &&
//     css`
//       ${InputRow} {
//         margin-bottom: 20px;
//       }
//       label {
//         width: 100px;
//       }
//       input {
//         width: 100%;
//       }
//       ${SelectBoxContainer} {
//         height: 25px;
//       }
//     `}
// `;

export const DescriptionContainer = styled.div<MobileProps>`
  display: flex;
  flex-direction: ${({ $isComments }: any) => ($isComments ? "column" : "row")};
  margin-bottom: 20px;
  width: 100%;

  .ql-toolbar.ql-snow {
    display: none;
    border: none;
  }
  .ql-container.ql-snow {
    border: none;
  }
  .ql-editor {
    border: 1px solid ${colors.grey.light13};
    padding: 10px;
  }

  label {
    font-size: 14px;
    font-weight: 600;
    flex: 0 0 200px;
    margin-right: 20px;
    color: ${colors.black.light2};
    margin-bottom: ${({ $isComments }: any) => ($isComments ? "10px" : "0px")};
    ${(props) =>
      props.$isMobile &&
      css`
        font-size: 12px;
      `}
  }
`;

// const AttachmentRow = styled.div`
//   ${InputRow} {
//     align-items: flex-start;
//   }
// `;

const ChildWorkRequestRow = styled.div`
  margin-bottom: 8px;
`;
